/* EZ Personalize — interaction helpers (S7o, 2026-10-11). Reads Teeinblue markup; the only value it changes is text typed into crossword name fields (letters A–Z only, see §14). */
/* 59. Ban-67 — choosing a style / colour / size is no longer a new page for Facebook.
       Teeinblue and the theme write the chosen variant into the address (?variant=…). Facebook Pixel watches the
       address and sent every change as a new "PageView" for each of the store's 3 pixels, each one built as a hidden
       ~100-field form posted through a hidden frame: 3 forms per click, 50–60 ms of work at once and more as the page
       was used, and Windows shows the busy cursor while the frames load (measured on TEST 5 with real clicks, 17/10:
       after 40 choices 61–229 ms per click → 0 ms, 3 forms → 0). The same happened each time the Size guide opened
       (it adds a history step with the same address so the Back button closes it: 3 forms). An address change that
       only swaps ?variant=, or a history step that keeps the same address, now goes straight to the browser; every
       other address change goes through all scripts as before. ViewContent, AddToCart and Purchase are not touched.
       Our own scripts hear of it through the "ez:variant-url" event.
       Works whichever loads first: a script that wraps history.pushState / replaceState after this one is kept in
       the chain for every other address change. */
(function () {
  "use strict";
  var H = window.History && window.History.prototype;
  if (!H || !window.URL || !Object.defineProperty || !Object.getOwnPropertyDescriptor) return;
  function samePage(url) {
    if (url === undefined || url === null) return true;   // a history step without a new address
    try {
      var a = new URL(String(url), location.href), b = new URL(location.href);
      if (a.href === b.href) return true;
      a.searchParams.delete("variant");
      b.searchParams.delete("variant");
      return a.href === b.href;
    } catch (e) { return false; }
  }
  ["replaceState", "pushState"].forEach(function (k) {
    var nat = H[k];
    if (typeof nat !== "function") return;
    var d = Object.getOwnPropertyDescriptor(history, k);
    if (d && !d.configurable) return;
    var stack = [typeof history[k] === "function" ? history[k] : nat], depth = 0;
    function ours(state, title, url) {
      if (!depth && samePage(url)) {
        var r = nat.apply(history, arguments);
        try { window.dispatchEvent(new Event("ez:variant-url")); } catch (e) {}
        return r;
      }
      var f = stack[stack.length - 1 - depth] || nat;      // wrappers added later call us again: go one level down
      depth++;
      try { return f.apply(history, arguments); } finally { depth--; }
    }
    try {
      Object.defineProperty(history, k, {
        configurable: true,
        enumerable: true,
        get: function () { return ours; },
        set: function (f) { if (typeof f === "function" && f !== ours) stack.push(f); }
      });
    } catch (e) {}
  });
})();

(function () {
  "use strict";
  var FORM = "#tee-artwork-form";
  /* Ban-116 (anh 21/10 11:16: popup "Edit design" của ngăn giỏ phải là đúng form trang SP): Teeinblue dựng form thứ 2
     (cùng id #tee-artwork-form) trong popup Edit. Phần làm đẹp FORM (ô ảnh, dropdown, trạng thái, ô bắt buộc…) chạy cho
     MỌI form; phần của TRANG SP (thanh dính, giá, Welcome back, cam kết dưới Add to Cart…) chỉ dùng form của trang. */
  function eachForm(fn) { Array.prototype.forEach.call(document.querySelectorAll(FORM), fn); }
  function pageForm() {
    var l = document.querySelectorAll(FORM);
    for (var i = 0; i < l.length; i++) if (!l[i].closest(".tee-dialog")) return l[i];
    return null;
  }

  /* 1. Character limit feedback.
     Browsers silently drop characters beyond maxlength (typing or pasting), so a long name is cut
     without warning. We show a hint at the limit and a clear warning when text was cut. */
  function hintFor(field) {
    var hint = field.querySelector(".ezp-limit-hint");
    if (!hint) {
      hint = document.createElement("span");
      hint.className = "ezp-limit-hint";
      hint.setAttribute("aria-live", "polite");
      var box = field.querySelector(".tee-field__input");
      if (box && box.parentNode) box.parentNode.insertBefore(hint, box.nextSibling);
      else field.appendChild(hint);
    }
    return hint;
  }
  function update(input, wasCut) {
    var max = parseInt(input.getAttribute("maxlength"), 10);
    var field = input.closest(".tee-field");
    if (!max || !field) return;
    var atLimit = input.value.length >= max;
    field.classList.toggle("ezp-at-limit", atLimit);
    field.classList.toggle("ezp-cut", !!wasCut);
    if (wasCut) {
      hintFor(field).textContent = "Only " + max + " characters fit. Your text was shortened to “" + input.value + "”.";
    } else if (atLimit) {
      hintFor(field).textContent = "Maximum " + max + " characters reached.";
    } else {
      var h = field.querySelector(".ezp-limit-hint");
      if (h) h.textContent = "";
    }
  }
  document.addEventListener("beforeinput", function (e) {
    var t = e.target;
    if (!t.matches || !t.matches(FORM + " input.tee__input[maxlength], " + FORM + " textarea.tee__paragraph[maxlength]")) return;
    var max = parseInt(t.getAttribute("maxlength"), 10);
    var data = e.data || (e.dataTransfer && e.dataTransfer.getData("text")) || "";
    var selected = (t.selectionEnd || 0) - (t.selectionStart || 0);
    t._ezpCut = !!data && t.value.length - selected + data.length > max;
  }, true);
  document.addEventListener("paste", function (e) {
    var t = e.target;
    if (!t.matches || !t.matches(FORM + " input.tee__input[maxlength], " + FORM + " textarea.tee__paragraph[maxlength]")) return;
    var max = parseInt(t.getAttribute("maxlength"), 10);
    var text = (e.clipboardData && e.clipboardData.getData("text")) || "";
    var selected = (t.selectionEnd || 0) - (t.selectionStart || 0);
    t._ezpCut = t.value.length - selected + text.length > max;
  }, true);
  document.addEventListener("input", function (e) {
    var t = e.target;
    if (!t.matches || !t.matches(FORM + " input.tee__input[maxlength], " + FORM + " textarea.tee__paragraph[maxlength]")) return;
    update(t, t._ezpCut);
    t._ezpCut = false;
  }, true);

  /* 2. After "Preview" with missing answers, bring the first invalid field into view
     below the sticky live preview (Teeinblue's own scroll can land behind it). */
  function stickyOffset() {
    var header = document.querySelector(".header-wrapper");
    var hh = header && getComputedStyle(header).position !== "static" ? header.offsetHeight : 0;
    var g = window.ezpGallery;                       // floating "Live preview" card (tee-sticky-gallery.js)
    var h = g && g.willShow() ? g.cardBottom() : 0;
    return Math.max(h, hh) + 16;
  }
  /* S7k: one smooth scroll that re-aims at the field on every frame (the floating preview card and
     lazy images can move it while scrolling), so it never overshoots and comes back. */
  var scrollAnim = 0;
  ["touchstart", "wheel"].forEach(function (t) {
    window.addEventListener(t, function () {
      if (!scrollAnim) return;
      cancelAnimationFrame(scrollAnim);
      scrollAnim = 0;
      document.documentElement.style.overflowAnchor = "";
    }, { passive: true });
  });
  function scrollToField(f, done, offset) {   // offset: optional function → px kept free at the top (default stickyOffset)
    cancelAnimationFrame(scrollAnim);
    var root = document.documentElement;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var off = offset || stickyOffset;
    var target = function () { return Math.max(0, Math.round(f.getBoundingClientRect().top + window.pageYOffset - off())); };
    var y0 = window.pageYOffset, t0 = performance.now();
    var dur = reduce ? 0 : Math.min(650, Math.max(320, Math.abs(target() - y0) * 0.3));
    root.style.overflowAnchor = "none";              // stop the browser from shifting the page under us
    var step = function (now) {
      var p = dur ? Math.min(1, (now - t0) / dur) : 1;
      var e = 1 - Math.pow(1 - p, 3);
      window.scrollTo({ top: y0 + (target() - y0) * e, behavior: "instant" });
      if (p < 1) { scrollAnim = requestAnimationFrame(step); return; }
      scrollAnim = 0;
      root.style.overflowAnchor = "";
      if (done) done();
    };
    scrollAnim = requestAnimationFrame(step);
  }
  window.addEventListener("touchstart", function () { cancelAnimationFrame(scrollAnim); document.documentElement.style.overflowAnchor = ""; }, { passive: true });
  window.addEventListener("wheel", function () { cancelAnimationFrame(scrollAnim); document.documentElement.style.overflowAnchor = ""; }, { passive: true });
  function revealFirstError() {
    var fields = Array.prototype.filter.call(
      document.querySelectorAll(FORM + " .tee-field--invalid"),
      function (f) { return f.offsetHeight > 0; }
    );
    if (!fields.length) return false;
    var f = fields[0];
    /* Ban-86: a photo in a grid: bring the grid heading into view, so its "Add N more photos" line shows */
    var aim = f.classList.contains("ezp-pg") && f._ezpHead && f._ezpHead.isConnected ? f._ezpHead : f;
    scrollToField(aim, function () {
      queueSticky();
      /* the keyboard is not opened by itself on phones (it would cover the field and hide the bar) */
      var input = f.querySelector("input.tee__input");
      if (input && window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
        try { input.focus({ preventScroll: true }); } catch (err) {}
      }
    });
    f.classList.remove("ezp-flash");
    void f.offsetWidth;
    f.classList.add("ezp-flash");
    return true;
  }
  var revealTimer = 0;
  function scheduleReveal() {
    clearTimeout(revealTimer);
    // Teeinblue validates asynchronously: check twice so a slow validation is still caught
    revealTimer = setTimeout(function () {
      if (!revealFirstError()) revealTimer = setTimeout(revealFirstError, 450);
    }, 250);
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest(".tee-btn--preview, .tee-btn--atc, .customily-preview-button, .tee-btn--personalize");
    if (!btn || btn.closest(".vm--container")) return;
    scheduleReveal();
  }, true);   // capture: Teeinblue stops the click from bubbling, so a normal listener never runs
  /* 3. Floating "Preview" button (phones): visible only while the form's own Preview button is off screen
        and the customer has reached the form; hidden while typing (keyboard open) or while the
        Teeinblue preview popup is open. One rAF-throttled check, so it never flickers. */
  var raf = 0;
  function isTyping() {
    var a = document.activeElement;
    return !!(a && a.closest && a.closest(FORM) && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && a.type !== "radio" && a.type !== "checkbox");
  }
  function modalOpen() {
    if (document.body.classList.contains("ezp-ai-open")) return true;
    /* Ban-29: "Photo tips" no longer counts. It is a sheet over its own dark backdrop (like "Estimated delivery"),
       so the bar can stay where it is underneath; hiding it on open and sliding it back on close made the bar,
       My cart and the back-to-top arrow jump each time the tips were closed. */
    var m = document.querySelector(".vm--container.tee-dialog");
    return !!(m && m.offsetHeight > 0);
  }
  function updateSticky() {
    raf = 0;
    /* Ban-67: no floating bar on computers, so nothing is measured there (this ran 0.4 s after every click) */
    if (window.innerWidth >= 990) { document.body.classList.remove("ezp-sticky-on"); return; }
    var form = pageForm();
    var btn = form && form.querySelector(".tee-btn--preview");
    var show = false;
    if (btn && btn.offsetHeight > 0 && window.innerWidth < 990) {
      var vh = window.innerHeight;
      var r = btn.getBoundingClientRect();
      var topLimit = document.body.classList.contains("gallery--sticky") ? stickyOffset() - 16 : 0;
      var btnOnScreen = r.top < vh - 24 && r.bottom > topLimit + 8;
      var reachedForm = form.getBoundingClientRect().top < vh * 0.8;
      show = !btnOnScreen && reachedForm && !isTyping() && !modalOpen();
    }
    document.body.classList.toggle("ezp-sticky-on", show);
  }
  function queueSticky() { if (!raf) raf = requestAnimationFrame(updateSticky); }
  window.addEventListener("scroll", queueSticky, { passive: true });
  window.addEventListener("resize", queueSticky);
  document.addEventListener("focusin", queueSticky);
  document.addEventListener("focusout", function () { setTimeout(queueSticky, 60); });
  document.addEventListener("click", function () { setTimeout(queueSticky, 400); });
  var stickyTries = 0;
  var stickyTimer = setInterval(function () {
    queueSticky();
    var pf = pageForm();
    if ((pf && pf.querySelector(".tee-btn--preview")) || ++stickyTries > 40) clearInterval(stickyTimer);
  }, 250);

  /* 4. Popups: tap outside / Esc closes the preview popup.
        The photo-placement popup is left alone (an accidental outside tap must not lose the crop). */
  function openDialog() {
    /* Ban-115: not the cart "Edit design" popup (ez-cart-drawer.js handles its outside tap / Esc and asks before
       throwing away changes; closing it from here skipped that question) */
    var d = document.querySelector(".vm--container.tee-dialog:not(.tee-dialog-image-placement):not(.tee-edit-popup)");
    return d && d.querySelector(".tee-dialog-close") ? d : null;
  }
  document.addEventListener("click", function (e) {
    var d = openDialog();
    if (!d || !d.contains(e.target)) return;
    if (e.target.closest(".vm--modal")) return;
    d.querySelector(".tee-dialog-close").click();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var d = openDialog();
    if (d) d.querySelector(".tee-dialog-close").click();
  });
  /* 5. Photo fields: "Photo tips" link on the first upload title + drag & drop on desktop. */
  function decoratePhotos() { eachForm(decoratePhotosIn); }
  function decoratePhotosIn(form) {
    var guide = document.querySelector(".upload_image_guidelines");
    var first = form.querySelector(".tee-field--photo .tee-field__header");
    if (guide && first && !form.querySelector(".ezp-photo-tips")) {
      var t = document.createElement("button");
      t.type = "button";
      t.className = "ezp-photo-tips";
      t.textContent = "Photo tips";
      t.addEventListener("click", function () { guide.click(); });
      first.appendChild(t);
      first.classList.add("ezp-has-tips");
    }
  }
  function photoBox(e) { return e.target && e.target.closest && e.target.closest(FORM + " .tee-field--photo .tee-photo"); }
  ["dragenter", "dragover"].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var box = photoBox(e);
      if (!box || !e.dataTransfer || Array.prototype.indexOf.call(e.dataTransfer.types || [], "Files") < 0) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
      box.classList.add("ezp-drag");
    });
  });
  document.addEventListener("dragleave", function (e) {
    var box = photoBox(e);
    if (box && !box.contains(e.relatedTarget)) box.classList.remove("ezp-drag");
  });
  document.addEventListener("drop", function (e) {
    var box = photoBox(e);
    if (!box) return;
    box.classList.remove("ezp-drag");
    var files = e.dataTransfer && e.dataTransfer.files;
    var input = box.querySelector("input[type=file]");
    if (!files || !files.length || !input || !/^image\//.test(files[0].type)) return;
    e.preventDefault();
    try {
      var dt = new DataTransfer();
      dt.items.add(files[0]);
      input.files = dt.files;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    } catch (err) {}
  });

  /* 6. Required fields: once the customer has filled one, drop its warning (Teeinblue only re-checks on the next click). */
  function fieldFilled(f) {
    if (f.querySelector(".tee-clipart.active, .tee-photo-uploaded img, .tee-photo-uploading, .tee-song__list-item--selected, .tee-scrabble__words-item")) return true;
    var sel = f.querySelector("select.tee-field__select");
    if (sel && sel.value !== "") return true;
    var txt = f.querySelector("input.tee__input, textarea.tee__paragraph");
    return !!(txt && txt.type !== "file" && txt.value.trim() !== "" && !f.classList.contains("tee-field--qr_song"));
  }
  function refreshValidity() { eachForm(refreshValidityIn); }
  function refreshValidityIn(form) {
    var open = 0;
    Array.prototype.forEach.call(form.querySelectorAll(".tee-field--invalid"), function (f) {
      var ok = fieldFilled(f);
      f.classList.toggle("ezp-ok", ok);
      if (!ok && f.offsetHeight > 0) open++;
    });
    Array.prototype.forEach.call(form.querySelectorAll(".ezp-ok:not(.tee-field--invalid)"), function (f) { f.classList.remove("ezp-ok"); });
    form.classList.toggle("ezp-all-ok", open === 0);
    pgCount();   // Ban-86
    /* Ban-51: Teeinblue's message box under the buttons (.tee-form-responses) stays in the page once it has shown
       "Some fields are required" — the message itself is hidden above, but the box kept its margins (15 + 10px)
       and the 10px gap of the buttons' row, so everything below stayed 35px lower after the form was completed.
       The empty box is now taken out too (CSS §55); a success message (.tee-success) is never hidden. */
    var resp = form.querySelector(".tee-form-responses");
    if (resp) resp.classList.toggle("ezp-resp-off", open === 0 && !resp.querySelector(".tee-success"));
    /* Ban-52: "Error: Some fields are required or invalid data" (two lines on phones) is shown as a short count that
       goes down while the customer fills the form: "Please complete 3 required fields". Only Teeinblue's
       "required" message is replaced (CSS §56 hides its text and shows data-ezp-msg); any other message stays as it is. */
    var msg = resp && resp.querySelector(".tee-error__message");
    if (msg) {
      var req = open > 0 && /required/i.test(msg.textContent);
      msg.setAttribute("data-ezp-msg", req ? "Please complete " + open + " required field" + (open > 1 ? "s" : "") : "");
      msg.classList.toggle("ezp-err-req", req);
    }
  }
  ["input", "change"].forEach(function (t) { document.addEventListener(t, function (e) { if (e.target.closest && e.target.closest(FORM)) setTimeout(refreshValidity, 0); }, true); });

  /* 7. Song search: the result list closes when the field loses focus (e.g. the phone keyboard is closed),
        and opens again when the customer taps back into the search box. */
  var songPointer = false;
  document.addEventListener("pointerdown", function (e) {
    songPointer = !!(e.target.closest && e.target.closest(FORM + " .tee-song__search-wrapper"));
    if (!songPointer) {
      var open = document.querySelector(FORM + " .tee-field--qr_song:not(.ezp-song-closed)");
      if (open && !open.contains(e.target)) open.classList.add("ezp-song-closed");
    }
  }, true);
  document.addEventListener("focusout", function (e) {
    var f = e.target.closest && e.target.closest(FORM + " .tee-field--qr_song");
    if (!f || !e.target.matches("input")) return;
    setTimeout(function () { if (!songPointer && !f.contains(document.activeElement)) f.classList.add("ezp-song-closed"); songPointer = false; }, 150);
  }, true);
  ["focusin", "input"].forEach(function (t) {
    document.addEventListener(t, function (e) {
      var f = e.target.closest && e.target.closest(FORM + " .tee-field--qr_song");
      if (f && e.target.matches("input")) f.classList.remove("ezp-song-closed");
    }, true);
  });
  /* Ban-161 (anh 25/10): on a phone, once the customer drags the song results more than 12px (scrolling the list, or
     the page with a finger on the list), the keyboard goes down — as in the site search (Ban-132). The list stays
     open: the touch began inside it, so songPointer is set and the focusout above does not close it. A tap on the
     box brings the keyboard back. */
  var songY0 = null;
  function songInput(a) { return a && a.matches && a.matches(FORM + " .tee-song-wrapper input") ? a : null; }
  document.addEventListener("touchstart", function (e) {
    songY0 = songInput(document.activeElement) && e.target.closest && e.target.closest(FORM + " .tee-song__search-wrapper") ? e.touches[0].clientY : null;
  }, { capture: true, passive: true });
  document.addEventListener("touchmove", function (e) {
    if (songY0 === null || Math.abs(e.touches[0].clientY - songY0) < 12) return;
    songY0 = null;
    var a = songInput(document.activeElement);
    if (a) a.blur();
  }, { capture: true, passive: true });
  /* Ban-162 (anh 25/10): after "Select" on a song, Teeinblue puts the cursor back in the search box (~45 ms later,
     measured), so on a phone the keyboard came up again over the form. That refocus is undone and the list closed. */
  var songPickAt = 0;
  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest(FORM + " .tee-song__search-wrapper .tee-song__list-item")) songPickAt = Date.now();
  }, true);
  document.addEventListener("focusin", function (e) {
    var a = songInput(e.target);
    if (!a || !songPickAt || Date.now() - songPickAt > 800) return;
    songPickAt = 0;
    setTimeout(function () {
      a.blur();
      var f = a.closest(".tee-field--qr_song");
      if (f) f.classList.add("ezp-song-closed");
    }, 0);
  }, true);

  /* Ban-162 (anh 25/10): phones — after typing in a box and tapping outside, the keyboard goes down and the floating
     "Live preview" card (tee-sticky-gallery.js) is back over the top of the screen, often right over the box just
     filled (while typing, iOS moves the page so the box sits just above the keyboard; typing also arms the card).
     Once the keyboard is down, a box left behind the card is brought back just below it — once, and never while a
     finger is on the screen or another box is being typed in. */
  var kbField = null, kbTimer = 0, kbTouch = false;
  window.addEventListener("touchstart", function () { kbTouch = true; }, { capture: true, passive: true });
  window.addEventListener("touchend", function () { kbTouch = false; }, { capture: true, passive: true });
  window.addEventListener("touchcancel", function () { kbTouch = false; }, { capture: true, passive: true });
  function keepFieldAboveCard() {
    clearTimeout(kbTimer);
    kbTimer = 0;
    var f = kbField;
    kbField = null;
    if (!f || !f.isConnected || window.innerWidth >= 990 || isTyping() || kbTouch) return;
    var g = window.ezpGallery;
    if (!g || !g.willShow() || !document.body.classList.contains("gallery--sticky")) return;
    var r = f.getBoundingClientRect(), line = g.cardBottom() + 12;
    if (r.top >= line || r.bottom <= 0) return;
    window.scrollBy({ top: Math.round(r.top - line), behavior: "smooth" });
  }
  document.addEventListener("focusout", function (e) {
    var t = e.target;
    if (window.innerWidth >= 990 || !t.matches || !t.matches(FORM + " input.tee__input, " + FORM + " textarea") || t.type === "file" || songInput(t)) return;
    kbField = t.closest(".tee-field") || t;
    clearTimeout(kbTimer);
    kbTimer = setTimeout(keepFieldAboveCard, 450);
  }, true);
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", function () {
      if (!kbField) return;
      clearTimeout(kbTimer);
      kbTimer = setTimeout(keepFieldAboveCard, 150);
    });
  }

  /* Ban-163 (anh 25/10): a guide to the form on a first look (phones / tablets < 990 px). Measured on 375 x 812: the
     "Personalized" card starts at 1159 px (1.4 screens down, 1.7 on an iPhone SE) and the first screen shows nothing
     that says the design can be changed. One guide, never two buttons at once:
       1. on the main photo: a white pill "Personalize this design" (bottom left, 40 px high), shown once the form is
          built — and kept there for good (Ban-164, anh 25/10 10:20), a quick way down to the form at any time;
       2. photo scrolled away while the form is still more than 200 px below the screen: the same guide as a bar at
          the bottom — the size and place of the "See my design" bar (50 px pill, 12 px from the bottom, 20 px sides,
          max 560 px), teal, one line. It goes once the form's top is within 200 px of the screen, so it is either up
          for at least 200 px of scrolling or not at all — never a blink (on the shirt above the photo goes at 449 px of
          scrolling while the form is near from 147 px on 812-high phones / 292 px on an iPhone SE: no bar there; it is
          for pages with a long block of options before the form);
       3. form within 80% of the screen, or the customer touches the form, or a design comes back: the bar part of the
          guide is over for this visit (the pill stays).
     While the guide is on (body.ezp-go-pre) the "See my design" bar stays down: it used to come up after only 40 px of
     scrolling (it follows the top of #tee-artwork-form, which starts at the price), and tapping it before anything
     was filled in only showed red "required" errors. From step 3 on it works as before.
     Tap: the page glides to the form card (title kept below where the live preview card will sit); the card glows
     teal once.
     No scroll listener: two IntersectionObservers; nothing is read from the layout while scrolling. */
  (function personalizeGuide() {
    if (window.innerWidth >= 990 || !("IntersectionObserver" in window) || !document.querySelector(".product__info-container")) return;
    var PEN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>';
    var DOWN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M6 13l6 6 6-6"/></svg>';
    var done = false, chip = null, bar = null, chipGone = false, formSeen = false, obs = [], tries = 0;
    function card() { var f = pageForm(); return f && f.querySelector(".tee-customize-main-form"); }
    function used() {
      return !!(window.ezpRestored || document.body.classList.contains("ezp-gal-armed") || document.querySelector(FORM + " .ezp-restore.is-open"));
    }
    function update() {
      var on = !done && chipGone && !formSeen;
      if (document.body.classList.contains("ezp-go-on") !== on) document.body.classList.toggle("ezp-go-on", on);
    }
    function finish() {
      if (done) return;
      done = true;
      obs.forEach(function (o) { o.disconnect(); });
      document.body.classList.remove("ezp-go-on", "ezp-go-pre");
    }
    function go(e) {
      e.preventDefault();
      e.stopPropagation();
      var c = card();
      finish();
      if (!c) return;
      /* Where the title lands. The live preview card (tee-sticky-gallery.js) is not up yet at this point: it comes with
         the customer's first choice (Teeinblue's own gallery only exists from then on) and then covers the top of the
         screen. So room for it is kept from the start, and the title does not move or hide when it appears: card ≈ 30%
         of the screen height + 8 px (its own sizing rule; 252 px measured on 375 x 812) or its real edge when it is
         already up, never less than the header; + 16 px. Without the card (landscape, computers) just under the header. */
      var free = function () {
        var g = window.ezpGallery, header = document.querySelector(".header-wrapper");
        var hh = header && getComputedStyle(header).position !== "static" ? header.offsetHeight : 0;
        var cardEdge = !g ? 0 : document.body.classList.contains("gallery--sticky") ? g.cardBottom() : Math.round(window.innerHeight * 0.31) + 8;
        return Math.max(cardEdge, hh) + 16;
      };
      scrollToField(c, function () {
        c.classList.remove("ezp-go-flash");
        void c.offsetWidth;
        c.classList.add("ezp-go-flash");
      }, free);
    }
    function start() {
      var c = card();
      if (!c) { if (++tries < 50) setTimeout(start, 300); return; }
      setTimeout(function () {
        var viewer = document.querySelector('.product__media-wrapper slider-component[id^="GalleryViewer"]');
        /* Ban-164 (anh 25/10 10:16): the pill on the photo stays for good (also after a choice, a design brought back,
           or a visit to the form) — a quick way down to the form at any time. Only the bottom bar and holding back
           "See my design" are for a first look. */
        if (viewer) {
          chip = document.createElement("button");
          chip.type = "button";
          chip.className = "ezp-go-chip";
          chip.setAttribute("aria-label", "Personalize this design: go to the personalization form");
          chip.innerHTML = PEN + "<span>Personalize this design</span>";
          chip.addEventListener("click", go);
          viewer.appendChild(chip);
          requestAnimationFrame(function () { if (chip) chip.classList.add("is-on"); });
        }
        if (used()) { done = true; return; }
        document.body.classList.add("ezp-go-pre");
        bar = document.createElement("button");
        bar.type = "button";
        bar.className = "ezp-go-bar";
        bar.innerHTML = PEN + "<span>Personalize it</span>" + DOWN;
        bar.addEventListener("click", go);
        document.body.appendChild(bar);
        if (chip) {
          var oc = new IntersectionObserver(function (en) {
            var r = en[en.length - 1];
            chipGone = !r.isIntersecting && r.boundingClientRect.top < 0;   // scrolled up past it, not below the screen
            update();
          });
          oc.observe(chip);
          obs.push(oc);
        } else {
          chipGone = true;
        }
        var os = new IntersectionObserver(function (en) {              // the form's top within 200 px of the screen
          var r = en[en.length - 1];
          formSeen = r.isIntersecting || r.boundingClientRect.top < 0;
          update();
        }, { rootMargin: "0px 0px 200px 0px" });
        var of = new IntersectionObserver(function (en) {              // the form is within 80% of the screen: done
          var r = en[en.length - 1];
          if (r.isIntersecting || r.boundingClientRect.top < 0) finish();
        }, { rootMargin: "0px 0px -20% 0px" });
        os.observe(c);
        of.observe(c);
        obs.push(os, of);
        update();
      }, 600);
    }
    ["pointerdown", "focusin"].forEach(function (t) {
      document.addEventListener(t, function (e) { if (!done && e.target.closest && e.target.closest(FORM + " #teeFormInputs")) finish(); }, true);
    });
    document.addEventListener("ezp:restored", finish);
    start();
  })();

  /* 8. Dropdown options: a styled list over the native <select>. The select stays the source of truth:
        choosing an item sets select.value and fires "change", exactly like a native pick. */
  var ddOpen = null;
  function closeDd() {
    if (!ddOpen) return;
    ddOpen.classList.remove("is-open", "is-up");
    ddOpen.querySelector(".ezp-dd__btn").setAttribute("aria-expanded", "false");
    ddOpen = null;
  }
  function ddSig(sel) {
    return sel.value + "|" + Array.prototype.map.call(sel.options, function (o) { return o.value + "=" + o.text; }).join("|");
  }
  /* Ban-162 (anh 25/10): Teeinblue's heading row ("Choose an option", "Choose something...") is a disabled option with
     the value "null" — the check for an empty value missed it, so it could be picked from the list and broke the
     preview. Any disabled / empty / "null" option is a heading: never listed, never picked. */
  function ddHeading(o) { return !o || o.disabled || o.value === "" || o.value === "null"; }
  function renderDd(sel, dd) {
    var btn = dd.querySelector(".ezp-dd__btn"), val = dd.querySelector(".ezp-dd__value"), list = dd.querySelector(".ezp-dd__list");
    var cur = sel.options[sel.selectedIndex];
    var isPh = ddHeading(cur);
    val.textContent = cur ? cur.text : "";
    val.classList.toggle("is-placeholder", isPh);
    list.innerHTML = "";
    Array.prototype.forEach.call(sel.options, function (o, i) {
      var li = document.createElement("li");
      var head = ddHeading(o);
      li.className = "ezp-dd__opt" + (head ? " is-placeholder" : "");
      if (head) li.hidden = true;
      li.setAttribute("role", "option");
      li.setAttribute("aria-selected", String(i === sel.selectedIndex && !head));
      li.dataset.index = i;
      li.textContent = o.text;
      list.appendChild(li);
    });
    dd._sig = ddSig(sel);
    btn.setAttribute("aria-label", (sel.closest(".tee-field") && sel.closest(".tee-field").querySelector(".tee-field__heading span") || {}).textContent || "Choose");
  }
  function decorateSelects() { eachForm(decorateSelectsIn); }
  function decorateSelectsIn(form) {
    Array.prototype.forEach.call(form.querySelectorAll(".tee-select-wrapper > select.tee-field__select"), function (sel) {
      if (sel.closest(".sr-only")) return;
      var wrap = sel.parentNode, dd = wrap.querySelector(".ezp-dd");
      if (!dd) {
        dd = document.createElement("div");
        dd.className = "ezp-dd";
        dd.innerHTML = '<button type="button" class="ezp-dd__btn" aria-haspopup="listbox" aria-expanded="false"><span class="ezp-dd__value"></span></button><ul class="ezp-dd__list" role="listbox"></ul>';
        wrap.appendChild(dd);
        wrap.classList.add("ezp-dd-on");
        sel.setAttribute("tabindex", "-1");
        sel.addEventListener("change", function () { if (dd._sig !== ddSig(sel)) renderDd(sel, dd); });
        renderDd(sel, dd);
      } else if (dd._sig !== ddSig(sel)) {
        renderDd(sel, dd);
      }
    });
  }
  function pick(dd, li) {
    var sel = dd.parentNode.querySelector("select.tee-field__select");
    if (!sel || li.classList.contains("is-placeholder") || ddHeading(sel.options[+li.dataset.index])) return;
    sel.selectedIndex = +li.dataset.index;
    sel.dispatchEvent(new Event("input", { bubbles: true }));
    sel.dispatchEvent(new Event("change", { bubbles: true }));
    renderDd(sel, dd);
    closeDd();
    dd.querySelector(".ezp-dd__btn").focus({ preventScroll: true });
  }
  function openDd(dd) {
    closeDd();
    ddOpen = dd;
    dd.classList.add("is-open");
    dd.querySelector(".ezp-dd__btn").setAttribute("aria-expanded", "true");
    var r = dd.getBoundingClientRect();
    var list = dd.querySelector(".ezp-dd__list");
    var below = window.innerHeight - r.bottom, need = Math.min(list.scrollHeight, 320) + 12;
    dd.classList.toggle("is-up", below < need && r.top > below);
    var cur = list.querySelector('[aria-selected="true"]');
    Array.prototype.forEach.call(list.children, function (li) { li.classList.toggle("is-active", li === cur); });
    if (cur) list.scrollTop = cur.offsetTop - list.clientHeight / 2 + cur.offsetHeight / 2;
  }
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest(FORM + " .ezp-dd__btn");
    if (btn) { var dd = btn.parentNode; if (dd.classList.contains("is-open")) closeDd(); else openDd(dd); return; }
    var li = e.target.closest && e.target.closest(FORM + " .ezp-dd__opt");
    if (li) { pick(li.closest(".ezp-dd"), li); return; }
    if (ddOpen && !ddOpen.contains(e.target)) closeDd();
  });
  document.addEventListener("keydown", function (e) {
    var dd = e.target.closest && e.target.closest(FORM + " .ezp-dd");
    if (!dd) return;
    var list = dd.querySelector(".ezp-dd__list");
    var items = Array.prototype.filter.call(list.children, function (li) { return !li.classList.contains("is-placeholder"); });
    var act = list.querySelector(".is-active");
    var i = items.indexOf(act);
    if (e.key === "Escape") { closeDd(); return; }
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      if (!dd.classList.contains("is-open")) { openDd(dd); return; }
      i = e.key === "ArrowDown" ? Math.min(items.length - 1, i + 1) : Math.max(0, i - 1);
      items.forEach(function (li, k) { li.classList.toggle("is-active", k === i); });
      if (items[i]) items[i].scrollIntoView({ block: "nearest" });
    } else if ((e.key === "Enter" || e.key === " ") && dd.classList.contains("is-open") && act) {
      e.preventDefault();
      pick(dd, act);
    }
  });

  /* 9. Description / Shipping / Personalization: only one open at a time. */
  /* Ban-49: the tab just opened keeps its place on the screen. Closing a long tab above it (e.g. Description while
     opening Shipping & Returns) made everything below jump up, so the new tab flew up out of view. */
  document.addEventListener("toggle", function (e) {
    var d = e.target;
    if (!d.open || !d.closest || !d.closest(".product__info-container > .product__accordion")) return;
    var sum = d.querySelector("summary"), before = sum ? sum.getBoundingClientRect().top : 0, closed = false;
    Array.prototype.forEach.call(document.querySelectorAll(".product__info-container > .product__accordion details[open]"), function (o) {
      if (o !== d) { o.open = false; closed = true; var s = o.querySelector("summary"); if (s) s.setAttribute("aria-expanded", "false"); }
    });
    if (!closed || !sum) return;
    var shift = sum.getBoundingClientRect().top - before;
    if (Math.abs(shift) < 2) return;
    var root = document.documentElement, was = root.style.scrollBehavior;
    root.style.scrollBehavior = "auto";
    window.scrollTo(0, window.pageYOffset + shift);
    root.style.scrollBehavior = was;
  }, true);

  /* Teeinblue re-renders parts of the form: re-apply the small additions when the DOM changes. */
  /* 10. State classes used by the CSS instead of :has() (a :has() rule is re-checked on every page change
         and made opening the product accordion noticeably slower on desktop). */
  var markRaf = 0;
  var RATIO_NOTE = /aspect ratio/i;   /* Teeinblue's "photo doesn't match this design's aspect ratio" note (§30 CSS) */
  function markStates() { markRaf = 0; eachForm(markStatesIn); }
  function markStatesIn(form) {
    Array.prototype.forEach.call(form.querySelectorAll(".tee-field--photo .tee-photo"), function (p) {
      p.classList.toggle("ezp-has-photo", !!p.querySelector(".tee-photo-uploaded"));
      p.classList.toggle("ezp-uploading", !!p.querySelector(".tee-photo-uploading"));
      var w = p.querySelector(".tee-photo-message .tee-photo-warning");
      var ratio = !!(w && RATIO_NOTE.test(w.textContent));
      if (w) w.classList.toggle("ezp-ratio-note", ratio);
      p.classList.toggle("ezp-ratio", ratio);
    });
    Array.prototype.forEach.call(form.querySelectorAll(".tee-form-actions .product-form__quantity"), function (q) {
      q.classList.toggle("ezp-qty", !!q.querySelector(".tee-quantity"));
    });
  }
  function queueMark() { if (!markRaf) markRaf = requestAnimationFrame(markStates); }
  markStates();

  /* 11. Price block on one line. Prices and the "Save X%" badge stay on a single row; when a long
         currency string (e.g. "₹1,900.00 INR") does not fit, the price text is scaled down a little
         instead of wrapping to a second line. Watches only the small price block. */
  var priceBox = null, priceMo = null, priceRaf = 0;
  function fitPrice() {
    priceRaf = 0;
    if (!priceBox || !priceBox.isConnected) return;
    priceBox.style.removeProperty("--ezp-pf");
    var pf = 1;
    for (var i = 0; i < 4; i++) {            /* the badge has a minimum size, so re-check a few times */
      var have = priceBox.clientWidth, need = priceBox.scrollWidth;
      if (!have || need <= have + 1 || pf <= 0.55) break;
      pf = Math.max(0.55, Math.floor(pf * (have / need) * 100) / 100 - 0.01);
      priceBox.style.setProperty("--ezp-pf", pf.toFixed(2));
    }
  }
  function queueFit() { if (!priceRaf) priceRaf = requestAnimationFrame(fitPrice); }
  function watchPrice() {
    var pf = pageForm(), box = pf && pf.querySelector(".tee-product-price");
    if (box === priceBox) return;
    if (priceMo) priceMo.disconnect();
    priceBox = box;
    if (!box) return;
    priceMo = new MutationObserver(queueFit);
    priceMo.observe(box, { childList: true, subtree: true, characterData: true });
    queueFit();
  }
  window.addEventListener("resize", queueFit);
  watchPrice();

  /* 12. Photo processing popup (AI / photo-effect layers).
         Teeinblue shows only a small progress bar while it uploads the photo and applies the effect
         (measured: about 2s upload + 10–18s AI). A calm popup explains the wait, shows the customer's
         own photo and Teeinblue's real progress, and can be minimised ("Keep editing"); the card then
         keeps showing the percentage. The popup closes when the crop window appears or on error. */
  var aiEl = null, aiTimer = 0, aiShowTimer = 0, aiSrc = "", aiMin = false, aiStart = 0, aiPct = 0, aiPhoto = null;
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (!t.matches || !t.matches(FORM + " .tee-field--photo input[type=file]") || !t.files || !t.files[0]) return;
    if (aiSrc) { try { URL.revokeObjectURL(aiSrc); } catch (err) {} }
    aiSrc = /^image\//.test(t.files[0].type) ? URL.createObjectURL(t.files[0]) : "";
    aiMin = false;
  }, true);
  function aiBuild() {
    if (aiEl) return aiEl;
    aiEl = document.createElement("div");
    aiEl.className = "ezp-ai";
    aiEl.setAttribute("role", "dialog");
    aiEl.setAttribute("aria-modal", "true");
    aiEl.setAttribute("aria-labelledby", "ezp-ai-title");
    aiEl.innerHTML =
      '<div class="ezp-ai__card">' +
        '<div class="ezp-ai__photo"><img alt="" hidden><span class="ezp-ai__scan"></span><span class="ezp-ai__spark"></span></div>' +
        '<p class="ezp-ai__kicker">Photo effect in progress</p>' +
        '<h3 class="ezp-ai__title" id="ezp-ai-title">Creating your design</h3>' +
        '<ol class="ezp-ai__steps">' +
          '<li data-step="1">Uploading your photo</li>' +
          '<li data-step="2">Applying the photo effect</li>' +
          '<li data-step="3">Preparing your preview</li>' +
        '</ol>' +
        '<div class="ezp-ai__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><span></span></div>' +
        '<p class="ezp-ai__meta"><span class="ezp-ai__pct" aria-live="polite">0%</span><span class="ezp-ai__eta">Usually 15–30 seconds</span></p>' +
        '<p class="ezp-ai__note">Please keep this page open. You can keep filling in the form while we work.</p>' +
        '<p class="ezp-ai__limit" hidden></p>' +
        '<button type="button" class="ezp-ai__min">Keep editing</button>' +
      '</div>';
    aiEl.querySelector(".ezp-ai__min").addEventListener("click", function () { aiMin = true; aiHide(); });
    document.body.appendChild(aiEl);
    return aiEl;
  }
  function aiShow() {
    var el = aiBuild();
    var img = el.querySelector(".ezp-ai__photo img");
    if (aiSrc) { img.src = aiSrc; img.hidden = false; } else { img.hidden = true; }
    el.classList.remove("is-leaving");
    el.classList.add("is-open");
    document.body.classList.add("ezp-ai-open");
    var b = el.querySelector(".ezp-ai__min");
    try { b.focus({ preventScroll: true }); } catch (err) {}
  }
  function aiHide() {
    if (!aiEl || !aiEl.classList.contains("is-open")) return;
    aiEl.classList.add("is-leaving");
    aiEl.classList.remove("is-open");
    document.body.classList.remove("ezp-ai-open");
  }
  function aiRender(pct, photo) {
    if (!aiEl) return;
    var p = Math.max(0, Math.min(99, Math.floor(pct)));
    aiEl.querySelector(".ezp-ai__bar span").style.transform = "scaleX(" + (p / 100) + ")";
    aiEl.querySelector(".ezp-ai__bar").setAttribute("aria-valuenow", String(p));
    aiEl.querySelector(".ezp-ai__pct").textContent = p + "%";
    var step = p < 12 ? 1 : p < 85 ? 2 : 3;
    Array.prototype.forEach.call(aiEl.querySelectorAll(".ezp-ai__steps li"), function (li) {
      var n = +li.getAttribute("data-step");
      li.className = n < step ? "is-done" : n === step ? "is-active" : "";
    });
    var secs = (Date.now() - aiStart) / 1000;
    aiEl.querySelector(".ezp-ai__eta").textContent = secs > 35 ? "Taking a little longer than usual…" : "Usually 15–30 seconds";
    var lim = photo && photo.querySelector(".tee-photo-rate-limit, .rate-limit-warning");
    var limEl = aiEl.querySelector(".ezp-ai__limit");
    if (lim && lim.textContent.trim()) { limEl.textContent = lim.textContent.trim(); limEl.hidden = false; } else limEl.hidden = true;
  }
  function aiTick() {
    var prog = document.querySelector(FORM + " .tee-field--photo .tee-photo-uploading .tee-progress");   // Ban-116: page form or the Edit popup
    if (!prog) {                                   // finished, failed or cancelled
      clearInterval(aiTimer); aiTimer = 0; clearTimeout(aiShowTimer); aiShowTimer = 0;
      if (aiPhoto) { aiPhoto.classList.remove("ezp-ai-busy"); aiPhoto.removeAttribute("data-ezp-pct"); }
      aiPhoto = null;
      if (aiEl && aiEl.classList.contains("is-open")) {
        if (document.querySelector(".vm--container.tee-dialog")) aiHide();
        else setTimeout(aiHide, 450);              // let the crop window appear underneath first
      }
      return;
    }
    var bar = prog.querySelector("[aria-valuenow]");
    var v = bar ? parseFloat(bar.getAttribute("aria-valuenow")) : NaN;
    if (!isNaN(v)) aiPct = Math.max(aiPct, v);   // never jumps backwards
    aiPhoto = prog.closest(".tee-photo");
    if (aiPhoto) { aiPhoto.classList.add("ezp-ai-busy"); aiPhoto.setAttribute("data-ezp-pct", Math.floor(Math.min(99, aiPct)) + "%"); }
    aiRender(aiPct, aiPhoto);
  }
  function aiWatch() {
    if (aiTimer) return;
    if (!document.querySelector(FORM + " .tee-field--photo .tee-photo-uploading .tee-progress")) return;
    aiStart = Date.now(); aiPct = 0;
    aiTimer = setInterval(aiTick, 250);
    aiTick();
    /* a quick plain upload never shows the popup; a long one (AI) does */
    aiShowTimer = setTimeout(function () { aiShowTimer = 0; if (aiTimer && !aiMin) { aiShow(); aiTick(); } }, 900);
  }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && aiEl && aiEl.classList.contains("is-open")) { aiMin = true; aiHide(); } });

  /* 13. Crop window + preview popup: start fading as soon as a tap on Cancel / Save / X is sure.
         Teeinblue does ~40ms of work (more on a phone) when the click lands, which held the fade back and
         made closing feel stuck, so the fade starts before that work. If nothing closes, the window comes back.
         Ban-165 (anh 25/10 10:41, iPhone): the fade used to start on finger-DOWN. The finger was still on the glass
         while the window went clear, so the page showed under it, with the phone's grey tap mark on top: it looked
         like the tap had hit the page (it had not: the window stays in the page until Teeinblue closes it after the
         click). The fade now starts on finger-UP on the same button, which comes just before the click. The
         "Change photo" button in the same footer (Teeinblue .tee-image-placement-replace) never fades the window. */
  var preFade = null, preTimer = 0, prePress = null;
  function unFade() { clearTimeout(preTimer); if (preFade && preFade.isConnected) preFade.classList.remove("ezp-closing"); preFade = null; }
  function closeBtn(t) {
    /* Ban-137: not the preview popup (.ezp-pv): it shrinks away when the close is decided (§15b).
       Ban-115: the cart Edit popup does not fade (it may ask "Discard your changes?" instead of closing) */
    return t && t.closest ? t.closest(".vm--container.tee-dialog-image-placement .tee-dcontent-footer .tee-btn:not(.tee-image-placement-replace), .vm--container.tee-dialog:not(.tee-edit-popup):not(.ezp-pv) .tee-dialog-close") : null;
  }
  document.addEventListener("pointerdown", function (e) {
    prePress = e.button > 0 ? null : closeBtn(e.target);
  }, true);
  document.addEventListener("pointercancel", function () { prePress = null; unFade(); }, true);
  document.addEventListener("pointerup", function (e) {
    var b = closeBtn(e.target), was = prePress;
    prePress = null;
    if (b && b === was) {
      unFade();
      preFade = b.closest(".vm--container") || b;
      preFade.classList.add("ezp-closing");
      preTimer = setTimeout(unFade, 900);
    } else if (preFade) unFade();
  }, true);

  /* 14. Name list (crossword) fields. The printed tiles only have the letters A–Z (Teeinblue's own help
         text says so), but the field accepted "Anh2" and printed the "2". While typing or pasting:
         accents become plain letters (Thư → Thu), digits and symbols are left out, and a short note
         says what changed. Phones also stop auto-correcting names. */
  function nameNote(field, msg) {
    var n = field.querySelector(".ezp-name-note");
    if (!n) {
      n = document.createElement("span");
      n.className = "ezp-name-note";
      n.setAttribute("aria-live", "polite");
      var box = field.querySelector(".tee-field__input");
      if (box && box.parentNode) box.parentNode.insertBefore(n, box.nextSibling); else field.appendChild(n);
    }
    n.textContent = msg;
    clearTimeout(n._t);
    if (msg) n._t = setTimeout(function () { n.textContent = ""; }, 6000);
  }
  function prepNameInputs() {
    Array.prototype.forEach.call(document.querySelectorAll(FORM + " .tee-field--scrabble input.tee__input"), function (i) {
      if (i._ezpName) return;
      i._ezpName = true;
      i.setAttribute("autocomplete", "off");
      i.setAttribute("autocorrect", "off");
      i.setAttribute("autocapitalize", "words");
      i.setAttribute("spellcheck", "false");
      i.setAttribute("enterkeyhint", "enter");
    });
  }
  document.addEventListener("input", function (e) {
    var t = e.target;
    if (e.isComposing || !t.matches || !t.matches(FORM + " .tee-field--scrabble input.tee__input")) return;
    var v = t.value;
    var plain = v.normalize ? v.normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[đĐ]/g, function (c) { return c === "đ" ? "d" : "D"; }) : v;
    var clean = plain.replace(/[^A-Za-z\s]/g, "");
    if (clean === v) return;
    var pos = t.selectionStart == null ? clean.length : Math.max(0, t.selectionStart - (v.length - clean.length));
    t.value = clean;
    try { t.setSelectionRange(pos, pos); } catch (err) {}
    var field = t.closest(".tee-field");
    if (field) nameNote(field, plain !== v && clean === plain ? "Accents were removed: the tiles only have the letters A–Z." : "Only letters A–Z can be printed, so numbers and symbols were left out.");
  }, true);   // capture: runs before Teeinblue reads the value
  document.addEventListener("compositionend", function (e) {
    var t = e.target;
    if (t.matches && t.matches(FORM + " .tee-field--scrabble input.tee__input")) t.dispatchEvent(new Event("input", { bubbles: true }));
  }, true);

  /* 15. Preview popup opens in one smooth movement (S7k).
         Before: the card faded in while its picture was still decoding and the title line was added
         ~100ms later (card grew 412 → 470px mid-animation). Now the title/sub-line are added the moment
         the popup is created, and the card only rises in once its pictures are ready (max 0.5s; the
         dark overlay and a small spinner show at once, so the tap still feels instant). */
  /* 15b. Ban-137 (owner 23/10, "as smooth as Macorner", redo of Ban-136 safely). Macorner (ant-design, measured 375):
          opens growing out of the touched spot, 0.2 -> 1 in 0.3s cubic-bezier(.08,.82,.17,1); closes shrinking back
          there in 0.2s cubic-bezier(.78,.14,.15,.86). Styles: ez-personalize.css section 16.
          Rules learnt from Ban-136 (it failed on iPhone):
          - nothing moves under a finger that is still down: the shrink starts when the close is DECIDED (finger
            lifted on the dark area, or the click on X / Add To Cart / Esc), never on finger-down;
          - while it is hidden / grows / shrinks the card takes no taps (CSS), the dark area stays and takes them;
          - for 0.45s after a close any click is dropped (iPhone can send a late or doubled click to whatever is
            under the finger once the popup is gone, e.g. the page's own Add To Cart);
          - a tap on the dark area closes on finger-up (iPhone may send no click at all for a tap on a plain div).
          Only the touch point is kept on finger-down (no layout read); the origin comes from the card's own inline
          left/top when it is shown. */
  var pvTap = null, pvDown = null, pvShield = 0;
  function pvOrigin(pv) {
    var m = pv.querySelector(":scope > .vm--modal");
    if (!m) return;
    var left = parseFloat(m.style.left), top = parseFloat(m.style.top);
    if (!pvTap || Date.now() - pvTap.t > 2000 || isNaN(left) || isNaN(top)) {   // keyboard or a late open: from the middle
      pv.style.removeProperty("--ezp-pv-o");
      return;
    }
    pv.style.setProperty("--ezp-pv-o", Math.round(pvTap.x - left) + "px " + Math.round(pvTap.y - top) + "px");
  }
  function pvClosing(pv) {
    if (pv.classList.contains("ezp-closing")) return false;
    pv.classList.add("ezp-closing");
    setTimeout(function () {                             // Teeinblue did not close it after all: show it again
      if (pv.isConnected && !pv.querySelector(":scope > .vm--modal[class*='leave']")) pv.classList.remove("ezp-closing");
    }, 900);
    return true;
  }
  function pvOutside(e) {
    var pv = e.target && e.target.closest && e.target.closest(".vm--container.ezp-pv");
    return pv && !e.target.closest(".vm--modal") ? pv : null;
  }
  var pvScrollT = 0;                                     // a tap that only stops the popup's own scrolling does not close it
  document.addEventListener("scroll", function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains("ezp-pv")) pvScrollT = Date.now();
  }, { capture: true, passive: true });
  window.addEventListener("pointerdown", function (e) {
    if (e.button > 0 || !e.isPrimary) { pvDown = null; return; }   // right / middle click, second finger: never closes
    pvTap = { x: e.clientX, y: e.clientY, t: Date.now() };
    pvDown = pvOutside(e) && Date.now() - pvScrollT > 250 ? { id: e.pointerId, x: e.clientX, y: e.clientY, t: Date.now() } : null;
  }, { capture: true, passive: true });
  window.addEventListener("pointercancel", function () { pvDown = null; }, true);
  window.addEventListener("pointerup", function (e) {
    var d = pvDown;
    pvDown = null;
    if (!d || d.id !== e.pointerId || Date.now() - d.t > 1500 || Math.abs(e.clientX - d.x) > 12 || Math.abs(e.clientY - d.y) > 12) return;
    var pv = pvOutside(e);
    var x = pv && pv.querySelector(".tee-dialog-close");
    if (!x || !pvClosing(pv)) return;
    x.click();                                           // Teeinblue's own close (the click below passes: no shield yet)
    pvShield = Date.now() + 450;
  }, true);
  window.addEventListener("click", function (e) {
    if (Date.now() < pvShield) {                         // the late / doubled click of a tap that closed the popup
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    var pv = e.target && e.target.closest && e.target.closest(".vm--container.ezp-pv");
    if (!pv) return;
    if (e.target.closest(".tee-dialog-close")) {         // X (also Esc, §4 clicks it): Teeinblue closes it right after
      if (pvClosing(pv)) pvShield = Date.now() + 450;
      return;
    }
    if (!e.target.closest(".vm--modal")) {               // dark area, when no finger-up came first (mouse etc.)
      e.preventDefault();
      e.stopImmediatePropagation();
      var x = pv.querySelector(".tee-dialog-close");
      if (x && pvClosing(pv)) { x.click(); pvShield = Date.now() + 450; }
    }
  }, true);
  var PV_TITLE = "Check your preview";
  var PV_SUB = "Names, dates and photos print as shown";
  function prepPreview() {
    var pv = document.querySelector(".vm--container.tee-dialog:not(.tee-dialog-image-placement):not(.tee-edit-popup)");   // Ban-115: not the cart Edit popup (no preview title / qty / fade there)
    if (!pv) return;
    var mock = pv.querySelector(".tee-dcontent-body:not(.tee-image-placement-body) .tee-preview__mockup");
    if (mock && !mock.querySelector(":scope > h3")) {
      var p = document.createElement("p");
      p.className = "sub-content";
      p.textContent = PV_SUB;
      var h = document.createElement("h3");
      h.textContent = PV_TITLE;
      mock.prepend(p);
      mock.prepend(h);
    } else if (mock) {
      var sub = mock.querySelector(":scope > .sub-content");
      if (sub && sub.textContent !== PV_SUB) sub.textContent = PV_SUB;
    }
    addPvQty(pv);
    if (pv.classList.contains("ezp-pv")) return;
    pv.classList.add("ezp-pv", "ezp-pv-wait");
    var t0 = Date.now();
    var reveal = function () {
      if (!pv.classList.contains("ezp-pv-wait")) return;
      pvOrigin(pv);                                        // Ban-137
      pv.classList.add("ezp-pv-grow");                     // Ban-137: no taps on the card while it grows (CSS)
      setTimeout(function () { pv.classList.remove("ezp-pv-grow"); }, 320);
      pv.classList.add("ezp-pv-in");
      pv.classList.remove("ezp-pv-wait");
    };
    var check = function () {
      if (!pv.isConnected) return;
      var imgs = pv.querySelectorAll(".tee-dcontent-body img");
      var pending = Array.prototype.filter.call(imgs, function (i) { return !i.complete && i.offsetParent !== null; });
      if ((imgs.length && !pending.length) || Date.now() - t0 > 500) {
        var first = imgs[0];
        if (first && first.decode && first.complete) first.decode().then(function () { requestAnimationFrame(reveal); }, function () { requestAnimationFrame(reveal); });
        else requestAnimationFrame(reveal);
        return;
      }
      setTimeout(check, 40);
    };
    setTimeout(check, 0);
    setTimeout(reveal, 650);                               // never wait longer than this
  }

  /* 15c. Quantity next to "Add To Cart" in the preview popup (Ban-09).
          A small − 1 + box beside the button. It drives Teeinblue's own quantity box on the page (the one Add To
          Cart reads), so the number chosen here is the number added, and the page box shows it too. */
  function pageQty() {
    var list = document.querySelectorAll(".tee-quantity-input");
    for (var i = 0; i < list.length; i++) if (!list[i].closest(".vm--container")) return list[i];
    return null;
  }
  function addPvQty(pv) {
    var foot = pv.querySelector(".tee-dcontent-footer");
    var atc = foot && foot.querySelector(".tee-btn--atc");
    var real = pageQty();
    if (!atc || !real || foot.querySelector(".ezp-pvqty")) return;
    var box = document.createElement("div");
    box.className = "ezp-pvqty";
    box.innerHTML = '<button type="button" class="ezp-pvqty__b" data-d="-1" aria-label="Decrease quantity"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 10h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '<input class="ezp-pvqty__n" type="number" inputmode="numeric" pattern="[0-9]*" min="1" max="999" aria-label="Quantity">' +
      '<button type="button" class="ezp-pvqty__b" data-d="1" aria-label="Increase quantity"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 10h10M10 5v10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
    var num = box.querySelector("input");
    var minus = box.querySelector('[data-d="-1"]');
    var get = function () { var n = parseInt(real.value, 10); return isNaN(n) || n < 1 ? 1 : n; };
    var show = function () { var n = get(); num.value = String(n); minus.disabled = n <= 1; };
    var put = function (n) {
      n = Math.max(1, Math.min(999, parseInt(n, 10) || 1));
      real.value = String(n);
      real.dispatchEvent(new Event("input", { bubbles: true }));    // Teeinblue (Vue) listens to input/change
      real.dispatchEvent(new Event("change", { bubbles: true }));
      show();
    };
    box.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest(".ezp-pvqty__b");
      if (b && !b.disabled) put(get() + parseInt(b.getAttribute("data-d"), 10));
    });
    num.addEventListener("change", function () { put(num.value); });
    num.addEventListener("blur", function () { put(num.value); });
    num.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); num.blur(); } });
    show();
    foot.classList.add("ezp-pvfoot");
    foot.insertBefore(box, foot.firstChild);
  }

  /* 15b. Photo crop window (opens right after a photo is chosen).
          Before: it faded in at ~795px tall and then snapped to ~522px once Teeinblue had laid out the
          picture (a visible jump), and its top was a 45px empty band with only the X.
          Now: a short title + hint fill that band, and the card rises only once its size has settled. */
  var CROP_TITLE = "Adjust your photo";
  var CROP_HINT = "Drag to move · zoom with the buttons";
  /* Ban-175: the crop window = the LAST one in the page. Two can stand in the page at once (seen in the pane: an Edit
     popup left open under another one); the first one was taken, so the open window got no title, no numbers, and
     "Change photo" went to the other one's photo (anh 25/10 20:24, screenshot on a computer: no title, no numbers). */
  function cropWin() {
    var ws = document.querySelectorAll(".vm--container.tee-dialog-image-placement");
    return ws.length ? ws[ws.length - 1] : null;
  }
  function prepCrop() {
    var c = cropWin();
    if (!c || c.classList.contains("ezp-crop")) return;
    var inner = c.querySelector(".tee-dialog-inner");
    var modal = c.querySelector(".vm--modal");
    if (!inner || !modal) return;
    c.classList.add("ezp-crop", "ezp-pv-wait");
    var head = document.createElement("div");
    head.className = "ezp-crop-head";
    head.innerHTML = '<h3 class="ezp-crop-head__title"></h3><p class="ezp-crop-head__hint"></p>';
    head.querySelector("h3").textContent = CROP_TITLE;
    head.querySelector("p").textContent = CROP_HINT;
    inner.insertBefore(head, inner.firstChild);
    var t0 = Date.now(), lastH = -1, sameSince = 0;
    var reveal = function () {
      if (!c.classList.contains("ezp-pv-wait")) return;
      c.classList.add("ezp-pv-in");
      c.classList.remove("ezp-pv-wait");
    };
    var watch = function () {
      if (!c.isConnected || !c.classList.contains("ezp-pv-wait")) return;
      var h = modal.offsetHeight, now = Date.now();
      if (h !== lastH) { lastH = h; sameSince = now; }
      var ready = c.querySelector(".tee-ip-preview") && h > 0 && now - sameSince >= 180;
      if (ready || now - t0 > 1000) { requestAnimationFrame(reveal); return; }
      requestAnimationFrame(watch);
    };
    requestAnimationFrame(watch);
  }

  /* 15d. Ban-167 → 168 (anh 25/10 12:01, 14:53) — the strip of photos in the crop window.
          With 2+ photos the window has a strip of them (Teeinblue's PhotoSwitcher, .tee-ip-photos__item): picking one
          moves the window to that photo (MockupImagePlacement.fieldId).
          a) "Change photo": Teeinblue's button keeps the field the window was opened from (fieldRef), so the new picture
             replaced THAT photo. On the tap, before the picker opens, fieldRef is pointed at the field of the photo picked
             in the strip. Ban-167 found that field by the picture's file name, which fails right after an upload (the
             strip then shows the local copy of the file, anh 14:53: "always the first photo"); Ban-168 reads the field id
             the window itself is on.
          b) Order: the strip follows the layers of the design, not the photo boxes of the form. Each thumbnail now takes
             the place of its box (CSS order) and shows the box number (data-ezp-n). When the order really changes, the
             strip's own scrolling and ‹ › arrows follow the order on screen.
          Teeinblue's app parts are found by walking its component tree (~2–4 ms, ~840 parts): on the Change tap, and when
          the strip's thumbnails change (not on every frame). Anything not found: Teeinblue's own behaviour. */
  /* Ban-171: the cart's "Edit design" popup is not in the app's tree: Teeinblue draws its popups opened from the cart
     with Vue's render() into <body> (document.body._vnode; /cart: the app on #teeinblue-wrapper holds 2 parts, the
     popup's crop window, strip and 6 photo boxes are under body, walk ~1 ms). Both trees are looked at; the one that
     holds the open crop window wins. */
  /* Ban-176 (anh 25/10 20:58, computer: "after changing photos and Save, the Edit design popup is not updated; 2 crop
     windows came up, both had to be closed"): on the product page the drawer's Edit popup of the SAME product is drawn
     in the page's own app tree (measured: 2 crop windows, 2 strips, 12 photo boxes in one tree, the same box ids twice).
     The boxes were kept by id, so the page's box won: "Change photo" put the new picture in the PAGE's form (photo 3 of
     the page changed, the Edit popup kept the old one) and the page's own crop window opened on top. Now only the parts
     that stand where the window is are taken: in that Edit popup, or (the page's window) outside every Edit popup. */
  function cropScope(ref) { return cropIn(ref || cropWin()); }
  function cropHere(scope, p) {
    var el = p && p.$el, n = el && (el.nodeType === 1 ? el : el.parentElement);
    if (!n) return true;                             // nothing to go by: as before
    return scope === document ? !n.closest(".tee-edit-popup") : scope.contains(n);
  }
  function cropParts(ref) {
    var scope = cropScope(ref);
    var roots = [], hosts = document.querySelectorAll("#teeinblue-wrapper, [data-v-app]"), first = null;
    for (var i = 0; i < hosts.length; i++) {
      var app = hosts[i].__vue_app__, r = app && app._container && app._container._vnode;
      if (r && roots.indexOf(r) < 0) roots.push(r);
    }
    if (document.body._vnode && roots.indexOf(document.body._vnode) < 0) roots.push(document.body._vnode);
    for (i = 0; i < roots.length; i++) {
      var o = cropWalk(roots[i], scope);
      if (o.ip) return o;
      if (!first || (!first.mip && o.mip)) first = o;
    }
    return first || { ip: null, mip: null, ps: null, fields: {} };
  }
  function cropWalk(root, scope) {
    var out = { ip: null, mip: null, ps: null, fields: {} };
    var seen = new Set(), stack = [root];
    while (stack.length) {
      var v = stack.pop();
      if (!v || typeof v !== "object" || seen.has(v)) continue;
      seen.add(v);
      var c = v.component, p = c && c.proxy;
      if (p) {
        try {
          if ("reuploadInPopup" in p && "tempCustomization" in p) { if (!out.ip && p.isOpen && cropHere(scope, p)) out.ip = p; }
          else if ("photoGroups" in p && "fieldId" in p) { if (!out.mip && cropHere(scope, p)) out.mip = p; }
          else if ("groups" in p && typeof p.scrollToShow === "function") { if (!out.ps && cropHere(scope, p)) out.ps = p; }
          else if (typeof p.recustomize === "function" && p.field && p.field.id && cropHere(scope, p)) out.fields[p.field.id] = p;
        } catch (err) {}
      }
      if (c) stack.push(c.subTree);                  // parts without a proxy (functional) still hold the window's parts
      if (Array.isArray(v.children)) for (var k = 0; k < v.children.length; k++) stack.push(v.children[k]);
      if (v.dynamicChildren) for (k = 0; k < v.dynamicChildren.length; k++) stack.push(v.dynamicChildren[k]);
    }
    return out;
  }
  function cropRefFix() {
    var q = cropParts();
    cropKeep(q.ip);
    var cw = cropWin();
    if (!cw || !cw.querySelector(".tee-ip-photos__item--active")) return;   // no strip: one photo
    var fid = q.mip && q.mip.fieldId, fp = fid && q.fields[fid];
    try { if (q.ip && fp && q.ip.fieldRef !== fp) q.ip.fieldRef = fp; } catch (err) {}
  }
  /* c0) Ban-172 (anh 25/10 17:16: "adjust photo rồi change photo khác chưa hoạt động mượt") — while a photo is being
         changed, Teeinblue rebuilds the window's copy of the design from the saved design and keeps only the place of
         the photo being changed (resetCustomization(true, [its position])): every photo moved / turned / zoomed in the
         window and not saved yet went back (measured /cart Edit design: photo 4 turned + zoomed, photo 5 changed →
         photo 4 a 1 → 0). Teeinblue's own; same on product pages. Now the places changed in the window (copy ≠ saved)
         of the other photos are put back right after; a window that opens still starts from the saved design (Teeinblue
         clears isReplacing first). Set on the window's part when "Change photo" is pressed. */
  function cropKeep(ip) {
    if (!ip || ip.__ezpKeep || typeof ip.resetCustomization !== "function") return;
    var orig = ip.resetCustomization;
    try { ip.__ezpKeep = true; } catch (err) { return; }
    ip.resetCustomization = function (keep, list) {
      var mine = null;
      try {
        if (keep && this.isReplacing) {
          var temp = this.tempCustomization || {}, real = this.customization || {}, skip = list || [];
          for (var k in temp) {
            if (/-position$/.test(k) && skip.indexOf(k) < 0 && JSON.stringify(temp[k]) !== JSON.stringify(real[k])) (mine = mine || {})[k] = temp[k];
          }
        }
      } catch (err) { mine = null; }
      var r = orig.apply(this, arguments);
      if (mine) { try { this.tempCustomization = Object.assign({}, this.tempCustomization, mine); } catch (err) {} }
      return r;
    };
  }
  window.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest(".vm--container.tee-dialog-image-placement .tee-image-placement-replace")) cropRefFix();
  }, true);
  window.addEventListener("keydown", function (e) {
    if ((e.key === "Enter" || e.key === " ") && e.target.closest && e.target.closest(".tee-image-placement-replace")) cropRefFix();
  }, true);
  /* Ban-175 (anh 25/10 20:24: "change photo bất cứ vị trí nào, không phụ thuộc vào ô ảnh mở edit"): the photo is
     pointed at again when the new file arrives — this listener on window (capture) runs before Teeinblue's own one on
     the file input — so whatever happened between the tap and the picker closing (iPhone: the page is redrawn when the
     photo library closes), the photo replaced is the one the window shows at that moment (its strip's active photo). */
  window.addEventListener("change", function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(".vm--container.tee-dialog-image-placement .tee-image-placement-replace-input")) cropRefFix();
  }, true);
  /* Ban-171: a crop window opened in the cart's Edit popup belongs to the form in that popup. On a product page the
     drawer's Edit popup can hold the same product as the page: two forms, the same box ids → look inside the popup. */
  function cropIn(el) { return (el && el.closest && el.closest(".tee-edit-popup")) || document; }
  function cropTile(el, id) {
    var sc = cropIn(el);
    return sc === document ? document.getElementById(id) : sc.querySelector('[id="' + id + '"]');
  }
  /* b) called from the page's MutationObserver (§19): cheap check first (same thumbnails and same empty boxes as last
        time: nothing to do) */
  function cropTag(w) {
    return "/" + w.querySelectorAll(".ezp-ip-add").length + "/" + w.querySelectorAll(".tee-ip-photos__item:not(.ezp-ip-add):not([data-ezp-n])").length;
  }
  function cropPoll() {
    if (cropPoll.t) return;
    cropPoll.t = setInterval(function () {
      if (!cropWin()) { clearInterval(cropPoll.t); cropPoll.t = 0; return; }
      cropStrip();
    }, 500);
  }
  function cropStrip() {
    var w = cropWin();
    if (!w) return;
    var track = w.querySelector(".tee-ip-photos__track:not(.ezp-ip-own__track)");
    var items = track ? track.querySelectorAll(".tee-ip-photos__item:not(.ezp-ip-add)") : [], sig = items.length + "";
    for (var i = 0; i < items.length; i++) { var im = items[i].querySelector("img"); sig += "|" + (im ? im.getAttribute("src") : ""); }
    var pgs = cropIn(w).querySelectorAll(FORM + " .tee-field.ezp-pg");
    sig += "/";
    for (i = 0; i < pgs.length; i++) sig += pgs[i].querySelector(".tee-photo-uploaded img, .tee-photo-uploading") ? "1" : (PB && PB.win && PB.fields.indexOf(pgs[i]) >= 0 && pbFailed(pgs[i]) ? "x" : "0");
    /* Ban-170: and how many "+" of ours the window holds (Teeinblue may redraw the part they sit in: draw them again).
       Ban-172 (anh 25/10 17:39, iPhone, cart Edit design: after "Change photo" the first thumbnails had no number and
       stood in the wrong place): and how many thumbnails have no number — Teeinblue can draw a thumbnail again with the
       same picture (same signature before), or settle after the 6 quick retries; while the window is open it is now
       looked at every 0.5 s too (cheap when nothing changed: the signature only) */
    cropPoll();
    if (w._ezpSig === sig + cropTag(w)) return;
    var q = cropParts(), groups = q.mip && q.mip.photoGroups;
    var even = !!groups && groups.length === items.length;
    if (track && !even) {
      /* the strip is drawn before Teeinblue's list settles (after "Change photo"): look again shortly, a few times */
      clearTimeout(cropStrip.t);
      w._ezpTry = (w._ezpTry || 0) + 1;
      if (w._ezpTry < 30) cropStrip.t = setTimeout(cropStrip, 200);
      if (!groups) return;
      /* Ban-175: meanwhile the thumbnails already there take their places by their picture (Teeinblue draws one per
         picture address: the same picture in two boxes can leave the lists of different lengths, which kept the whole
         strip unnumbered and in the design's order — anh's screenshot 20:24: the changed photo first, without number) */
    } else w._ezpTry = 0;
    var used = [], name = function (u) { return String(u || "").split("?")[0].split(/[\/:]/).pop(); };
    var groupOf = function (i) {   // the list holds "wa:customers/uploads/x.jpg", the picture "https://cdnx…/x.jpg": by file name
      if (even) return groups[i];
      var im = items[i].querySelector("img"), src = name(im && im.getAttribute("src"));
      for (var j = 0; j < groups.length; j++) if (used.indexOf(j) < 0 && src && name(groups[j].url) === src) { used.push(j); return groups[j]; }
      return null;
    };
    /* Ban-170: a window of one photo opens before its toolbar is drawn: no place for the row of "+" yet (Ban-169 then
       never drew it) — no signature kept, the next change of the page tries again */
    if (cropAdd(w, track, q) === false) { w._ezpSig = ""; return; }
    if (!track) { w._ezpSig = sig + cropTag(w); return; }
    var cards = Array.prototype.slice.call(cropIn(w).querySelectorAll(FORM + " .tee-field--photo"));
    var place = [], moved = false;
    for (i = 0; i < items.length; i++) {
      var gi = groupOf(i), tile = gi ? cropTile(w, "tee-field--" + gi.fieldId) : null, k = cards.indexOf(tile);
      place.push(k < 0 ? 999 + i : k);
      var n = tile ? String(tile._ezpNum || k + 1) : "";
      if (items[i].style.order !== String(place[i])) items[i].style.order = String(place[i]);
      if (n && items[i].getAttribute("data-ezp-n") !== n) items[i].setAttribute("data-ezp-n", n);
      if (i && place[i] < place[i - 1]) moved = true;
    }
    w._ezpSig = even ? sig + cropTag(w) : "";       // lists not even yet: looked at again (0.5 s) until they are
    var ps = q.ps;
    if (!moved || !ps || ps.__ezpOrd) return;
    /* the strip's own scrolling and arrows count in the design's order: give them the order on screen */
    ps.__ezpOrd = true;
    var vis = function () {           // indexes of ps.groups, as they stand on screen
      var g = ps.groups || [], ix = g.map(function (x, j) { return j; });
      var cs = Array.prototype.slice.call(cropIn(w).querySelectorAll(FORM + " .tee-field--photo"));
      var at = function (j) { var t = cropTile(w, "tee-field--" + g[j].fieldId), k2 = cs.indexOf(t); return k2 < 0 ? 999 + j : k2; };
      return ix.sort(function (x, y) { return at(x) - at(y); });
    };
    try {
      ps.scrollToShow = function (t) {
        var vp = ps.$refs && ps.$refs.viewport, tr = vp && vp.firstElementChild;
        var b = tr && tr.querySelectorAll(".tee-ip-photos__item")[t];
        if (!b) return;
        var x = b.getBoundingClientRect().left - vp.getBoundingClientRect().left + vp.scrollLeft, w = b.offsetWidth;
        if (x + w + 8 > vp.scrollLeft + vp.clientWidth) vp.scrollTo({ left: x + w + 8 - vp.clientWidth, behavior: "smooth" });
        else if (x - 8 < vp.scrollLeft) vp.scrollTo({ left: Math.max(0, x - 8), behavior: "smooth" });
      };
      var step = function (d) {
        var g = ps.groups || [], o = vis(), cur = g.findIndex(function (x) { return x.isActive; }), pos = o.indexOf(cur < 0 ? 0 : cur);
        var nx = o[pos + d];
        if (nx != null) ps.$emit("select", g[nx]);
      };
      ps.next = function () { step(1); };
      ps.prev = function () { step(-1); };
      /* Ban-178 (anh 26/10 12:15, Edit design: "at the start or the end of the strip the left / right arrow disappears"):
         Teeinblue greys an arrow out (disabled, opacity .35) from the photo's place in ITS list (canPrev/canNext), not
         from the place on screen: on photo 1, first on screen but last in Teeinblue's list, ‹ was live and › greyed out,
         so › could not be pressed at all (measured /cart Edit design, 6 photos). Both now count on the order on screen;
         they read the strip's own reactive list, so Vue redraws the arrows whenever the photo changes. */
      var ctx = ps.$ && ps.$.ctx;
      if (ctx) {
        var here = function () {
          var g = ps.groups || [], o = vis(), cur = g.findIndex(function (x) { return x.isActive; });
          return { p: o.indexOf(cur < 0 ? 0 : cur), n: o.length };
        };
        Object.defineProperty(ctx, "canPrev", { configurable: true, enumerable: true, get: function () { return here().p > 0; }, set: function () {} });
        Object.defineProperty(ctx, "canNext", { configurable: true, enumerable: true, get: function () { var q = here(); return q.p < q.n - 1; }, set: function () {} });
        if (typeof ps.$forceUpdate === "function") ps.$forceUpdate();
      }
    } catch (err) {}
  }

  /* c) Ban-169 (anh 25/10 15:10) — the empty photo boxes in the strip. In a grid of photos (§69) with boxes still
        empty, the strip also shows one "+" thumbnail per empty box (its number, where the box stands). Tapping one opens
        the picker (several photos allowed); the photos go to the empty boxes from that one on (§69 d, same as from the
        form).
        Ban-170 (anh 25/10 15:25: "the window drops as soon as I add a photo; keep it until I press Save"): the window now
        STAYS OPEN. Ban-169 saved, closed and reopened it because Teeinblue's window works on a copy of the design taken
        when it opens (tempCustomization): the empty boxes are in that copy as null, Teeinblue merges later changes as
        {...design, ...copy} (the copy's null wins, the new photo never shows), and Save writes the place of EVERY photo
        from the copy (the new photo's place would be written back as null). Measured on TEST 13 Mom Photo Collage.
        Now, while the photos are added (§69 d, "win" batch): Teeinblue's own call to open a window for each new photo is
        held (as in a batch from the form), and every value of the new photos' boxes that changes in the design is copied
        into the window's copy, unless the customer already moved that photo in the window. The strip then shows the
        new photos (Teeinblue's PhotoSwitcher reads the copy); until a photo is in the strip, its "+" turns into a
        spinner. Teeinblue's "go to this photo" after each upload is dropped for these photos (§69 d pbMute: on a phone
        the window would jump while the customer adjusts another one); the window goes once to the first new photo.
        Tried (pane 375×812 and 845): 2 of 6 photos, window on photo 1 turned, "+3" with 2 photos → window stays, strip
        1,2,3*,4,+5,+6 (~0.1 s); photo 3 resized, "+5" → 5*; tap photo 4 → 4*; Save → the five places kept, no window
        opens again. Cancel while a photo goes up → closed, photo in its box, no window later.
        Without Teeinblue's strip (one photo so far) a row of our own holds the "+" thumbnails (Ban-170: now really drawn,
        see cropStrip). */
  var ADD_ICO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  function cropAdd(w, track, q) {
    var fid = (q.mip && q.mip.fieldId) || (q.ip && q.ip.fieldRef && q.ip.fieldRef.field && q.ip.fieldRef.field.id);
    var tile = fid && cropTile(w, "tee-field--" + fid);
    var run = tile && tile._ezpHead && tile._ezpHead._ezpRun, own = w.querySelector(".ezp-ip-own");
    var inStrip = ((q.mip && q.mip.photoGroups) || []).map(function (x) { return "tee-field--" + x.fieldId; });
    /* Ban-170: a photo being added from this window, not in the strip yet: its thumbnail waits (spinner) */
    /* Ban-176: a strict true/false — with a batch from the FORM running (PB.win undefined) it gave undefined, and
       classList.toggle(name, undefined) FLIPS the class: the "+" of a box left empty kept spinning (anh 25/10 20:51,
       iPhone: "6" with a spinner, nothing to tap; measured in the pane: 5 photos into 6 boxes → "+6" busy for good) */
    var busy = function (g) { return !!(PB && PB.win && PB.fields.indexOf(g) >= 0 && inStrip.indexOf(g.id) < 0 && !pbFailed(g)); };
    var empties = (run || []).filter(function (g) {
      var i = g.querySelector("input[type=file]");
      if (!g.isConnected || !i) return false;
      return busy(g) || (!i.disabled && !g.querySelector(".tee-photo-uploaded img, .tee-photo-uploading"));
    });
    var host = track;
    if (!host) {
      if (!empties.length) { if (own) own.parentNode.removeChild(own); return; }
      var tb = w.querySelector(".tee-toolbar");
      if (!own && !tb) return false;
      if (!own) {
        own = document.createElement("div");
        own.className = "tee-ip-photos ezp-ip-own";
        own.innerHTML = '<div class="tee-ip-photos__viewport"><div class="tee-ip-photos__track ezp-ip-own__track"></div></div>';
        tb.parentNode.insertBefore(own, tb);
      }
      host = own.querySelector(".ezp-ip-own__track");
    } else if (own) own.parentNode.removeChild(own);
    var cards = Array.prototype.slice.call(cropIn(w).querySelectorAll(FORM + " .tee-field--photo"));
    var olds = host.querySelectorAll(".ezp-ip-add");
    for (var i = 0; i < olds.length; i++) {
      var g0 = cropTile(w, olds[i].getAttribute("data-ezp-for"));
      if (empties.indexOf(g0) < 0) olds[i].parentNode.removeChild(olds[i]);
    }
    empties.forEach(function (g) {
      var b = host.querySelector('.ezp-ip-add[data-ezp-for="' + g.id + '"]');
      if (!b) {
        var k = cards.indexOf(g), n = String(g._ezpNum || k + 1);
        b = document.createElement("label");
        b.className = "tee-ip-photos__item ezp-ip-add";
        b.setAttribute("data-ezp-for", g.id);
        b.setAttribute("data-ezp-n", n);
        b.style.order = String(k);
        b.innerHTML = ADD_ICO + '<input type="file" class="ezp-ip-add__in" accept="image/*" multiple>';
        b.lastChild.setAttribute("aria-label", "Add photo " + n);
        host.appendChild(b);                       // at the end of Teeinblue's list: its own rows keep their places
      }
      var wait = busy(g);
      if (b.classList.contains("ezp-ip-add--busy") !== wait) {
        b.classList.toggle("ezp-ip-add--busy", wait);
        b.lastChild.disabled = wait;
        b.setAttribute("aria-busy", wait ? "true" : "false");
      }
    });
  }
  window.addEventListener("change", function (e) {
    var inp = e.target;
    if (!inp || !inp.classList || !inp.classList.contains("ezp-ip-add__in")) return;
    e.stopImmediatePropagation();
    var b = inp.closest(".ezp-ip-add"), g = b && cropTile(inp, b.getAttribute("data-ezp-for"));
    var files = Array.prototype.slice.call(inp.files || []);
    inp.value = "";
    if (!g || !files.length || typeof window.ezpAddPhotos !== "function") return;
    if (window.ezpAddPhotos(g, files, true)) return;   // Ban-170: added with the window open
    /* the window's parts not found (never seen): as Ban-169, keep what was adjusted, close, add, open again */
    var save = document.querySelector(".vm--container.tee-dialog-image-placement .tee-dcontent-footer .tee-btn--primary");
    if (save) save.click();
    window.ezpAddPhotos(g, files);
  }, true);

  /* 16. Option tiles answer the finger at once: a light "pressed" look while the finger is down
         (Teeinblue needs ~80ms on a laptop, more on a phone, before the tile turns selected). */
  var pressed = null;
  function unpress() { if (pressed) { pressed.classList.remove("ezp-press"); pressed = null; } }
  document.addEventListener("pointerdown", function (e) {
    var lab = e.target.closest && e.target.closest(FORM + " .tee-clipart-label");
    if (!lab || e.button > 0) return;
    var tile = lab.closest(".tee-clipart");
    if (!tile || tile.classList.contains("active")) return;
    unpress();
    pressed = tile;
    tile.classList.add("ezp-press");
  }, true);
  ["pointerup", "pointercancel"].forEach(function (t) { document.addEventListener(t, function () { setTimeout(unpress, 120); }, true); });

  /* 17b. Photo card: a tap anywhere on an empty card opens the photo picker (not only "Select image"). */
  document.addEventListener("click", function (e) {
    var card = e.target.closest && e.target.closest(FORM + " .tee-field--photo .tee-photo");
    if (!card || card.classList.contains("ezp-has-photo") || card.classList.contains("ezp-uploading")) return;
    if (e.target.closest("label, button, a, input, .ezp-photo-tips")) return;   // their own action already
    var input = card.querySelector("input[type=file]");
    if (input && !input.disabled) input.click();
  });

  /* 18. Changing country / currency keeps the design. Teeinblue saves every customization in the
         browser (localStorage) but only fills the form back when asked; after the country form reloads
         the page we ask it once (teeinblue.refillCustomization). */
  /* Ban-06: tell the live-preview card (tee-sticky-gallery.js) that the form already holds a design,
     so it shows as soon as the customer reaches the form, without waiting for a first click. */
  function designRestored() {
    window.ezpRestored = true;
    try { document.dispatchEvent(new CustomEvent("ezp:restored")); } catch (err) {}
  }
  function productId() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    return m && m.id ? String(m.id) : "";
  }
  function markRefill() {
    var id = productId();
    if (!id) return;
    try { sessionStorage.setItem("ezp-refill", id + "|" + Date.now()); } catch (err) {}
  }
  document.addEventListener("submit", function (e) {
    if (e.target && /\/localization/.test(e.target.getAttribute("action") || "")) markRefill();
  }, true);
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (t && t.name === "country_code" && t.form && /\/localization/.test(t.form.getAttribute("action") || "")) markRefill();
  }, true);
  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest("[data-ezf-country], .ezf-locale button, .disclosure__link[data-value]")) markRefill();
  }, true);
  (function refillAfterCountryChange() {
    var flag;
    try { flag = sessionStorage.getItem("ezp-refill"); } catch (err) { return; }
    var parts = flag ? flag.split("|") : [];
    if (!flag || parts[0] !== productId() || Date.now() - +parts[1] > 120000) {
      try { sessionStorage.removeItem("ezp-refill"); } catch (err) {}
      /* not a country change: normal visit → quiet restore with the note (§18b) */
      var n = 0;
      var t = setInterval(function () {
        var ready = window.teeinblue && window.teeinblue.refillCustomization && document.querySelector(FORM + " #teeFormInputs .tee-field");
        if (ready || ++n > 60) { clearInterval(t); if (ready) autoRestore(); }
      }, 150);
      return;
    }
    try { sessionStorage.removeItem("ezp-refill"); } catch (err) {}
    if (parts[0] !== productId() || Date.now() - +parts[1] > 120000) return;
    var tries = 0;
    var timer = setInterval(function () {
      var T = window.teeinblue;
      var ready = T && T.refillCustomization && document.querySelector(FORM + " #teeFormInputs .tee-field");
      if (ready || ++tries > 60) {
        clearInterval(timer);
        try { if (ready && T.hasCustomization(parts[0])) { T.refillCustomization(parts[0]); designRestored(); } } catch (err) {}
      }
    }, 250);
  })();

  /* 18b. Welcome back (S7o). Teeinblue keeps every design in the browser but only fills the form when
          asked. On a fresh visit to a product with a saved design (and an untouched form), the design is
          brought back at once, quietly, before the customer reaches the form. A small note at the top of
          the form says so and offers "Start fresh" (back to the default form), with Undo for a few seconds.
          After a country/currency change the design comes back without the note (§18).
          Set RESTORE_CARD = false to turn it all off. */
  var RESTORE_CARD = true;
  /* Teeinblue's getCurrentCustomization() already returns the saved design on a fresh page, so the
     form itself is checked: nothing typed, no photo, and (if there is a layout choice) none picked. */
  function formUntouched() {
    var form = pageForm();
    if (!form) return false;
    if (form.querySelector(".tee-photo-uploaded, .tee-scrabble__words-item, .tee-song__list-item--selected")) return false;
    var typed = Array.prototype.some.call(form.querySelectorAll("input.tee__input, textarea.tee__paragraph"), function (i) { return i.type !== "file" && i.value.trim() !== ""; });
    if (typed) return false;
    var tpl = form.querySelector(".tee-field--template");
    return !(tpl && tpl.querySelector(".tee-clipart.active"));
  }
  function removeNote(note) {
    if (!note || note.classList.contains("is-leaving")) return;
    note.classList.add("is-leaving");
    setTimeout(function () { if (note.parentNode) note.parentNode.removeChild(note); }, 260);
  }
  /* Ban-139: "Start fresh" also empties Teeinblue's in-page memory of typed values. With "sync between
     templates" on (our campaigns), Teeinblue remembers every field by its label while the page is open, so
     names keep when the customer switches 2 ⇄ 3 members. resetCustomization() clears the saved design but not
     that memory, so picking a layout again after Start fresh brought the old names, text and photos back.
     The memory lives on the page form's Vue component (useGlobalCustomizationData.globalCustomizationData);
     Edit design popups in the cart have their own and are left alone. Not found (Teeinblue changed) → same as before. */
  function syncMemories(pid) {
    var found = [], seen = [];
    function vnode(v, d) {
      if (!v || typeof v !== "object" || d > 400) return;
      if (v.component) comp(v.component, d + 1);
      if (Array.isArray(v.children)) v.children.forEach(function (c) { vnode(c, d + 1); });
      if (v.suspense && v.suspense.activeBranch) vnode(v.suspense.activeBranch, d + 1);
    }
    function comp(c, d) {
      if (!c || seen.indexOf(c) !== -1) return;
      seen.push(c);
      try {
        var px = c.proxy, m = px && px.useGlobalCustomizationData;
        if (m && m.globalCustomizationData && String(px.productId) === String(pid)) found.push(m);
      } catch (err) {}
      vnode(c.subTree, d + 1);
    }
    try {
      Array.prototype.forEach.call(document.querySelectorAll("div"), function (el) {
        if (el._vnode && !el.closest(".tee-edit-customization, .tee-edit-popup")) vnode(el._vnode, 0);
      });
    } catch (err) {}
    return found;
  }
  function showRestoredNote(pid) {
    var pf = pageForm(), inputs = pf && pf.querySelector("#teeFormInputs");
    if (!inputs || document.querySelector(".ezp-restore")) return;
    var note = document.createElement("div");
    note.className = "ezp-restore";
    note.setAttribute("role", "status");
    note.innerHTML =
      '<div class="ezp-restore__in">' +
        '<span class="ezp-restore__icon" aria-hidden="true"></span>' +
        '<span class="ezp-restore__text"><b>Welcome back!</b> Your last design is ready.</span>' +
        '<button type="button" class="ezp-restore__fresh">Start fresh</button>' +
        '<button type="button" class="ezp-restore__x" aria-label="Close">×</button>' +
      '</div>';
    var text = note.querySelector(".ezp-restore__text");
    var fresh = note.querySelector(".ezp-restore__fresh");
    var backup = null, undoTimer = 0, mems = [], memBackup = [];
    fresh.addEventListener("click", function () {
      var T = window.teeinblue;
      if (backup === null) {                       /* Start fresh */
        try { backup = localStorage.getItem("teeinblue-customizations"); } catch (err) { backup = ""; }
        mems = syncMemories(pid);
        memBackup = mems.map(function (m) { var o = m.globalCustomizationData; m.globalCustomizationData = {}; return o; });
        try { T.resetCustomization(pid); } catch (err) {}
        text.innerHTML = "Started a new design.";
        fresh.textContent = "Undo";
        undoTimer = setTimeout(function () { removeNote(note); }, 6000);
      } else {                                     /* Undo */
        clearTimeout(undoTimer);
        mems.forEach(function (m, i) { m.globalCustomizationData = memBackup[i]; });
        try { if (backup) localStorage.setItem("teeinblue-customizations", backup); T.refillCustomization(pid); } catch (err) {}
        removeNote(note);
      }
    });
    note.querySelector(".ezp-restore__x").addEventListener("click", function () { removeNote(note); });
    inputs.parentNode.insertBefore(note, inputs);
    requestAnimationFrame(function () { requestAnimationFrame(function () { note.classList.add("is-open"); }); });
  }
  function autoRestore() {
    if (!RESTORE_CARD) return;
    /* Ban-144 (anh 23/10 21:46): trang mở bằng ?customization-id= (giỏ → "+ Add another") — Teeinblue đã nạp đúng thiết
       kế từ giỏ; "Welcome back! Your last design is ready." vừa thừa vừa sai, đứng chung với dòng "Making another one".
       Không nạp bản nháp, không hiện dòng, không tự cuộn (ez-cart-drawer.js lo việc cuộn). */
    if (/[?&]customization-id=[^&]/.test(location.search)) return;
    var T = window.teeinblue, pid = productId();
    if (!T || !pid || !T.hasCustomization || !T.refillCustomization) return;
    var saved;
    try {
      if (!T.hasCustomization(pid)) return;
      saved = T.getCustomization(pid);
    } catch (err) { return; }
    if (!saved || !Object.keys(saved).length || !formUntouched()) return;
    try { T.refillCustomization(pid); } catch (err) { return; }
    designRestored();
    showRestoredNote(pid);
    autoScrollToForm();
  }
  /* Ban-07 (phones, like Pawfect): a returning customer whose design was just brought back is taken to the
     form with one gentle scroll, and the live preview card shows on the way. Only if they have not started
     scrolling or touching the page themselves, and never when the link points somewhere on the page (#…). */
  var userMoved = false;
  ["touchstart", "wheel", "keydown", "mousedown"].forEach(function (t) {
    window.addEventListener(t, function () { userMoved = true; }, { passive: true, capture: true });
  });
  function autoScrollToForm() {
    if (!window.matchMedia("(max-width: 989px)").matches || location.hash) return;
    var tries = 0;
    (function go() {
      if (userMoved || window.pageYOffset > 80) return;
      if (!window.ezpGallery && ++tries < 25) { setTimeout(go, 150); return; }   /* card script starts ~2 s after load */
      if (window.ezpGallery && window.ezpGallery.arm) window.ezpGallery.arm();
      setTimeout(function () {
        if (userMoved || window.pageYOffset > 80) return;
        var f = document.querySelector(FORM + " .ezp-restore") || document.querySelector(FORM + " #teeFormInputs");
        if (f) scrollToField(f);
      }, 300);
    })();
  }
  /* Ban-07: the note no longer closes by itself on the first option tap — closing it moved the whole form
     up ~70px right under the customer's finger (e.g. first 6 ⇄ 9 switch). It closes only with × or Start fresh. */

  /* 18c. Phones: the sticky button opens the preview window (which has the Add to cart).
     Ban-130 (owner 22/10): "Preview & Add to Cart" sounded too salesy → "See my design" (eye icon = its ::before, §15). */
  var STICKY_LABEL = "See my design";
  function prepStickyLabel() {
    var a = document.querySelector(".btn-preview.hidden-xl #btn-preview");
    if (!a || a._ezpLabel) return;
    a._ezpLabel = true;
    a.textContent = STICKY_LABEL;
    a.setAttribute("aria-label", "See your design, then add it to your cart");
  }

  /* 19. Back from the cart (phones keep the page in memory): never leave Add to cart stuck on "Adding…" */
  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    Array.prototype.forEach.call(document.querySelectorAll(".tee-btn--atc.tee-processing"), function (b) { b.classList.remove("tee-processing"); });
    document.body.classList.remove("ezp-ai-open");
    queueSticky();
  });

  var moTimer = 0;
  /* S7r/Ban-06: a photo field that Teeinblue mounts again (e.g. "Choose Image Effect" swaps the colour and the
     black & white photo layer) is decorated in the same task, before the browser paints it. Before, it showed
     for a moment in its plain state, then grew when "Photo added" + "Photo tips" were applied (the form jumped). */
  function photoAdded(muts) {
    for (var i = 0; i < muts.length; i++) {
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var n = a[j];
        if (n.nodeType === 1 && (n.matches(".tee-field--photo, .tee-photo, .tee-photo-uploaded") || n.querySelector(".tee-field--photo, .tee-photo-uploaded"))) return true;
      }
    }
    return false;
  }
  /* Ban-108: choices whose label holds a picture keep Teeinblue's look (CSS c2 styles text choices only). A class
     set here, before paint, instead of :not(:has(img)) in the CSS, which made every form redraw slower. */
  function markImgRadios() {
    var ims = document.querySelectorAll(FORM + " .tee-radio-label img");
    for (var i = 0; i < ims.length; i++) {
      var r = ims[i].closest(".tee-radio");
      if (r && !r.classList.contains("ezp-radio--img")) r.classList.add("ezp-radio--img");
    }
  }
  new MutationObserver(function (muts) {
    markImgRadios();
    if (photoAdded(muts) || document.querySelector(FORM + " .tee-photo-warning:not(.ezp-ratio-note)")) {
      markStates();
      decoratePhotos();
      photoGrid();   // Ban-86: grid before the browser paints the new fields
      Array.prototype.forEach.call(document.querySelectorAll(FORM + " img.tee-photo-image:not([decoding])"), function (im) { im.decoding = "sync"; });
    }
    queueMark();
    /* Ban-52: Teeinblue's message just appeared: count the fields now, before it is painted (no flash of the long text) */
    if (document.querySelector(FORM + " .tee-form-responses .tee-error__message:not([data-ezp-msg])")) refreshValidity();
    document.body.classList.toggle("ezp-modal-open", !!document.querySelector(".vm--container.tee-dialog"));
    if (!aiTimer && document.querySelector(FORM + " .tee-field--photo .tee-photo-uploading .tee-progress")) aiWatch();
    prepPreview();
    prepCrop();
    cropStrip();   // Ban-168
    if (moTimer) return;
    moTimer = setTimeout(function () { moTimer = 0; decoratePhotos(); photoGrid(); decorateSelects(); refreshValidity(); queueSticky(); watchPrice(); prepNameInputs(); prepStickyLabel(); placeTrust(); trimDemand(); markShipTrigger(); properTitles(); decorateTitle(); }, 120);
  }).observe(document.body, { childList: true, subtree: true });   // childList only: watching class changes too made option picks slower
  /* 20. (Ban-07) The cart button moved to its own file, ez-cart-button.js, loaded on every page. */

  /* 21. (Ban-08) Cart labels: remember how this product's options are named on the product page (Teeinblue
         campaign labels, e.g. "Size: 4.7 INCHES"), so the cart page shows the same words straight away.
         Reads Teeinblue's own campaign file (already loaded by the page, so it comes from the browser cache). */
  (function cacheCartLabels() {
    var pid = productId();
    if (!pid || !window.fetch || !window.localStorage) return;
    var nice = function (x) { x = String(x || "").trim(); return x && x === x.toUpperCase() ? x.charAt(0) + x.slice(1).toLowerCase() : x; };
    var build = function (j) {
      var out = {}, cps = (j && j.campaign_products) || [], byTib = {};
      cps.forEach(function (cp) { (cp.campaign_variants || []).forEach(function (cv) { byTib[cv.variant_id] = { cp: cp, cv: cv }; }); });
      ((j && j.instance_variants) || []).forEach(function (iv) {
        var hit = byTib[iv.variant_id];
        if (!hit || !iv.platform_linked_id) return;
        var p = hit.cp.product || {}, v = hit.cv.variant || {}, rows = [];
        if (cps.length > 1) rows.push([nice((j.config && j.config.available_product_label) || "Style"), hit.cp.platform_title || p.title || ""]);
        var color = hit.cv.color || v.color, size = hit.cv.size || v.size;
        if (color) rows.push([p.color_custom_label || "Color", color]);
        if (size) rows.push([p.size_custom_label || "Size", size]);
        out[String(iv.platform_linked_id)] = rows.filter(function (r) { return r[1] && !/^(default|default title|no)$/i.test(String(r[1]).trim()); });
      });
      return out;
    };
    var tries = 0;
    (function look() {
      var url = "";
      try {
        var list = performance.getEntriesByType("resource");
        for (var i = 0; i < list.length; i++) if (/api\.teeinblue\.com\/api\/merchant\/campaigns\/\d+\.json/.test(list[i].name)) { url = list[i].name; break; }
      } catch (err) {}
      if (!url) { if (++tries < 20) setTimeout(look, 500); return; }
      fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (!j) return;
        try { localStorage.setItem("ez-tib-labels:" + pid, JSON.stringify({ t: Date.now(), v: build(j) })); } catch (err) {}
      }).catch(function () {});
    })();
  })();

  /* Ban-33: "Photo tips" (the photo upload guidelines) opens in the same popup as "Estimated delivery" (§37,
     openSheet): same backdrop, card, title and X, same way in and out, same lock on the page behind, same
     swipe-down on phones. Before (Ban-26 → Ban-32) it was the theme's own box (snippets/upload-guide.liquid),
     shown and hidden by teeinblue-custom.js with a class, with our animation, close, lock and swipe added on
     top in layers; on iPhone a swipe-down then played its exit a second time. The text and icons still come from
     that snippet (edit them there); the theme's box itself is never shown any more. */
  function openGuide() {
    var src = document.querySelector(".modal-custom-image .modal__main");
    if (!src) return;
    var title = document.querySelector(".modal-custom-image .title-custom-upload");
    openSheet({
      cls: "ezp-ship--guide",
      title: title && title.textContent.trim() ? title.textContent.trim() : "Photo Upload Guidelines",
      fill: function (body) {
        Array.prototype.forEach.call(src.children, function (n) { body.appendChild(n.cloneNode(true)); });
      }
    });
  }
  /* capture phase on the document: runs before teeinblue-custom.js's handler on the link, so the theme's box
     never opens as well. "Photo tips" next to the first photo field clicks this same link (§5). */
  /* Ban-66: on the window (before Facebook Pixel's document listener, which spent 50–180 ms per click here) and
     stopped there, so the popup opens without the mouse stalling */
  window.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest(".upload_image_guidelines");
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openGuide();
  }, true);

  /* 36. Ban-17 — under Add To Cart: the store's promise + three delivery steps (Pawfect House / Macorner do
         this right under the button). The markup and dates come from snippets/shipping.liquid
         (<template id="ezTrustTpl">, same dates as "Estimated delivery"); it is placed after the Teeinblue
         form (outside Teeinblue's own markup, so Teeinblue never removes it) and only once. */
  function placeTrust() {
    var tpl = document.getElementById("ezTrustTpl");
    var form = pageForm();
    if (!tpl || !form || !form.querySelector(".tee-btn--atc") || document.querySelector(".ezp-trust")) return;
    var box = tpl.content ? tpl.content.cloneNode(true) : null;
    if (!box) return;
    form.parentNode.insertBefore(box, form.nextSibling);
  }
  /* "In demand. 63 people bought this in the last 24 hours." → "63 people bought this in the last 24 hours."
     so the pill fits on one line on a phone (Ban-17 CSS §35a); the number itself is untouched */
  function trimDemand() {
    var p = document.querySelector(".people-demand:not(.ezp-trimmed)");
    if (!p) return;
    for (var n = p.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && /In demand\.\s*/.test(n.nodeValue)) { n.nodeValue = n.nodeValue.replace(/\s*In demand\.\s*/, ""); break; }
    }
    p.classList.add("ezp-trimmed");
  }
  placeTrust();
  trimDemand();

  /* Ban-21 — variant titles in Proper Case, whatever the campaign typed: "STYLE" → "Style", "color" → "Color",
     "t-shirt color" → "T-Shirt Color". Only the title's own words change (the "Size Chart" link inside stays);
     a title that is already right is left alone, so this never loops with the observer. */
  function properCase(t) {
    return t.toLowerCase().replace(/(^|[\s\-\/(])([a-z\u00e0-\u024f])/g, function (m, a, c) { return a + c.toUpperCase(); });
  }
  function properTitles() {
    var list = document.querySelectorAll("#tee-artwork-form .tee-option__title");
    for (var i = 0; i < list.length; i++) {
      for (var n = list[i].firstChild; n; n = n.nextSibling) {
        if (n.nodeType !== 3 || !/[A-Za-z]/.test(n.nodeValue)) continue;
        var v = properCase(n.nodeValue);
        if (v !== n.nodeValue) n.nodeValue = v;
      }
    }
  }
  properTitles();

  /* Ban-23 — form title: "PERSONALIZED" (a plain span made by teeinblue-custom.js) becomes a soft brand band
     with twinkling sparkles, like Macorner's but in EZ colours (the pastel orange → teal of the newsletter block).
     The span keeps its class, so teeinblue-custom.js still finds it and never adds a second one. */
  function decorateTitle() {
    Array.prototype.forEach.call(document.querySelectorAll("#teeFormInputs > .title-customize:not(.ezp-hd)"), function (t) {   // Ban-116: every form
      t.classList.add("ezp-hd");
      t.innerHTML = '<span class="ezp-hd__ic" aria-hidden="true"><i></i><i></i><i></i></span><span class="ezp-hd__t">Personalized</span>';
    });
  }
  decorateTitle();

  /* 37. Ban-18 — "Estimated delivery" details popup.
         Before: the theme's box opened on mouse-over, covered the price and had no clear way to close.
         Now: opens on tap/click only, the same Popup as everywhere (dark backdrop, centred title, round X,
         r16 card), the same 3 delivery steps as under Add To Cart, and the notes the store writes in the
         theme editor (Shipping block › description) as a tidy list. Esc, X or a tap outside closes it. */
  function shipNotes() {
    var src = document.querySelector('.modal-shipping[data-index="1"] .sub-des-shipping') || document.querySelector(".modal-shipping .sub-des-shipping");
    return src ? src.innerHTML : "";
  }
  /* Ban-33: the popup shared by "Estimated delivery" and "Photo tips". Ban-36: it lives in ez-floating-buttons.js
     (window.ezSheet), loaded on every page, so the gift popup uses the very same one; this only hands over. */
  function openSheet(o) { return window.ezSheet ? window.ezSheet(o) : null; }
  function openShip() {
    var tpl = document.getElementById("ezTrustTpl");
    var steps = tpl && tpl.content ? tpl.content.querySelector(".ezp-steps") : null;
    var country = document.querySelector(".deliver-to-country-line .shipping-country-current");
    var notes = shipNotes();
    openSheet({
      title: "Estimated delivery",
      sub: "Made to order, shipped" + (country && country.textContent.trim() ? " to " + country.textContent.trim() : " to you"),
      fill: function (body) {
        if (steps) {
          var st = document.createElement("div");
          st.className = "ezp-ship__steps";
          st.appendChild(steps.cloneNode(true));
          body.appendChild(st);
        }
        if (notes) {
          var nt = document.createElement("div");
          nt.className = "ezp-ship__notes";
          nt.innerHTML = notes;
          Array.prototype.forEach.call(nt.querySelectorAll("a"), function (a) { a.removeAttribute("title"); });
          body.appendChild(nt);
        }
      }
    });
  }
  /* capture phase on the document: runs before the theme's own handler (teeinblue-custom.js), which would
     otherwise open the old box too */
  window.addEventListener("click", function (e) {   /* Ban-66: window + stopped (see "Photo tips" above) */
    var t = e.target.closest && e.target.closest(".new-shipping");
    if (!t || t.closest(".accordion__content")) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openShip();
  }, true);
  document.addEventListener("keydown", function (e) {
    if ((e.key === "Enter" || e.key === " ") && e.target.matches && e.target.matches(".new-shipping")) { e.preventDefault(); openShip(); }
  });
  function markShipTrigger() {
    var t = document.querySelector(".product__info-container .new-shipping:not([tabindex])");
    if (!t || t.closest(".accordion__content")) return;
    t.setAttribute("tabindex", "0");
    t.setAttribute("role", "button");
    t.setAttribute("aria-haspopup", "dialog");
  }
  markShipTrigger();

  /* 38. Ban-28 — zoom on the floating "Live preview" card (phones), like Pawfect House: a small + / − pill in the
         card's bottom-right corner. Steps 1× → 1.5× → 2× → 2.5×, eased; once zoomed, a finger drags the picture
         around (and two fingers pinch); a double tap zooms in at that spot, or back out. Only the picture inside
         the card moves (Teeinblue's slider track, through CSS variables read by the card's own rules), so the
         gallery in the page is never touched, and the zoom resets each time the card goes away. */
  (function liveZoom() {
    var STEPS = [1, 1.5, 2, 2.5], MAX = 2.5;
    var host = null, pill = null, bIn = null, bOut = null, lvl = null, lvlTimer = 0;
    var s = 1, x = 0, y = 0;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">';
    function isOn() {
      var c = document.body.classList;
      return c.contains("gallery--sticky") && !c.contains("gallery--sticky--hide");
    }
    function stage() { return host && host.querySelector(".tee-gallery"); }
    function track() { return host && host.querySelector(".tee-slider__track"); }
    function kScale() { var g = stage(); return g && g.offsetWidth ? g.getBoundingClientRect().width / g.offsetWidth : 0.5; }
    function clamp() {
      var t = track();
      if (!t) return;
      var mx = t.offsetWidth * (s - 1) / 2, my = t.offsetHeight * (s - 1) / 2;
      x = Math.max(-mx, Math.min(mx, x));
      y = Math.max(-my, Math.min(my, y));
    }
    function apply(anim) {
      if (!host) return;
      clamp();
      host.classList.toggle("ezz-anim", !!anim && !reduce);
      host.classList.toggle("ezz-on", s > 1.001);
      host.style.setProperty("--ezz-s", String(Math.round(s * 1000) / 1000));
      host.style.setProperty("--ezz-x", Math.round(x * 10) / 10 + "px");
      host.style.setProperty("--ezz-y", Math.round(y * 10) / 10 + "px");
      if (bOut) bOut.disabled = s <= 1.001;
      if (bIn) bIn.disabled = s >= MAX - 0.001;
    }
    function showLevel() {
      if (!lvl) return;
      lvl.textContent = (Math.round(s * 10) / 10) + "×";
      lvl.classList.add("is-show");
      clearTimeout(lvlTimer);
      lvlTimer = setTimeout(function () { lvl.classList.remove("is-show"); }, 900);
    }
    /* zoom to n, keeping the point q (offset from the picture's centre, in its own pixels) where it is */
    function zoomTo(n, qx, qy, anim) {
      n = Math.max(1, Math.min(MAX, n));
      qx = qx || 0; qy = qy || 0;
      x = qx - n * (qx - x) / s;
      y = qy - n * (qy - y) / s;
      s = n;
      if (s <= 1.001) { s = 1; x = 0; y = 0; }
      apply(anim);
      showLevel();
    }
    function step(dir) {
      var n = s;
      if (dir > 0) { for (var i = 0; i < STEPS.length; i++) if (STEPS[i] > s + 0.01) { n = STEPS[i]; break; } }
      else { n = 1; for (var j = STEPS.length - 1; j >= 0; j--) if (STEPS[j] < s - 0.01) { n = STEPS[j]; break; } }
      zoomTo(n, 0, 0, true);
    }
    function reset() { s = 1; x = 0; y = 0; apply(false); if (lvl) lvl.classList.remove("is-show"); }
    /* screen point → offset from the picture's centre, in the picture's own pixels */
    function local(cx, cy) {
      var g = stage(), k = kScale();
      if (!g) return [0, 0];
      var r = g.getBoundingClientRect();
      return [(cx - (r.left + r.width / 2)) / k, (cy - (r.top + r.height / 2)) / k];
    }

    function build() {
      host = document.querySelector(".grid__item.product__media-wrapper .tee-gallery-content");
      if (!host || host.querySelector(":scope > .ezz")) return;
      pill = document.createElement("div");
      pill.className = "ezz";
      pill.setAttribute("role", "group");
      pill.setAttribute("aria-label", "Zoom live preview");
      pill.innerHTML =
        '<button type="button" class="ezz__b ezz__in" aria-label="Zoom in">' + SVG + '<path d="M12 6.5v11M6.5 12h11"/></svg></button>' +
        '<button type="button" class="ezz__b ezz__out" aria-label="Zoom out" disabled>' + SVG + '<path d="M6.5 12h11"/></svg></button>';
      lvl = document.createElement("span");
      lvl.className = "ezz-lvl";
      lvl.setAttribute("aria-hidden", "true");
      bIn = pill.querySelector(".ezz__in");
      bOut = pill.querySelector(".ezz__out");
      pill.addEventListener("click", function (e) {
        var b = e.target.closest && e.target.closest(".ezz__b");
        e.preventDefault();
        e.stopPropagation();
        if (!b || b.disabled) return;
        step(b === bIn ? 1 : -1);
      });
      host.appendChild(pill);
      host.appendChild(lvl);
      bindGestures();
      apply(false);
    }

    /* gestures on the picture: drag (zoomed), pinch (zoomed), double tap (any time) */
    var pts = {}, nPts = 0, start = null, moved = false, lastTap = null, bound = null;
    /* Ban-37: Teeinblue's own swipe (touch events on its slider track: a sideways drag over 50px goes to the next
       picture) is switched off inside the floating card. Before, dragging a zoomed picture sideways also "swiped",
       so the card jumped to another picture. Touch events stop at the picture's frame on their way down (capture),
       so neither the swipe nor Teeinblue's own pinch zoom see them; the pointer events used here still arrive,
       and the page still scrolls up and down as before. In the gallery in the page nothing changes. */
    function holdSwipe(e) { if (isOn()) e.stopPropagation(); }
    function holdPinch(e) { if (isOn() && e.touches && e.touches.length > 1 && e.cancelable) e.preventDefault(); }
    function bindGestures() {
      var g = stage();
      if (!g || g === bound) return;
      bound = g;
      g.addEventListener("pointerdown", down);
      g.addEventListener("pointermove", move);
      g.addEventListener("pointerup", up);
      g.addEventListener("pointercancel", up);
      ["touchstart", "touchmove", "touchend", "touchcancel"].forEach(function (t) { g.addEventListener(t, holdSwipe, { capture: true, passive: true }); });
      /* Ban-51: two fingers on the card zoom the picture, never the page. Teeinblue lets the browser pinch-zoom over
         its pictures (touch-action: pan-y pinch-zoom), so a pinch started at 1× also zoomed the whole page, and on
         phones the browser usually took the gesture over and our zoom stopped. Now the card allows the browser only
         up-down scrolling (CSS §55), and as soon as a second finger is down the browser's own pinch is cancelled
         (touchstart/touchmove with 2+ fingers; gesturestart/gesturechange on iPhone). One finger still scrolls the
         page as before while the picture is not zoomed. */
      ["touchstart", "touchmove"].forEach(function (t) { g.addEventListener(t, holdPinch, { capture: true, passive: false }); });
      ["gesturestart", "gesturechange"].forEach(function (t) { g.addEventListener(t, function (e) { if (isOn() && e.cancelable) e.preventDefault(); }, { passive: false }); });
      /* a click that ends a drag in the card is not a tap; Ban-37: only in the card and only right after that drag
         (before, the flag stayed on once the card closed, and every tap in the gallery was swallowed) */
      g.addEventListener("click", function (e) {
        if (moved && isOn()) { e.preventDefault(); e.stopPropagation(); }
        moved = false;
      }, true);
    }
    function forget() { pts = {}; nPts = 0; start = null; moved = false; lastTap = null; }
    function snapshot() {
      var ids = Object.keys(pts), a = pts[ids[0]], b = pts[ids[1]] || a;
      return { s: s, x: x, y: y, cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2, d: Math.hypot(a.x - b.x, a.y - b.y) || 1 };
    }
    function down(e) {
      if (!isOn() || e.target.closest(".gallery--close-button")) { forget(); return; }
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      nPts = Object.keys(pts).length;
      moved = false;
      /* Ban-37: no setPointerCapture any more. On iPhone it sent the finger's "up" to this frame instead of
         Teeinblue's slider, which then counted that finger as still down: after two zoomed drags it believed two
         fingers were always on the picture and switched its swipe off for good (the gallery in the page froze).
         A finger's events stay with the element it touched anyway, so nothing is lost. */
      start = snapshot();
      start.t = Date.now();
      start.x0 = e.clientX; start.y0 = e.clientY;
    }
    function move(e) {
      if (!pts[e.pointerId] || !start) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (Math.abs(e.clientX - start.x0) + Math.abs(e.clientY - start.y0) > 6) moved = true;
      if (s <= 1.001 && nPts < 2) return;               // not zoomed: the page scrolls as usual
      var now = snapshot(), k = kScale();
      if (nPts > 1) {                                    // pinch around the fingers' midpoint
        var n = Math.max(1, Math.min(MAX, start.s * now.d / start.d));
        var q = local(start.cx, start.cy);
        x = q[0] - n * (q[0] - start.x) / start.s + (now.cx - start.cx) / k;
        y = q[1] - n * (q[1] - start.y) / start.s + (now.cy - start.cy) / k;
        s = n;
      } else {                                           // drag
        x = start.x + (now.cx - start.cx) / k;
        y = start.y + (now.cy - start.cy) / k;
      }
      apply(false);
      if (nPts > 1) showLevel();
    }
    function up(e) {
      if (!pts[e.pointerId]) return;
      delete pts[e.pointerId];
      nPts = Object.keys(pts).length;
      if (nPts) { start = snapshot(); start.t = Date.now(); start.x0 = start.cx; start.y0 = start.cy; return; }
      if (s < 1.02) reset();
      if (e.type === "pointerup" && !moved && start && Date.now() - start.t < 300) {
        var now = Date.now();
        if (lastTap && now - lastTap.t < 320 && Math.abs(e.clientX - lastTap.x) < 30 && Math.abs(e.clientY - lastTap.y) < 30) {
          lastTap = null;
          if (s > 1.001) zoomTo(1, 0, 0, true);
          else { var q = local(e.clientX, e.clientY); zoomTo(2, q[0], q[1], true); }
        } else lastTap = { t: now, x: e.clientX, y: e.clientY };
      }
      start = null;
    }

    function sync() {
      if (isOn()) {
        if (!host || !host.isConnected || !host.querySelector(":scope > .ezz")) build();
        else bindGestures();
      } else { forget(); if (s !== 1) reset(); }
    }
    new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ["class"] });
  })();

  /* 39. Ban-28 — swipe down to close the phone bottom sheets: moved with the popup to ez-floating-buttons.js (Ban-36). */

  /* 40. Ban-35 — the three tabs under Add To Cart (Description, Shipping & Returns, Personalization) in one style.
         Nothing is changed in Shopify: the product descriptions keep their HTML, this only reads it and adds classes
         (styles: ez-personalize.css §40). Shipping & Returns and Personalization get EZ's own short text (below:
         edit it here); the theme's Customize text for those two tabs is not used by the theme. */
  var TABS = {
    shipping: [
      "Made to order for you, then shipped with tracking.",
      "Dates are estimates for US standard shipping. International orders may take a few extra days for customs.",
      "Canvas, posters and metal signs can't be delivered to PO boxes.",
      "Need to change or cancel? Contact us within 2 hours of ordering."
    ],
    returns: [
      "Damaged, defective or wrong item? We send a <strong>free replacement</strong>, no need to return it.",
      "Email us within 30 days of delivery with your order number and a photo.",
      "Each item is personalized for you, so we can't accept change-of-mind returns."
    ],
    steps: [
      "Fill in every field above and check the spelling.",
      "Use standard English letters and numbers. Emojis and special characters may not print.",
      "Uploading a photo? A clear, well-lit photo works best. <button type=\"button\" class=\"ezd-link\" data-ezd-guide>Photo tips</button>",
      "Tap <strong>Preview</strong> to check your design, then add it to your cart."
    ],
    note: "<strong>We print exactly what you enter.</strong> Please double-check spelling. Colors on screen can look slightly different from the printed item."
  };
  function tabOf(name) {
    var acc = document.querySelectorAll(".product__info-container > .product__accordion");
    for (var i = 0; i < acc.length; i++) {
      var t = acc[i].querySelector(".accordion__title");
      if (t && t.textContent.trim().toLowerCase().indexOf(name) === 0) return acc[i].querySelector(".accordion__content");
    }
    return null;
  }
  function list(items) {
    return '<ul class="ezd-dots">' + items.map(function (t) { return "<li>" + t + "</li>"; }).join("") + "</ul>";
  }
  /* Description: the store's HTML as it is, read and tidied (97% of products share one pattern:
     "<p><strong>PRODUCT DETAILS:</strong></p>" + lists, plus empty paragraphs used as spacers) */
  function tidyDescription() {
    var box = tabOf("description");
    var d = box && box.querySelector(".product__description");
    if (!d || d.hasAttribute("data-ezd")) return;
    d.setAttribute("data-ezd", "");
    d.classList.add("ezd");
    /* Ban-49: older descriptions carry <br> between blocks (</p><br><p>), at the start or end of a paragraph, or
       alone in a paragraph. Each added an empty line on top of the spacing the page already gives, so the gaps
       looked uneven. Those are removed here; a <br> between two lines of text stays. */
    var BLOCK = /^(P|UL|OL|LI|H[1-6]|DIV|TABLE|BLOCKQUOTE|HR|SECTION|FIGURE)$/;
    var near = function (n, dir) {
      n = n[dir];
      while (n && ((n.nodeType === 3 && !n.textContent.replace(/[\s\u00a0\u200b\ufeff]/g, "")) || n.nodeType === 8)) n = n[dir];
      return n;
    };
    var edge = function (n) { return !n || (n.nodeType === 1 && (BLOCK.test(n.tagName) || n.tagName === "BR")); };
    Array.prototype.slice.call(d.querySelectorAll("br")).forEach(function (br) {
      if (br.closest("table")) return;
      var prev = near(br, "previousSibling"), next = near(br, "nextSibling");
      var inBlock = br.parentNode === d || /^(P|LI)$/.test(br.parentNode.tagName);
      var afterBlock = prev && prev.nodeType === 1 && BLOCK.test(prev.tagName);   // "</h3><br>Text": an empty line
      if ((edge(prev) && edge(next)) || (inBlock && (!prev || !next)) || afterBlock) br.remove();
    });
    Array.prototype.forEach.call(d.querySelectorAll("p, div"), function (p) {
      if (p.children.length && p.querySelector("img, iframe, video, table")) return;
      if (!p.textContent.replace(/[\s\u00a0\u200b\ufeff]/g, "")) { p.classList.add("ezd-empty"); return; }
      /* a paragraph that is only a short bold label such as "PRODUCT DETAILS:" becomes a section heading */
      var txt = p.textContent.replace(/\s+/g, " ").trim();
      var bold = p.querySelector("strong, b");
      if (p.tagName === "P" && bold && bold.textContent.replace(/\s+/g, " ").trim() === txt && txt.length <= 40 && !/[.!?]$/.test(txt)) {
        p.classList.add("ezd-h");
        bold.textContent = txt.replace(/:\s*$/, "");
        if (/^(message|tags?|seo( keywords)?)$/i.test(bold.textContent)) p.classList.add("ezd-h--message");
      }
    });
    /* after "MESSAGE:" (and "TAGS:", "SEO KEYWORDS:"): a long comma-separated keyword list stays visible as small
       muted text; a short line after "MESSAGE" (the words printed on the product) gets a quote box; anything else,
       such as a full paragraph of copy, stays a normal paragraph */
    Array.prototype.forEach.call(d.querySelectorAll(".ezd-h--message"), function (h) {
      var n = h.nextElementSibling;
      while (n && n.classList.contains("ezd-empty")) n = n.nextElementSibling;
      if (!n || n.tagName !== "P" || n.classList.contains("ezd-h")) return;
      var text = n.textContent.replace(/\s+/g, " ").trim();
      var commas = (text.match(/,/g) || []).length;
      var titleLike = /\b(personali[sz]ed|custom|gifts?)\b/i.test(text);   // a product name, not a printed line
      if (commas >= 4 || (titleLike && commas >= 2) || !/^message$/i.test(h.textContent.trim())) n.classList.add("ezd-keywords");
      else if (!titleLike && text.length <= 140 && commas <= 3) n.classList.add("ezd-quote");
    });
    Array.prototype.forEach.call(d.querySelectorAll("table"), function (t) {
      if (t.parentNode.classList.contains("ezd-table")) return;
      var w = document.createElement("div");
      w.className = "ezd-table";
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
  }
  /* long descriptions: the first ~360px, then "Read more" (no box that scrolls on its own any more). Measured the
     first time the tab is open: a closed tab has no height yet. */
  function clampDescription(d) {
    if (!d || d.hasAttribute("data-ezd-measured") || !d.offsetHeight) return;
    d.setAttribute("data-ezd-measured", "");
    if (d.scrollHeight < 480) return;
    var box = d.closest(".accordion__content");
    d.classList.add("ezd-clamp");
    var b = document.createElement("button");
    b.type = "button";
    b.className = "ezd-more";
    b.setAttribute("aria-expanded", "false");
    b.textContent = "Read more";
    b.addEventListener("click", function () {
      var open = d.classList.toggle("ezd-clamp") === false;
      b.textContent = open ? "Show less" : "Read more";
      b.setAttribute("aria-expanded", String(open));
      if (!open) {
        var top = box.closest(".product__accordion").getBoundingClientRect().top;
        if (top < 0) window.scrollBy(0, top - 80);
      }
    });
    d.parentNode.insertBefore(b, d.nextSibling);
  }
  function buildShipping() {
    var box = tabOf("shipping");
    if (!box || box.hasAttribute("data-ezd")) return;
    box.setAttribute("data-ezd", "");
    var dl = box.querySelector(".timeline-delivered");
    var when = dl ? dl.textContent.replace(/\s+/g, " ").trim() : "";
    var html = '<div class="ezd ezd--tab">';
    if (when) html += '<div class="ezd-arrive"><div><strong>Arrives ' + when.replace(/[<>&]/g, "") + '</strong><span>if you order today</span></div><button type="button" class="ezd-link" data-ezd-ship>Details</button></div>';
    html += '<p class="ezd-h">Shipping</p>' + list(TABS.shipping) +
      '<p class="ezd-h">Returns &amp; replacements</p>' + list(TABS.returns) +
      '<p class="ezd-links"><a href="/pages/shipping-delivery">Shipping policy</a><a href="/pages/return-refund">Return &amp; refund policy</a></p></div>';
    box.innerHTML = html;
  }
  function buildPersonalization() {
    var box = tabOf("personali");
    if (!box || box.hasAttribute("data-ezd")) return;
    box.setAttribute("data-ezd", "");
    box.innerHTML = '<div class="ezd ezd--tab"><ol class="ezd-steps">' +
      TABS.steps.map(function (t, i) { return "<li" + (i === 2 ? ' class="ezd-photo-step"' : "") + ">" + t + "</li>"; }).join("") +
      '</ol><p class="ezd-note">' + TABS.note + "</p></div>";
  }
  /* the photo step only where the form has a photo field (Teeinblue draws the form later, so check on opening) */
  document.addEventListener("toggle", function (e) {
    var det = e.target;
    if (!det.open || !det.closest || !det.closest(".product__accordion")) return;
    clampDescription(det.querySelector(".product__description.ezd"));
    var step = det.querySelector(".ezd-photo-step");
    if (step) step.hidden = !document.querySelector("#tee-artwork-form .tee-field--photo, .tee-field--photo");
  }, true);
  window.addEventListener("click", function (e) {   /* Ban-66: window + stopped (see "Photo tips" above) */
    var t = e.target.closest && e.target.closest("[data-ezd-ship], [data-ezd-guide]");
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (t.hasAttribute("data-ezd-ship")) openShip(); else openGuide();
  }, true);
  function tidyTabs() { tidyDescription(); buildShipping(); buildPersonalization(); clampDescription(document.querySelector(".product__description.ezd")); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", tidyTabs);
  else tidyTabs();

  /* 41. Ban-38 — the gallery in the page changes picture smoothly (phones and computers).
         Teeinblue's own slider swapped pictures at once (arrows, small pictures), animated a swipe only after the
         finger was lifted and by moving "left" (layout work, jerky), and every new picture first showed an empty box
         with a spinner for about 0.2 s before Teeinblue drew it, even a picture already seen.
         Now: the picture follows the finger (or a mouse drag, or a sideways trackpad swipe) and the next one slides
         in beside it; arrows and small pictures slide the same way. The incoming picture is the small picture's own
         copy, enlarged on top, until Teeinblue has drawn the real one underneath, so nothing flashes. Only transform
         and opacity move (GPU). Teeinblue still owns which picture is shown: at the end of each slide its own arrow
         or small picture is clicked, exactly as before. Off while the floating "Live preview" card is up (§38).
         Ban-43 — the theme's gallery on computers (shown until the customer starts on the form) slides the same way:
         it switched at once and showed a white box (~0.14 s, longer on a slow line) while the next picture loaded.
         Its incoming picture is the big picture itself (the small one underneath until it has loaded), the theme's
         own small picture is clicked at the end, and the pictures next to the one shown load quietly ahead.
         Phones keep the theme's own swipe (the browser's scrolling, already smooth).
         The sideways-trackpad listener sits on the gallery only: page scrolling elsewhere never waits for it. */
  (function galleryGlide() {
    var DUR = 280, EASE = "cubic-bezier(.22, .8, .25, 1)";   // Ban-42: a little quicker (300 → 280 ms) — swipes, drags
    var TAP = 320, TAP_EASE = "cubic-bezier(.4, 0, .2, 1)";  // Ban-46: arrows and trackpad: gentle start and end
    var FADE = 200;                                       // Ban-44: small pictures fade, they do not slide
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var mq = window.matchMedia ? window.matchMedia("(min-width: 990px)") : null;
    var busy = false, pending = null, replaying = false, cover = null, drag = null, lastDragEnd = 0, wheelSum = 0, wheelLock = 0, wheelIdle = 0;
    function cardOn() { var c = document.body.classList; return c.contains("gallery--sticky") && !c.contains("gallery--sticky--hide"); }
    function wrapEl() { return document.querySelector(".grid__item.product__media-wrapper"); }
    /* Teeinblue's gallery */
    function teeCtx() {
      var w = wrapEl();
      if (!w || w.classList.contains("ezv-swap") || cardOn()) return null;   // still being laid out out of sight (§43)
      var g = w.querySelector(".tee-gallery");
      if (!g || g.closest("media-gallery")) return null;   // Ban-45: the Preview picture of the theme's gallery
      var slider = g.querySelector(".tee-slider"), track = g.querySelector(".tee-slider__track");
      if (!slider || !track) return null;
      var slides = track.querySelectorAll(":scope > .tee-slide"), a = -1;
      for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains("tee-slide--active")) { a = i; break; }
      if (slides.length < 2 || a < 0 || !slider.clientWidth) return null;
      var c = { kind: "t", g: g, slider: slider, track: track, slides: slides, a: a, n: slides.length, w: slider.clientWidth,
        thumbs: g.querySelectorAll(".tee-thumbnails .tee-thumbnail"),
        prev: g.querySelector(".tee-slider__button--prev"), next: g.querySelector(".tee-slider__button--next") };
      /* nothing of Teeinblue's to press at the end of a slide (markup changed?): stay out, its own swipe keeps working */
      return c.thumbs.length === c.n || (c.prev && c.next) ? c : null;
    }
    /* Ban-43: the theme's gallery (Dawn <media-gallery>), computers only */
    function dawnCtx() {
      if (!mq || !mq.matches) return null;
      var w = wrapEl(), mg = w && w.querySelector(":scope > media-gallery");
      if (!mg || !mg.offsetParent) return null;           // hidden while Teeinblue's gallery is shown
      var slider = mg.querySelector(":scope > slider-component:not(.thumbnail-slider)");
      var track = slider && slider.querySelector(".product__media-list"), tl = mg.querySelector(".thumbnail-list");
      if (!track || !tl || !slider.clientWidth) return null;
      var slides = [], thumbs = [], a = -1;
      Array.prototype.forEach.call(track.querySelectorAll(":scope > [data-media-id]"), function (s) {
        var id = s.getAttribute("data-media-id");
        var t = tl.querySelector('.thumbnail-list__item[data-target="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]');
        var b = t && t.offsetParent !== null && t.querySelector("button");
        if (!b) return;                                    // a picture the theme does not offer (other variant)
        if (s.classList.contains("is-active")) a = slides.length;
        slides.push(s);
        thumbs.push(b);
      });
      if (slides.length < 2 || a < 0) return null;
      return { kind: "d", g: mg, slider: slider, track: track, slides: slides, a: a, n: slides.length, w: slider.clientWidth,
        thumbs: thumbs, prev: slider.querySelector(".ezv-arrow--prev"), next: slider.querySelector(".ezv-arrow--next") };
    }
    function ctx() { return teeCtx() || dawnCtx(); }
    function within(e, c) { return c && e.target && e.target.closest && c.slider.contains(e.target); }
    function fill(el, fit) {
      el.removeAttribute("id");
      el.style.cssText = "position:absolute;left:0;top:0;width:100%;height:100%;object-fit:" + fit + ";opacity:1;transform:none";
      return el;
    }
    /* the incoming picture: the small picture's drawing, enlarged to the slide's size (Teeinblue); the big picture
       itself over the small one (theme) */
    function peek(c, i) {
      var p = document.createElement("div");
      p.className = "ezg-peek";
      var t = c.thumbs.length === c.n ? c.thumbs[i] : null, src = t && t.querySelector(".tee-mockup");
      var kept = c.kind === "t" && fromCache(c, i), still = c.kind === "t" && t && t.querySelector("img");
      var live = c.kind === "d" && c.slides[i].classList.contains("ezv-design") && c.slides[i].querySelector(".tee-slide--active .tee-mockup");
      if (live) {                                        // Ban-45: the Preview picture, as Teeinblue shows it now
        var lm = live.cloneNode(true), lw = parseFloat(live.style.width) || c.w, lh = parseFloat(live.style.height) || c.w;
        lm.style.position = "absolute";
        lm.style.left = Math.round((c.w - lw) / 2) + "px";
        lm.style.top = Math.round((c.slider.clientHeight - lh) / 2) + "px";
        lm.style.transform = "none";
        p.appendChild(lm);
      } else if (kept) p.appendChild(kept);                     // Ban-44: the picture as Teeinblue last drew it (same design)
      else if (still && !src) {                          // Ban-44: "Static" small pictures are plain images
        p.appendChild(fill(still.cloneNode(false), "contain"));
        p.classList.add("is-still");
      } else if (src && src.offsetWidth) {
        var k = c.w / src.offsetWidth, m = src.cloneNode(true);
        m.style.transform = "scale(" + k + ")";
        m.style.transformOrigin = "0 0";
        m.style.position = "absolute";
        m.style.left = Math.round((c.w - src.offsetWidth * k) / 2) + "px";
        m.style.top = Math.round((c.slider.clientHeight - src.offsetHeight * k) / 2) + "px";
        p.appendChild(m);
      } else if (c.kind === "d") {
        var cur = c.slides[c.a].querySelector("img"), fit = (cur && window.getComputedStyle(cur).objectFit) || "cover";
        var small = t && t.querySelector("img"), big = c.slides[i].querySelector("img");
        if (small) p.appendChild(fill(small.cloneNode(false), fit));
        if (big) { var b = fill(big.cloneNode(false), fit); b.loading = "eager"; p.appendChild(b); }
        if (!small && !big) p.classList.add("is-empty");
      } else p.classList.add("is-empty");
      c.slider.appendChild(p);
      return p;
    }
    /* Ban-44: what Teeinblue has drawn for each picture, kept for its next slide-in while the design is unchanged
       (Teeinblue takes ~0.2 s to draw a picture seen for the first time; the "Static" small pictures are 150px) */
    var kept = window.WeakMap ? new WeakMap() : null, version = 0;
    function mockOf(slide) { return slide && slide.querySelector(".tee-mockup"); }
    function remember(c, i) {
      if (!kept || c.kind !== "t" || !drawn(c, i)) return;
      var s = c.slides[i], m = mockOf(s);
      if (!m || !m.offsetWidth) return;
      var sr = c.slider.getBoundingClientRect(), mr = m.getBoundingClientRect(), tx = 0;
      var tr = s.style.transform.match(/translate3d\((-?[\d.]+)px/);
      if (tr) tx = parseFloat(tr[1]);
      kept.set(s, { v: version, w: c.w, node: m.cloneNode(true), left: Math.round(mr.left - sr.left - tx), top: Math.round(mr.top - sr.top) });
    }
    function placed(k) {
      var n = k.node.cloneNode(true);
      n.style.position = "absolute";
      n.style.left = k.left + "px";
      n.style.top = k.top + "px";
      n.style.margin = "0";
      n.style.transform = "none";
      return n;
    }
    function fromCache(c, i) {
      var k = kept && kept.get(c.slides[i]);
      return k && k.v === version && k.w === c.w ? placed(k) : null;
    }
    /* a copy of the picture shown now, to move out while Teeinblue already shows the next one underneath */
    function snapshot(c) {
      var o = document.createElement("div");
      o.className = "ezg-peek";
      remember(c, c.a);
      var k = kept && kept.get(c.slides[c.a]);
      if (k && k.v === version && k.w === c.w) o.appendChild(placed(k));
      else o.classList.add("is-empty");
      c.slider.appendChild(o);
      return o;
    }
    /* any choice in Teeinblue's form changes the design: copies kept so far are out of date */
    ["change", "input"].forEach(function (t) {
      document.addEventListener(t, function (e) {
        if (e.target && e.target.closest && !e.target.closest(".tee-gallery-content") && e.target.closest('[class*="tee-"], [id^="tee-"]')) version++;
      }, true);
    });
    function put(el, x, ms, ease) {
      el.style.transition = ms ? "transform " + ms + "ms " + (ease || EASE) : "none";
      el.style.transform = "translate3d(" + Math.round(x * 10) / 10 + "px,0,0)";
    }
    function clean(el) { if (el) { el.style.transition = ""; el.style.transform = ""; } }
    function drawn(c, i) {
      var s, ok;
      if (c.kind === "t") {
        s = c.track.querySelectorAll(":scope > .tee-slide")[i];
        ok = !!(s && s.classList.contains("tee-slide--active") && s.querySelector(".tee-mockup, video"));
        if (ok) Array.prototype.forEach.call(s.querySelectorAll(".tee-mockup img"), function (im) { if (!im.complete) ok = false; });
        var ld = ok && s.querySelector(".tee-image--loader");
        if (ld && ld.offsetParent !== null) ok = false;     // Teeinblue's spinner still up
        return ok;
      }
      s = c.slides[i];
      ok = !!(s && s.classList.contains("is-active"));
      var imgs = s && s.classList.contains("ezv-design") ? s.querySelectorAll(".tee-slide--active .tee-mockup img") : s && s.querySelectorAll("img");
      if (ok) Array.prototype.forEach.call(imgs, function (im) { if (!im.complete || !im.naturalWidth) ok = false; });
      return ok;
    }
    /* theme's gallery: the pictures next to the one shown load now (the theme loads a picture only once shown) */
    /* Ban-46: and decoded ahead, so the first slide to a picture does not wait for the browser to decode it (that
       wait came at the start of the slide: the picture stood still, then caught up too fast) */
    function warm(c, all) {
      if (!c || c.kind !== "d") return;
      (all ? c.slides.map(function (s, k) { return k - c.a; }) : [1, -1, 2]).forEach(function (k) {
        var im = c.slides[(c.a + k + c.n) % c.n].querySelector("img");
        if (!im || im.__ezgWarm) return;
        im.__ezgWarm = 1;
        if (im.loading === "lazy") im.loading = "eager";
        if (im.decode) im.decode().catch(function () {});
      });
    }
    /* the incoming copy's pictures decoded before it starts moving (at most 150 ms) */
    function ready(p, fn) {
      var imgs = p.querySelectorAll("img"), jobs = [];
      Array.prototype.forEach.call(imgs, function (im) { if (im.decode) jobs.push(im.decode().catch(function () {})); });
      if (!jobs.length || !window.Promise) { fn(); return; }
      var done = false, go1 = function () { if (done) return; done = true; requestAnimationFrame(fn); };
      Promise.all(jobs).then(go1);
      setTimeout(go1, 150);
    }
    /* after the switch: the copy stays on top ("cover") until the real picture is drawn underneath, then fades.
       A new swipe may start meanwhile: the cover then moves with the picture it covers. */
    function settle(c, i, p) {
      var t0 = Date.now();
      cover = p;
      (function wait() {
        if (cover !== p) return;                          // carried away by the next slide
        if (!drawn(c, i) && Date.now() - t0 < 1500) { setTimeout(wait, 30); return; }
        remember(c, i);                                   // Ban-44: kept for the next time this picture slides in
        var real = c.kind === "d" && c.slides[i] && c.slides[i].querySelector("img");
        var fadeOut = function () {
          if (cover !== p) return;                       // a new slide took it along meanwhile
          cover = null;
          p.style.transition = "opacity .12s ease";
          p.style.opacity = "0";
          setTimeout(function () { drop(p); }, 130);
        };
        /* Ban-46: the real picture painted before the copy on top fades (else a pale frame between the two) */
        if (real && real.decode && window.Promise) {
          var once = false, f1 = function () { if (once) return; once = true; requestAnimationFrame(function () { requestAnimationFrame(fadeOut); }); };
          real.decode().then(f1, f1);
          setTimeout(f1, 120);
        } else fadeOut();
        warm(dawnCtx());
      })();
    }
    function drop(el) { if (el && el.parentNode) el.parentNode.removeChild(el); }
    /* the end of a running slide, run at its time or at once when a new swipe starts before it is over */
    function later(fn, ms) {
      var t = setTimeout(run, ms);
      function run() { clearTimeout(t); if (pending === run) pending = null; fn(); }
      pending = run;
    }
    function finishNow() { if (pending) pending(); }
    function moveCur(c, x, ms) { put(c.slides[c.a], x, ms); if (cover) put(cover, x, ms); }
    function triggerFor(c, i, dir) {
      if (c.thumbs.length === c.n && c.thumbs[i]) return c.thumbs[i];
      return dir > 0 ? c.next : c.prev;
    }
    /* slide from the current position (x: how far the finger already moved it) to picture i.
       Ban-44: fade (small pictures): the new picture fades in where it is, with no direction.
       Ban-44: Teeinblue switches at the start, not at the end: it draws the new picture (~0.2 s the first time)
       while the copies move, so the real picture is ready when the slide ends; a copy of the old one moves out. */
    function go(c, i, dir, x, p, trigger, fade) {
      var cur = c.slides[c.a], old = cover, out = null;
      p = p || peek(c, i);
      trigger = trigger || triggerFor(c, i, dir);
      if (!trigger) { drop(p); moveCur(c, 0, 0); clean(cur); return; }
      busy = true;
      cover = null;
      var tap = !x && !fade, ease = tap ? TAP_EASE : EASE;
      var ms = reduce ? 0 : fade ? FADE : tap ? TAP : Math.max(160, Math.round(DUR * (1 - Math.abs(x || 0) / c.w)));
      if (c.kind === "t") {
        out = old || snapshot(c);
        if (!old) put(out, x || 0, 0);
        old = null;
        clean(cur);
        /* after the click being handled is over: a button cannot be clicked again from inside its own click */
        setTimeout(function () {
          replaying = true;
          try { trigger.click(); } catch (err) {}         // Teeinblue switches picture, as with its own buttons
          replaying = false;
        }, 0);
      }
      ready(p, function () {
      void p.offsetWidth;                                // start from where it is now
      if (fade) {
        p.style.transition = ms ? "opacity " + ms + "ms ease" : "none";
        p.style.opacity = "1";
      } else {
        put(out || cur, -dir * c.w, ms, ease);
        if (old) put(old, -dir * c.w, ms, ease);
        put(p, 0, ms, ease);
      }
      later(function () {
        if (c.kind !== "t") {
          replaying = true;
          try { trigger.click(); } catch (err) {}         // the theme's gallery switches picture, as with its own buttons
          replaying = false;
          clean(cur);
        }
        drop(out);
        drop(old);
        busy = false;
        settle(c, i, p);
      }, ms + 20);
      });
    }

    /* arrows and small pictures */
    document.addEventListener("click", function (e) {
      if (replaying || !e.target.closest) return;
      var b = e.target.closest(".tee-slider__button, .tee-thumbnails .tee-thumbnail, .ezv-arrow, media-gallery .thumbnail-list .thumbnail");
      if (!b) return;
      var c = ctx();
      if (!c || !c.g.contains(b)) return;
      if (busy && pending) { finishNow(); c = ctx(); }    // Ban-43: a quick second press counts: the slide running ends at once
      if (busy || !c) { e.preventDefault(); e.stopPropagation(); return; }
      var i = Array.prototype.indexOf.call(c.thumbs, b), dir;
      if (i >= 0) {
        if (i === c.a || c.thumbs.length !== c.n) return;
        dir = i > c.a ? 1 : -1;
      } else if (b.classList.contains("tee-slider__button") || b.classList.contains("ezv-arrow")) {
        dir = /--next/.test(b.className) ? 1 : -1;
        i = (c.a + dir + c.n) % c.n;
      } else return;
      e.preventDefault();
      e.stopPropagation();
      var fade = Array.prototype.indexOf.call(c.thumbs, b) >= 0;   // Ban-44: a small picture fades the big one in
      var p = peek(c, i);
      if (fade) { put(p, 0, 0); p.style.opacity = "0"; } else put(p, dir * c.w, 0);
      go(c, i, dir, 0, p, c.kind === "t" ? b : triggerFor(c, i, dir), fade);
    }, true);

    /* drag: finger or mouse */
    document.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      if (drag && drag.id !== e.pointerId && e.isPrimary)               // the last touch never ended (lost): drop it
        release({ type: "pointercancel", pointerId: drag.id, timeStamp: e.timeStamp });
      if (drag) return;
      if (busy && pending && ctx() && within(e, ctx())) finishNow();      // swiping again before the slide ended: end it now
      if (busy) return;
      var c = ctx();
      if (!within(e, c) || e.target.closest(".tee-slider__button, .ezv-arrow")) return;
      drag = { c: c, id: e.pointerId, x0: e.clientX, y0: e.clientY, dx: 0, on: false, dir: 0, p: null, lx: e.clientX, lt: e.timeStamp, v: 0 };
    }, true);
    document.addEventListener("pointermove", function (e) {
      var d = drag;
      if (!d || e.pointerId !== d.id) return;
      var dx = e.clientX - d.x0, dy = e.clientY - d.y0;
      if (!d.on) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; }   // up/down: the page scrolls as usual
        d.c = ctx();                                      // read again: Teeinblue may have just switched picture
        if (!d.c) { drag = null; return; }
        d.on = true;
        d.c.slider.classList.add("ezg-dragging");
      }
      if (e.cancelable) e.preventDefault();
      var dir = dx < 0 ? 1 : -1;
      if (dir !== d.dir) {                               // the picture coming in from that side
        if (d.p && d.p.parentNode) d.p.parentNode.removeChild(d.p);
        d.dir = dir;
        d.i = (d.c.a + dir + d.c.n) % d.c.n;
        d.p = peek(d.c, d.i);
      }
      d.dx = dx;
      var dt = e.timeStamp - d.lt;
      if (dt > 0) { d.v = (e.clientX - d.lx) / dt; d.lx = e.clientX; d.lt = e.timeStamp; }
      moveCur(d.c, dx, 0);
      put(d.p, dx + dir * d.c.w, 0);
    }, { capture: true, passive: false });
    function release(e) {
      var d = drag;
      if (!d || (e && e.pointerId !== d.id)) return;
      drag = null;
      if (!d.on) return;
      d.c.slider.classList.remove("ezg-dragging");
      lastDragEnd = Date.now();
      if (e && e.timeStamp - d.lt > 90) d.v = 0;            // held still before letting go: no flick
      var far = Math.abs(d.dx) > d.c.w * 0.14 || (Math.abs(d.v) > 0.28 && Math.abs(d.dx) > 20 && (d.v < 0) === (d.dir > 0));   // Ban-42: lighter (was 18% / 0.35)
      if (e && e.type === "pointerup" && far) { go(d.c, d.i, d.dir, d.dx, d.p); return; }
      var cur = d.c.slides[d.c.a], p = d.p, ms = reduce ? 0 : 240;   // not far enough: back into place
      busy = true;
      moveCur(d.c, 0, ms);
      put(p, d.dir * d.c.w, ms);
      later(function () { clean(cur); drop(p); busy = false; }, ms + 20);
    }
    document.addEventListener("pointerup", release, true);
    document.addEventListener("pointercancel", release, true);
    /* no click (theme: no zoom window) and no native image drag at the end of a drag */
    document.addEventListener("click", function (e) {
      if (Date.now() - lastDragEnd < 350 && e.target.closest && e.target.closest(".tee-slider__track, media-gallery .product__media-list")) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    document.addEventListener("dragstart", function (e) {
      var c = e.target.closest && e.target.closest(".tee-slider, media-gallery .product__media-list") ? ctx() : null;
      if (c && c.slider.contains(e.target)) e.preventDefault();
    }, true);
    /* Teeinblue's own swipe (touch events on its track) is replaced by the above: stopped on the way down */
    ["touchstart", "touchmove", "touchend", "touchcancel"].forEach(function (t) {
      document.addEventListener(t, function (e) {
        if (!e.target.closest || !e.target.closest(".tee-slider__track")) return;
        var c = teeCtx();
        if (c && c.track.contains(e.target)) e.stopPropagation();
      }, { capture: true, passive: true });
    });
    /* sideways trackpad swipe (computers): one picture per gesture. Ban-43: listened to on the gallery only (it must
       be able to stop the browser's "back" gesture there, which makes the browser wait for it before scrolling) */
    function onWheel(e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || e.ctrlKey) return;
      var c = ctx();
      if (!within(e, c)) return;
      e.preventDefault();                                 // no "back" gesture of the browser over the picture
      clearTimeout(wheelIdle);
      wheelIdle = setTimeout(function () { wheelSum = 0; wheelLock = 0; }, 220);
      if (wheelLock || busy) return;
      wheelSum += e.deltaX;
      if (Math.abs(wheelSum) < 50) return;
      wheelLock = 1;
      var dir = wheelSum > 0 ? 1 : -1, i = (c.a + dir + c.n) % c.n, p = peek(c, i);
      put(p, dir * c.w, 0);
      go(c, i, dir, 0, p);
    }
    function start() {
      var w = wrapEl();
      if (w) w.addEventListener("wheel", onWheel, { passive: false });
      /* the pictures next to the first one: once the page has loaded, out of the way of the first picture */
      var idle = function () { warm(dawnCtx()); setTimeout(function () { warm(dawnCtx(), true); }, 1500); };   // Ban-46: then all
      var later2 = function () { if (window.requestIdleCallback) window.requestIdleCallback(idle, { timeout: 2500 }); else setTimeout(idle, 600); };
      if (document.readyState === "complete") later2(); else window.addEventListener("load", later2);
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  })();

  /* 42. Ban-39 → 42 — the small pictures of both galleries, the same everywhere.
         Two galleries take turns on the product page: the theme's (Dawn <media-gallery>, shown first since Teeinblue
         no longer loads its gallery when the page opens) and Teeinblue's (once the customer starts on the form, or at
         once for a saved design). ez-personalize.css (§42) gives both the same small pictures:
         - computers (990px+): a column on the left of the big picture (80px; 64px when the gallery is under 640px
           wide, 56px under 520px); page columns and form column keep their width (big picture 619px at 1366px);
           ↑ ↓ buttons on the column when it scrolls, ‹ › buttons on the big picture of both galleries (Ban-42);
         - phones and tablets: one row of 56px pictures under the big picture, swiped with the finger (Ban-42; the
           theme showed dots, Teeinblue a row of 90px pictures moved only by its buttons).
         This part:
         - marks the gallery column ("ezv" Teeinblue's column, "ezv-d" the theme's column, "ezv-m" phone rows), so the
           layout also works where the browser lacks :has();
         - shrinks Teeinblue's drawing of each small picture to the box (Teeinblue draws them 90-174px);
         - has Teeinblue measure again if it measured before the column was there;
         - keeps the chosen small picture in view; adds the buttons; shows ↑ ↓ only when there is more to see. */
  (function thumbColumn() {
    var mq = window.matchMedia ? window.matchMedia("(min-width: 990px)") : null;
    var wrap = null, busy = 0, measured = 0, shown = null, was = false;
    var CHEV = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
    function desk() { return !!(mq && mq.matches); }
    function teeBox() { var c = wrap.querySelector(":scope > .tee-gallery-content"); return c && !wrap.classList.contains("ezv-swap") ? c : null; }
    function teeOn() { var c = wrap.querySelector(":scope > .tee-gallery-content"); return !!(c && c.querySelector(".tee-thumbnail + .tee-thumbnail")); }
    function dawn() { return wrap.querySelector(":scope > media-gallery"); }
    function dawnOn() {
      var mg = dawn();
      return !!(mg && (mg.getAttribute("data-desktop-layout") || "thumbnail_slider") === "thumbnail_slider" &&
        mg.querySelector(".thumbnail-list__item + .thumbnail-list__item"));
    }
    function sizes() {
      var w = wrap.clientWidth, t = w < 520 ? 56 : w < 640 ? 64 : 80, gap = t === 80 ? 12 : t === 64 ? 10 : 8;
      if (wrap.style.getPropertyValue("--ezv-t") !== t + "px") {
        wrap.style.setProperty("--ezv-t", t + "px");
        wrap.style.setProperty("--ezv-col", t + gap + "px");
      }
      return t;
    }
    function shrink(t) {
      var col = wrap.querySelector(":scope > .tee-gallery-content .tee-thumbnails"), m = col && col.querySelector(".tee-thumbnail .tee-mockup");
      if (!m || !m.offsetWidth) return;
      var k = (t / m.offsetWidth).toFixed(4);
      if (col.style.getPropertyValue("--ezv-k") !== k) col.style.setProperty("--ezv-k", k);
    }
    function remeasure() {
      var g = wrap.querySelector(":scope > .tee-gallery-content .tee-gallery"), sl = g && g.querySelector(".tee-slider");
      if (!sl || !g.clientWidth || Math.abs(sl.offsetWidth - g.clientWidth) <= 1) return;
      if (Date.now() - measured < 400) return;            // once at a time: Teeinblue answers a window resize
      measured = Date.now();
      window.dispatchEvent(new Event("resize"));
    }
    /* the visible gallery's list of small pictures, its chosen one, and how to choose another */
    function current() {
      var tee = teeBox();
      if (tee && tee.querySelector(".tee-thumbnail + .tee-thumbnail") && !tee.closest("media-gallery")) {
        var tl = tee.querySelector(".tee-thumbnails");
        return { kind: "t", col: tl, host: tee.querySelector(".tee-gallery"), items: tl.querySelectorAll(".tee-thumbnail"),
          active: tl.querySelector(".tee-thumbnail--active"),
          go: function (dir) { var b = tee.querySelector(dir > 0 ? ".tee-slider__button--next" : ".tee-slider__button--prev"); if (b) b.click(); } };
      }
      var mg = dawn(); if (!mg) return null;
      var dl = mg.querySelector(".thumbnail-list"); if (!dl) return null;
      var items = dl.querySelectorAll(".thumbnail-list__item"), cur = dl.querySelector(".thumbnail[aria-current]");
      return { kind: "d", col: dl, host: mg, items: items, active: cur && cur.closest(".thumbnail-list__item"),
        go: function (dir) {
          var list = Array.prototype.filter.call(items, function (li) { return li.offsetParent !== null; });
          var i = list.indexOf(cur && cur.closest(".thumbnail-list__item")), n = list.length;
          if (!n) return;
          var b = list[((i < 0 ? 0 : i) + dir + n) % n].querySelector(".thumbnail");
          if (b) b.click();
        } };
    }
    function keepInView(c) {
      if (!c || !c.active || !c.col.clientHeight) return;
      var vertical = desk();
      var key = c.kind + Array.prototype.indexOf.call(c.items, c.active) + ":" + c.col.clientWidth + "x" + c.col.clientHeight + ":" + (vertical ? c.col.scrollHeight : c.col.scrollWidth);
      if (key === shown) return;                          // only when the chosen picture (or the list) changes
      shown = key;
      var b = c.col.getBoundingClientRect(), r = c.active.getBoundingClientRect(), d = 0;
      if (vertical) {
        if (c.col.scrollHeight <= c.col.clientHeight + 1) return;
        if (r.top < b.top + 34) d = r.top - b.top - 34; else if (r.bottom > b.bottom - 34) d = r.bottom - b.bottom + 34;   // clear of the 30px up/down bars
        if (d) c.col.scrollBy({ top: d, behavior: "smooth" });
      } else {
        if (c.col.scrollWidth <= c.col.clientWidth + 1) return;
        if (r.left < b.left + 12) d = r.left - b.left - 12; else if (r.right > b.right - 12) d = r.right - b.right + 12;   // 12px = the row's side padding
        if (d) c.col.scrollBy({ left: d, behavior: "smooth" });
      }
    }
    /* ‹ › on the theme's big picture (Teeinblue's has its own, styled the same in §42 CSS) */
    function mainArrows(mg) {
      var viewer = mg.querySelector(":scope > slider-component:not(.thumbnail-slider)");
      if (!viewer || viewer.querySelector(":scope > .ezv-arrow")) return;
      ["prev", "next"].forEach(function (k) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "ezv-arrow ezv-arrow--" + k;
        b.setAttribute("aria-label", k === "prev" ? "Previous image" : "Next image");
        b.innerHTML = CHEV;
        b.addEventListener("click", function (e) { e.preventDefault(); var c = current(); if (c && c.kind === "d") c.go(k === "prev" ? -1 : 1); });
        viewer.appendChild(b);
      });
    }
    /* ↑ ↓ on the column of small pictures, shown only when it scrolls that way */
    function colArrows(c) {
      var host = c.host; if (!host) return;
      var up = host.querySelector(":scope > .ezv-colnav--up"), down = host.querySelector(":scope > .ezv-colnav--down");
      if (!up) {
        [["up", -1], ["down", 1]].forEach(function (p) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "ezv-colnav ezv-colnav--" + p[0];
          b.setAttribute("aria-label", p[1] < 0 ? "Scroll thumbnails up" : "Scroll thumbnails down");
          b.innerHTML = CHEV;
          b.addEventListener("click", function (e) {
            e.preventDefault();
            var cc = current(); if (!cc) return;
            cc.col.scrollBy({ top: p[1] * Math.max(80, cc.col.clientHeight - 90), behavior: "smooth" });
          });
          host.appendChild(b);
        });
        up = host.querySelector(":scope > .ezv-colnav--up"); down = host.querySelector(":scope > .ezv-colnav--down");
      }
      if (!c.col.__ezvScroll) {
        c.col.__ezvScroll = true;
        c.col.addEventListener("scroll", function () { queue(); }, { passive: true });
      }
      var more = c.col.scrollHeight > c.col.clientHeight + 1;
      up.classList.toggle("is-on", more && c.col.scrollTop > 2);
      down.classList.toggle("is-on", more && c.col.scrollTop + c.col.clientHeight < c.col.scrollHeight - 2);
    }
    function run() {
      busy = 0;
      wrap = wrap && wrap.isConnected ? wrap : document.querySelector(".grid__item.product__media-wrapper");
      if (!wrap) return;
      var dk = desk(), t = teeOn(), d = dawnOn();
      wrap.classList.toggle("ezv", dk && t);
      wrap.classList.toggle("ezv-d", dk && d);
      wrap.classList.toggle("ezv-m", !dk && (t || d));
      if (!t && !d) {
        if (wrap.style.getPropertyValue("--ezv-t")) { wrap.style.removeProperty("--ezv-t"); wrap.style.removeProperty("--ezv-col"); }
        if (was) remeasure();
        was = false;
        return;
      }
      var size = dk ? sizes() : 56;
      if (!dk && wrap.style.getPropertyValue("--ezv-t")) { wrap.style.removeProperty("--ezv-t"); wrap.style.removeProperty("--ezv-col"); }
      if (t) { shrink(size); if (dk) { was = true; remeasure(); } }
      var mg = dawn();
      if (dk && d && mg) mainArrows(mg);
      var c = current();
      if (c && dk) colArrows(c);
      keepInView(c);
    }
    function queue() { if (!busy) busy = requestAnimationFrame(run); }
    function start() {
      wrap = document.querySelector(".grid__item.product__media-wrapper");
      if (!wrap) return;
      /* Ban-42: no longer every style change inside the gallery (Teeinblue restyles its layers on each choice) */
      new MutationObserver(queue).observe(wrap, { subtree: true, childList: true, attributes: true, attributeFilter: ["class", "aria-current"] });
      /* the floating Live preview on phones only switches a class on <body>: the row is measured again when it comes back */
      new MutationObserver(queue).observe(document.body, { attributes: true, attributeFilter: ["class"] });
      window.addEventListener("resize", queue);
      if (mq) { if (mq.addEventListener) mq.addEventListener("change", queue); else if (mq.addListener) mq.addListener(queue); }
      queue();
    }
    window.ezvQueue = function () { queue(); };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  })();

  /* 43. Ban-41 — the switch from the theme's gallery to Teeinblue's, without a blank, a jump or a jolt.
         Teeinblue puts its own gallery in the theme's place when the customer starts on the form (at once for a saved
         design). Before, the theme's picture vanished the moment Teeinblue's empty gallery arrived (spinner ~0.25 s),
         and on phones the gallery grew ~45px, pushing the form down under the finger.
         - Teeinblue's gallery is laid out out of sight first; the theme's stays until Teeinblue's picture is drawn
           (at most 2.5 s), then fades out on top of it (0.25 s).
         - Ban-42: when Teeinblue's gallery has a single picture ("only one mockup" in Teeinblue, or a product with one
           mockup), it is not swapped in: §44 puts it first in the theme's gallery instead.
         - At the switch, what the customer is looking at (the form) is measured before and after; if it moved, the
           page is moved back by the same amount (no double move where the browser already held it still).
         - Later height changes of the gallery while it is above the top of the screen (the floating Live preview
           giving the gallery back): the page is moved by the same amount, only in browsers that do not hold the page
           still themselves (Safari). */
  (function gallerySwap() {
    var wrap = null, started = false, lastH = 0, lastW = 0;
    var anchors = !!(window.CSS && CSS.supports && CSS.supports("overflow-anchor", "auto"));
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function ready(c) {
      var s = c.querySelector(".tee-slide--active"), ok = !!(s && s.querySelector(".tee-mockup, video"));
      if (ok) Array.prototype.forEach.call(s.querySelectorAll(".tee-mockup img"), function (im) { if (!im.complete) ok = false; });
      return ok;
    }
    /* what the customer is looking at (below the gallery): it must not move when the gallery changes height */
    function anchor() {
      var w = wrap.getBoundingClientRect();
      if (w.top >= 0 || w.bottom > window.innerHeight * 0.5) return null;   // gallery itself in view: let it grow
      var el = document.elementFromPoint(window.innerWidth / 2, window.innerHeight * 0.5);
      return el && !wrap.contains(el) ? { el: el, top: el.getBoundingClientRect().top } : null;
    }
    function hold(a) {
      if (a && a.el.isConnected) {                         // browsers that hold the page still have done it already
        var moved = Math.round(a.el.getBoundingClientRect().top - a.top);
        if (moved) window.scrollBy(0, moved);
      }
    }
    /* Ban-67: during the switch the browser's own "hold the page still" is off and hold() alone keeps the form where
       it was. With both on, the first choice after the page opened (phones / tablets, < 990 px) moved the form up by
       ~137 px (measured on TEST 5 at 840 px: form 148 px → 11 px from the top; with only hold(): stays at 148 px). */
    var anchorWas = null;
    /* Ban-107: phones (< 750 px) keep the browser's own "hold the page still" on. With it off, the first edit on a
       phone moved the page up ~387 px (TEST 11, 9 products, e.g. 522 → 135, the field ending under the keyboard);
       with it on the page stays (522 → 522, field at y 384), and hold() then finds nothing left to correct. */
    function anchorOff() {
      if (!anchors || anchorWas !== null || window.innerWidth < 750) return;
      anchorWas = document.documentElement.style.overflowAnchor || "";
      document.documentElement.style.overflowAnchor = "none";
    }
    function anchorOn() {
      if (anchorWas === null) return;
      var was = anchorWas;
      anchorWas = null;
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        if (anchorWas === null && document.documentElement.style.overflowAnchor === "none") document.documentElement.style.overflowAnchor = was;
      }); });
    }
    function finish(c) {
      var mg = wrap.querySelector(":scope > media-gallery");
      var top = mg ? mg.getBoundingClientRect().top - wrap.getBoundingClientRect().top : 0;
      var a = anchor();
      if (window.ezvDesign && window.ezvDesign.put(c)) {   // Ban-45: the Preview picture of the theme's gallery (§44)
        wrap.classList.remove("ezv-swap", "ezv-pos");
        lastH = Math.round(wrap.getBoundingClientRect().height);
        hold(a);
        anchorOn();
        return;
      }
      wrap.classList.remove("ezv-swap");
      lastH = Math.round(wrap.getBoundingClientRect().height);
      hold(a);
      anchorOn();
      if (!mg || reduce) return;
      mg.style.setProperty("--ezv-fade-top", Math.round(top) + "px");
      wrap.classList.add("ezv-fade");                      // the theme's gallery, on top, fading out
      setTimeout(function () { wrap.classList.remove("ezv-fade", "ezv-pos"); mg.style.removeProperty("--ezv-fade-top"); }, 280);
    }
    function begin(c) {
      if (started) return;
      started = true;
      var mg = wrap.querySelector(":scope > media-gallery");
      if (!mg || !mg.querySelector("img")) return;         // nothing of the theme's to keep on screen
      anchorOff();                                         // Ban-67 (see hold)
      if (window.getComputedStyle(wrap).position === "static") wrap.classList.add("ezv-pos");   // Ban-45 (see CSS §43)
      wrap.classList.add("ezv-swap");
      var t0 = Date.now();
      (function wait() {
        if (!c.isConnected) { wrap.classList.remove("ezv-swap"); anchorOn(); return; }
        if (!ready(c) && Date.now() - t0 < 2500) { setTimeout(wait, 50); return; }
        finish(c);
      })();
    }
    function look() {
      var c = wrap.querySelector(":scope > .tee-gallery-content");
      if (c) begin(c);
    }
    function onResize() {
      var r = wrap.getBoundingClientRect(), h = Math.round(r.height);
      if (anchors || !lastH || window.innerWidth !== lastW || wrap.classList.contains("ezv-swap")) { lastH = h; lastW = window.innerWidth; return; }
      var dh = h - lastH;
      lastH = h;
      if (dh && r.top < 0) window.scrollBy(0, dh);
    }
    function start() {
      wrap = document.querySelector(".grid__item.product__media-wrapper");
      if (!wrap) return;
      look();
      if (!started) {
        var mo = new MutationObserver(function () { look(); if (started) mo.disconnect(); });
        mo.observe(wrap, { childList: true });
      }
      lastW = window.innerWidth;
      if (window.ResizeObserver) new ResizeObserver(onResize).observe(wrap);
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  })();

  /* 44. Ban-42 → 45 — the theme's gallery stays the gallery the customer browses; Teeinblue's picture (the Live
         preview, with the customer's design) becomes its first picture.
         Teeinblue's own gallery has one picture with the design (Live preview) and the product's other mockups as
         still pictures (checked on TEST 5, 15/10), and it draws each picture only when it is shown (~0.2 s for a new
         one, again after every choice), so browsing it never felt like the theme's gallery. Ban-45 (owner, 15/10):
         - when Teeinblue puts its gallery in the page, its box is moved into a new first slide of the theme's
           gallery, with a "Preview" small picture first in the column / row; the big picture fades to it;
         - Teeinblue keeps drawing and updating that picture itself, showing the picture it chooses (it returns to
           the Live preview after each choice); its small pictures and arrows are hidden; nothing in Teeinblue is
           clicked or changed;
         - a swipe or drag on the Preview picture moves the theme's gallery (Teeinblue's own swipe is kept out there);
         - after each choice in the form, the theme's gallery comes back to the Preview picture (fading);
         - while the floating Live preview (phones) is up, Teeinblue's box goes back to its own place (the card needs
           it there), and returns to the slide afterwards;
         - if the theme's gallery is not the expected Dawn markup, nothing is done (Teeinblue's own gallery, §41–43). */
  (function designFirst() {
    var wrap = null, c = null, slide = null, thumb = null, moThumb = null, timer = 0, cardOn = false, back = 0;
    function mg() { return wrap && wrap.querySelector(":scope > media-gallery"); }
    function card() { var b = document.body.classList; return b.contains("gallery--sticky") && !b.contains("gallery--sticky--hide"); }
    function drawThumb() {
      timer = 0;
      if (!thumb || !c) return;
      var src = c.querySelector(".tee-slide--active .tee-mockup") || c.querySelector(".tee-mockup");
      var box = thumb.querySelector(".ezv-design-pic");
      if (!src || !box) return;
      var w = src.offsetWidth || parseFloat(src.style.width);
      if (!w) return;
      var k = Math.max(box.clientWidth, 1) / w, m = src.cloneNode(true);
      m.style.cssText += ";position:absolute;left:0;top:0;transform:scale(" + k.toFixed(4) + ");transform-origin:0 0;pointer-events:none";
      box.textContent = "";
      box.appendChild(m);
    }
    function soon() { if (!timer) timer = setTimeout(drawThumb, 300); fitSoon(120); }
    /* Ban-49: Teeinblue sizes its pictures to the box it is in, and measures again only when the window is resized.
       A design kept from an earlier visit is drawn when the page opens, before the box is moved into the Preview
       slide (or while the page's styles are still arriving), so the picture could stay bigger than the slide:
       zoomed in and cut off, until the window was resized. When the sizes differ, a resize is announced. */
    var fits = 0, fitTimer = 0;
    function fit() {
      fitTimer = 0;
      if (!c || cardOn || !c.isConnected || fits >= 6) return;
      var g = c.querySelector(".tee-gallery"), sl = c.querySelector(".tee-slider");
      if (!g || !sl || !g.offsetWidth) return;
      var w = parseFloat(sl.style.width);
      if (w && Math.abs(w - g.offsetWidth) > 1) { fits++; window.dispatchEvent(new Event("resize")); }
    }
    function fitSoon(ms) { clearTimeout(fitTimer); fitTimer = setTimeout(fit, ms); }
    function choose() {
      var g = mg(); if (!g || !slide) return;
      Array.prototype.forEach.call(g.querySelectorAll(".product__media-list > [data-media-id]"), function (el) { el.classList.toggle("is-active", el === slide); });
      Array.prototype.forEach.call(g.querySelectorAll(".thumbnail-list button"), function (b) { b.removeAttribute("aria-current"); });
      var b = thumb && thumb.querySelector("button"); if (b) b.setAttribute("aria-current", "true");
      var list = g.querySelector(".product__media-list");
      if (list && list.scrollLeft) list.scrollTo({ left: 0, behavior: "smooth" });   // phones: back to the first slide
      if (window.ezvQueue) window.ezvQueue();
    }
    /* to the Preview picture as if its small picture were pressed: on computers §41 fades it in */
    function shown() {
      if (!slide.classList.contains("is-active")) return false;
      var g = mg(), list = g && g.querySelector(".product__media-list");   // phones: the row may be scrolled away
      return !(list && list.scrollWidth > list.clientWidth + 1 && Math.abs(list.scrollLeft - slide.offsetLeft) > 4);
    }
    function show() {
      var b = thumb && thumb.querySelector("button");
      if (!b || !slide || shown()) return;
      if (card()) choose(); else b.click();
    }
    function put(content) {
      var g = mg(); if (!g || !content || !content.querySelector(".tee-slider__track > .tee-slide")) return false;
      var list = g.querySelector(".product__media-list"), tl = g.querySelector(".thumbnail-list");
      if (!list || !tl || !list.querySelector("[data-media-id]")) return false;
      var fresh = !slide;
      if (fresh) {
        var first = list.querySelector("[data-media-id]");
        slide = document.createElement(first.tagName);
        slide.className = first.className.replace(/\bis-active\b/g, "").replace(/\bscroll-trigger\S*|\banimate--\S+/g, "") + " ezv-design";
        slide.setAttribute("data-media-id", "ezv-design");
        slide.id = "Slide-ezv-design";                     // counted by the theme's slider (ids "Slide-…")
        list.insertBefore(slide, first);
        var ft = tl.querySelector(".thumbnail-list__item");
        thumb = document.createElement(ft ? ft.tagName : "li");
        thumb.className = (ft ? ft.className : "thumbnail-list__item") + " ezv-design-thumb ezv-new";
        thumb.id = "Slide-Thumbnails-ezv-design";
        thumb.setAttribute("data-target", "ezv-design");    // the theme finds it when the customer swipes to it
        thumb.innerHTML = '<button type="button" class="thumbnail global-media-settings global-media-settings--no-shadow" aria-label="Your design preview"><span class="ezv-design-pic"></span><span class="ezv-design-tag">Preview</span></button>';
        tl.insertBefore(thumb, tl.firstChild);
        thumb.querySelector("button").addEventListener("click", function (e) { e.preventDefault(); choose(); });
        setTimeout(function () { if (thumb) thumb.classList.remove("ezv-new"); }, 400);
        Array.prototype.forEach.call(g.querySelectorAll("slider-component"), function (sc) {
          if (sc.resetPages) try { sc.resetPages(); } catch (err) {}
        });
      }
      if (c && c !== content && c.parentNode === slide) slide.removeChild(c);   // Teeinblue built a new box (variant)
      c = content;
      cardOn = card();
      if (!cardOn) slide.appendChild(content);
      wrap.classList.add("ezv-one");
      show();                                              // the big picture fades to the Preview picture
      if (moThumb) moThumb.disconnect();
      moThumb = new MutationObserver(soon);
      moThumb.observe(content, { subtree: true, childList: true, attributes: true, attributeFilter: ["src", "style", "class"] });
      soon();
      fits = 0;
      fitSoon(0);
      setTimeout(fit, 700);
      setTimeout(fit, 1800);
      if (window.ResizeObserver && !slide._ezpFit) {
        slide._ezpFit = new ResizeObserver(function () { fits = 0; fitSoon(80); });
        slide._ezpFit.observe(slide);
      }
      return true;
    }
    /* the floating Live preview (phones) needs Teeinblue's box in its own place */
    function check() {
      if (!wrap || !slide) return;
      if (c && !c.isConnected) c = null;
      var on = card();
      if (!c) {                                            // replaced by Teeinblue while the card was up
        var own = wrap.querySelector(":scope > .tee-gallery-content");
        if (own && !on) put(own);
        return;
      }
      if (on === cardOn) return;
      cardOn = on;
      if (on && c.parentNode !== wrap) wrap.insertBefore(c, wrap.firstChild);
      if (!on && slide && c.parentNode !== slide) {
        slide.appendChild(c);
        /* Ban-152: the resize only when Teeinblue's slider no longer fits its box. It was sent every time the card left:
           Teeinblue then measured and redrew its whole slider while the customer was still scrolling up (iPhone: "khựng
           1 nhịp"); on a 375px phone the slider (375px) already fit (375px). fit() / the ResizeObserver above still catch
           a box that changes size later. One layout read, once per card change. */
        var g = c.querySelector(".tee-gallery"), sl = c.querySelector(".tee-slider"), w = sl && parseFloat(sl.style.width);
        if (w && g && Math.abs(w - g.clientWidth) > 1) window.dispatchEvent(new Event("resize"));
      }
    }
    /* Teeinblue's own swipe and drag stay out of the Preview picture: there they move the theme's gallery (§41 and the
       phones' own scrolling run first: these listeners come after theirs on the page) */
    ["pointerdown", "pointermove", "pointerup", "pointercancel", "touchstart", "touchmove", "touchend", "touchcancel", "mousedown", "mouseup"].forEach(function (t) {
      document.addEventListener(t, function (e) {
        if (e.target && e.target.closest && e.target.closest("media-gallery .tee-gallery-content")) e.stopPropagation();
      }, { capture: true, passive: true });
    });
    /* after each choice in Teeinblue's form: back to the Preview picture.
       Ban-47: also on a click on a choice. Teeinblue marks a picture choice (background, character, number…) as chosen
       before the mouse button comes up, so a real click there sends no "change" (only a scripted click did). */
    var CHOICE = 'input, select, textarea, label, .tee-clipart, [class*="tee-option"], [class*="tee-swatch"], [role="radio"], [role="option"]';
    var NOT_CHOICE = '.tee-btn, button, [type="submit"], .tee-quantity-group, .product-form__quantity, a[href]';
    function later() { clearTimeout(back); back = setTimeout(show, 150); }
    function teeForm(el) {
      return el && el.closest && !el.closest(".tee-gallery-content") && el.closest('[class*="tee-"], [id^="tee-"]');
    }
    ["change", "input"].forEach(function (t) {
      document.addEventListener(t, function (e) { if (slide && teeForm(e.target)) later(); }, true);
    });
    document.addEventListener("click", function (e) {
      var el = e.target;
      if (!slide || !teeForm(el) || !el.closest(CHOICE) || el.closest(NOT_CHOICE)) return;
      if (el.closest("input") && el.closest("input").type === "file") return;
      later();
    }, true);
    /* Ban-47: on computers the theme's slider can count the hidden Preview slide next to the shown picture (both at the
       same place), then announce a slide change with no slide; the theme's gallery threw an error each time. */
    document.addEventListener("slideChanged", function (e) {
      if (!e.detail || !e.detail.currentElement) e.stopPropagation();
    }, true);
    function start() {
      wrap = document.querySelector(".grid__item.product__media-wrapper");
      if (!wrap) return;
      new MutationObserver(check).observe(document.body, { attributes: true, attributeFilter: ["class"] });
      var deb = 0;
      new MutationObserver(function () {
        clearTimeout(deb);
        deb = setTimeout(function () {
          /* a box of Teeinblue's in its own place, not ours for the floating card: a new one (variant change) */
          var own = wrap.querySelector(":scope > .tee-gallery-content");
          if (own && slide && !card() && !wrap.classList.contains("ezv-swap") && own.querySelector(".tee-slide--active .tee-mockup")) { put(own); return; }
          if (slide) check();
        }, 200);
      }).observe(wrap, { childList: true });
    }
    window.ezvDesign = { put: function (content) { if (!wrap) wrap = document.querySelector(".grid__item.product__media-wrapper"); return put(content); } };
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  })();

  /* 49. Ban-47 — colour swatches in Teeinblue's form (T-shirts, mugs, tumblers…): the chosen colour's name after the
         title ("Color: Navy Blue"). The name was only in a hover bubble, which phones and tablets never show.
         Only an attribute is set on Teeinblue's title; the text itself comes from ez-personalize.css §49. */
  (function colourName() {
    var timer = 0;
    function mark() {
      timer = 0;
      Array.prototype.forEach.call(document.querySelectorAll(".tee-option--color"), function (block) {
        var title = block.querySelector(".tee-option__title");
        if (!title) return;
        var on = block.querySelector(".tee-radio.active input, input:checked");
        var label = on && block.querySelector('label[for="' + on.id + '"]');
        var name = (label && (label.getAttribute("data-title") || label.getAttribute("title"))) || (on && on.value) || "";
        if (name) { if (title.getAttribute("data-ezp-val") !== name) title.setAttribute("data-ezp-val", name); }
        else if (title.hasAttribute("data-ezp-val")) title.removeAttribute("data-ezp-val");
      });
    }
    function soon() { if (!timer) timer = setTimeout(mark, 60); }
    ["change", "click"].forEach(function (t) { document.addEventListener(t, function (e) {
      if (e.target && e.target.closest && e.target.closest(".tee-option--color")) soon();
    }, true); });
    function start() {
      var form = document.querySelector("form.tee-form-wrapper") || document.body;
      new MutationObserver(soon).observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ["class"] });
      soon();
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  })();

  /* 54. Ban-50 — date fields (Teeinblue's <input type="date">, e.g. "Choose Date"). The browser drew them its own
         way: "mm/dd/yyyy" with a grey calendar icon on computers, an empty box with no hint on iPhone. Now the box
         shows the date in words ("Jun 15, 2025") or "Select a date", like the other boxes, and a tap anywhere
         opens the phone's or browser's own date picker (best on phones: wheels on iPhone, calendar on Android).
         The input stays Teeinblue's: its value and events are untouched; the words are a layer on top
         (ez-personalize.css §54). */
  (function dateField() {
    var MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var SEL = '#tee-artwork-form input[type="date"]', timer = 0;
    var VALUE = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value");
    function words(v) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || "");
      return m ? MON[+m[2] - 1] + " " + +m[3] + ", " + m[1] : "";
    }
    function paint(inp) {
      var box = inp.parentNode;
      if (!box || !box.classList) return;
      var t = box.querySelector(":scope > .ezp-date-text");
      if (!t) {
        var colour = getComputedStyle(inp).color;          // the campaign's text colour, read before it is hidden
        t = document.createElement("span");
        t.className = "ezp-date-text";
        t.setAttribute("aria-hidden", "true");
        if (colour && !/rgba\(0, 0, 0, 0\)|transparent/.test(colour)) t.style.setProperty("--ezp-date-ink", colour);
        box.appendChild(t);
        box.classList.add("ezp-date");
      }
      if (!inp._ezpDate && VALUE && VALUE.set) {             // Teeinblue fills a saved design / "Start fresh" clears it
        inp._ezpDate = true;                                   // by setting .value, which fires no event
        try {
          Object.defineProperty(inp, "value", { configurable: true, get: function () { return VALUE.get.call(this); },
            set: function (v) { VALUE.set.call(this, v); paint(this); } });
        } catch (err) {}
      }
      var w = words(inp.value);
      if (t.textContent !== (w || "Select a date")) t.textContent = w || "Select a date";
      t.classList.toggle("is-empty", !w);
    }
    function all() { timer = 0; Array.prototype.forEach.call(document.querySelectorAll(SEL), paint); }
    function soon() { if (!timer) timer = setTimeout(all, 80); }
    ["input", "change", "blur"].forEach(function (type) {
      document.addEventListener(type, function (e) { if (e.target && e.target.matches && e.target.matches(SEL)) paint(e.target); }, true);
    });
    function start() {
      /* Ban-116: the whole page — the cart Edit popup adds a second form later */
      new MutationObserver(soon).observe(document.body, { subtree: true, childList: true });
      soon();
      setTimeout(all, 1500);                                  // a saved design fills the date without an event
      setTimeout(all, 4000);
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  })();

  /* 69. Ban-86 — photo fields: a grid for 2+ photos in a row (3+ before Ban-87), Teeinblue's photo notes filtered, one message per group.
         Owner approved the design 19/10 (artifact "Ban-86 Form ảnh và thiếu ô").
     a) Grid. Three or more photo fields standing next to each other in Teeinblue's form (#teeFormInputs) become square
        tiles, 3 per row, under one heading "Your photos". A photo field on its own, or a pair, keeps the row card.
        Teeinblue removes unused fields from the page (choosing "Number of photos" adds / removes them), so "next to
        each other" is always what the customer sees. A field holding anything beyond the usual parts (unknown buttons)
        is never put in a grid: that group keeps its row cards. Measured on TEST 8, "Add Loved One" with 12 photos at
        375 px: photo part 3,282 px → ~560 px; "Playing Card" 8 photos: form 1,688 → ~1,260 px.
        Empty tile: tap = Teeinblue's own photo picker (§17b). Tile with a photo: tap = a sheet with Adjust / Change /
        Remove, each one presses Teeinblue's own button; the × in the corner removes at once (Teeinblue's own ×, made
        a 44 px target instead of 22 px). Nothing in Teeinblue's logic changes: required photos, validation, popups.
     b) Notes. Teeinblue's note under every photo field (photo_hint) is hidden; 37 products had one, 22 texts, most of
        them generic and out of date ("click SELECT IMAGE", "click the PREVIEW button below"). Lines with real
        information stay (an artist redraws the photo, only one photo is used, wait 20–30 s for background removal):
        8 products keep nothing, 22 a waiting line, 5 the artist line, 2 "only one photo". Staff keep writing notes in
        Teeinblue as before. Filtering one page takes ~0.2 ms (all 29 texts 0.56 ms).
     c) Message. A grid shows one line instead of one red line per photo: "Add 4 more photos (2 of 6 added)". Other
        fields keep Teeinblue's own messages. The first missing field still scrolls into view (§2, aimed at the
        heading of the grid so the line shows). */
  var PG_FORM = "#tee-artwork-form";   // own copy: §69 also runs in the test pages that load §41 → end only
  function pgS() { return pgS.s || (pgS.s = { notes: {}, stamp: 0, sheet: null, field: null }); }
  var PG_STD = "Tap a box to add photos, several at once if you like. Tap a photo to adjust or change it.";   // Ban-166: several at once (2 lines at 375 px, as before)   // review 19/10: say how to add, not only how to edit (the quality advice is in Photo tips)
  var PG_KEEP = /artist|only one photo|wait|seconds|background remove|face cutout|preview shows/i;
  var PG_DROP = /spinning icon|when it stops/i;
  /* a sentence naming what the photo must show stays even when it also says "works best", "tap"… (staff may write
     "For best results use a front-facing photo" in a new campaign) */
  var PG_SPEC = /\b(face|faces|front|full[- ]body|whole body|pet|pets|dog|cat|eyes|glasses|alone|one person|single person|background|head|shoulders?|vertical|horizontal|landscape|baby|child|kids?|selfie|smil\w*)\b/i;
  var PG_GEN = /select (an? )?(image|photo)|upload your (photos?|images?|pictures?)\b|re-?upload|replace (photo|button)|crop|high[- ]?(quality|resolution)|large pixels|well-lit|in focus|blur|creases|preview button|edit button|\bclick\b|\btap\b|touch the photo|zoom|rotate|move (up|down|left|right)|adjust|best (result|look|final)|works? best|recommended|multiple photos at once|disclaimer|resize|fit the frame|choose a high|if you want/i;
  function pgNote(html) {
    var s = pgS();
    if (Object.prototype.hasOwnProperty.call(s.notes, html)) return s.notes[html];
    var t = String(html).replace(/<br\s*\/?>|<\/p>|<\/li>|<\/div>/gi, "\n").replace(/<[^>]+>/g, " ")
      .replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&#39;|&rsquo;/g, "'").replace(/&quot;/g, "\"");
    t = t.replace(/•/g, "\n").replace(/(^|\s)\d{1,2}\s*[-.)]\s*(?=[A-Za-z])/g, "\n");
    var out = [];
    t.split("\n").forEach(function (line) {
      line = line.replace(/^\s*[-–]\s+/, "").replace(/([.!])\s+(?=[A-Z])/g, "$1\n");   // one sentence per line (no lookbehind: older iPhones)
      line.split("\n").forEach(function (x) {
        x = x.replace(/\s+/g, " ").trim();
        if (x.length < 4 || /^[a-z]/.test(x) || PG_DROP.test(x)) return;
        if (!PG_KEEP.test(x) && !PG_SPEC.test(x) && PG_GEN.test(x)) return;
        x = x.replace(/^however,?\s*/i, "");
        if (x === x.toUpperCase()) x = x.charAt(0) + x.slice(1).toLowerCase();
        x = x.charAt(0).toUpperCase() + x.slice(1);
        out.push(/[.!]$/.test(x) ? x : x + ".");
      });
    });
    return (s.notes[html] = out.join(" "));
  }
  var PG_PARTS = /^(tee-field__|tee-upload|tee-photo|ezp-)/;
  function pgPlain(f) {
    var c, p = f.querySelector(".tee-photo");
    if (!p) return false;
    for (c = f.firstElementChild; c; c = c.nextElementSibling) if (!PG_PARTS.test(c.classList[0] || "")) return false;
    for (c = p.firstElementChild; c; c = c.nextElementSibling) if (!PG_PARTS.test(c.classList[0] || "")) return false;
    var a = p.querySelector(".tee-photo-action");
    if (a) for (c = a.firstElementChild; c; c = c.nextElementSibling) if (!c.matches("label.tee-btn--upload, .tee-btn--recustomize")) return false;
    return true;
  }
  function pgLabel(f) {
    var s = f.querySelector(".tee-field__heading > span");
    return (s ? s.textContent : "").replace(/\*+\s*$/, "").replace(/^\s*(please\s+)?(upload|add|choose|select|insert)\s+(your\s+|a\s+|the\s+)?/i, "").replace(/[:\s]+$/, "").trim();
  }
  function pgBase(l) { return l.replace(/[#\d]+/g, "").replace(/\s+/g, " ").trim().toLowerCase(); }
  function pgHead(box, before) {
    var h = document.createElement("div");
    h.className = "ezp-pg-head";
    /* Teeinblue's own title markup (tee-field__header / __heading / tee-asterisk), so "Your photos" takes exactly the
       size, weight, colour and spacing of every other title in the form (anh 19/10 13:53: it was 15 px vs 14.6 px) */
    h.innerHTML = '<div class="tee-field__header ezp-pg-top"><div class="tee-field__heading"><span class="ezp-pg-t">Your photos</span><span class="tee-asterisk ezp-pg-req" aria-hidden="true">*</span></div></div>' +
      '<p class="ezp-pg-cap"></p><p class="ezp-pg-note" hidden></p><p class="ezp-pg-n" aria-live="polite"></p><p class="ezp-pg-fit" hidden></p><p class="ezp-pg-msg" role="alert" hidden></p>';
    h.querySelector(".ezp-pg-cap").textContent = PG_STD;
    if (document.querySelector(".upload_image_guidelines")) {
      var tips = document.createElement("span");
      tips.className = "ezp-photo-tips ezp-pg-tips";
      tips.setAttribute("role", "button");
      tips.setAttribute("tabindex", "0");
      tips.textContent = "Photo tips";
      h.firstChild.appendChild(tips);
    }
    box.insertBefore(h, before);
    return h;
  }
  function photoGrid() { Array.prototype.forEach.call(document.querySelectorAll(PG_FORM + " #teeFormInputs"), photoGridIn); }   // Ban-116: page form + cart Edit popup
  function photoGridIn(box) {
    var s = pgS(), i, el;
    /* b) notes, on every photo field (single ones too) */
    /* the same note under several photos (e.g. 10 × "Only one photo can be used for the whole design") shows once */
    var ins = box.querySelectorAll(".tee-field--photo .tee-upload-instruction"), seen = {};
    for (i = 0; i < ins.length; i++) {
      el = ins[i];
      var raw = el.innerHTML, n = pgNote(raw), show = !!n && !seen[n];
      if (n) seen[n] = true;
      if (el.getAttribute("data-ezp-note") !== n) el.setAttribute("data-ezp-note", n);
      if (el.classList.contains("ezp-note-on") !== show) el.classList.toggle("ezp-note-on", show);
    }
    /* a) groups of photo fields standing next to each other */
    var runs = [], run = [];
    for (el = box.firstElementChild; el; el = el.nextElementSibling) {
      if (!el.classList.contains("tee-field") || el.style.display === "none") continue;   // titles, guides, our headings
      if (el.classList.contains("tee-field--photo") && pgPlain(el)) { run.push(el); continue; }
      if (run.length) runs.push(run);
      run = [];
    }
    if (run.length) runs.push(run);
    /* a grid for 2+ photos with the same name apart from the number ("Upload Photo #1…#12"; from 2 since Ban-87, anh 19/10
       13:39: picking 3 → 2 on Playing Card Couple must not switch the layout, and 2 tiles take 186 px vs 232 px of rows); photos with names of
       their own ("Dad's photo", "Choose Character #15" between "Photo #14" and "Photo #15") each have a purpose and
       keep their row card with the full name. Seen on "Best Dad Grandpa Ever": 3 such fields at the end of 16. */
    runs = runs.filter(function (r) {
      if (r.length < 2) return false;
      var base = pgBase(pgLabel(r[0]));
      return r.every(function (f) { return pgBase(pgLabel(f)) === base; });
    });
    var stamp = ++s.stamp;
    runs.forEach(function (r) {
      var head = r[0].previousElementSibling;
      if (!head || !head.classList.contains("ezp-pg-head")) head = pgHead(box, r[0]);
      head._ezpStamp = stamp;
      head._ezpRun = r;
      var labels = r.map(pgLabel);
      var plain = /^(your\s+)?(photos?|images?|pictures?)?$/i.test(pgBase(labels[0]));
      /* the number in the name, unless two names carry the same one or none ("Upload Your Photo #1" twice, "Upload Photo"
         twice: 2 of 62 two-photo templates, scan 19/10) — then the tile's place: Photo 1, Photo 2 */
      var nums = labels.map(function (l) { return (l.match(/\d+/) || [""])[0]; });
      var byPlace = nums.some(function (n, k) { return !n || nums.indexOf(n) !== k; });
      var notes = [];
      /* a photo without Teeinblue's asterisk in a group that has required ones says "(optional)" on its tile — the
         rows showed it by the missing *, the tile has no title (check 19/10: Proud Graduate stole, Photo #1 optional) */
      var anyReq = r.some(function (f) { return f.querySelector(".tee-asterisk"); });
      r.forEach(function (f, k) {
        var num = byPlace ? String(k + 1) : nums[k];
        f._ezpStamp = stamp;
        f._ezpHead = head;
        if (!f.classList.contains("ezp-pg")) f.classList.add("ezp-pg");
        var cap = plain || !labels[k] ? "Photo " + num : (pgBase(labels[k]).replace(/^./, function (c) { return c.toUpperCase(); }) + " " + num);
        f._ezpCap = cap;
        f._ezpNum = num;
        var p = f.querySelector(".tee-photo"), hd = p.querySelector(".tee-photo-head"), up = p.querySelector(".tee-photo-uploaded");
        if (p.getAttribute("tabindex") !== "0") { p.setAttribute("tabindex", "0"); p.setAttribute("role", "button"); }
        var opt = anyReq && !f.querySelector(".tee-asterisk");
        if (f.classList.contains("ezp-pg-opt") !== opt) f.classList.toggle("ezp-pg-opt", opt);
        var aria = up ? cap + ": adjust, change or remove" : "Add " + cap + (opt ? " (optional)" : "");
        if (p.getAttribute("aria-label") !== aria) p.setAttribute("aria-label", aria);
        if (hd && hd.getAttribute("data-ezp-cap") !== cap) hd.setAttribute("data-ezp-cap", cap);
        if (up && up.getAttribute("data-ezp-num") !== num) up.setAttribute("data-ezp-num", num);
        /* d) Ban-166: an empty tile's picker takes several photos at once (they fill the empty tiles in turn); a tile with
           a photo keeps one (its input is also Teeinblue's "change photo") */
        var fi = p.querySelector("input[type=file]"), many = !up && !p.querySelector(".tee-photo-uploading");
        if (fi && fi.multiple !== many) fi.multiple = many;
        var xb = p.querySelector(".tee-photo-clear"), xl = f.classList.contains("ezp-rm-armed") ? "Tap again to remove " + cap : "Remove " + cap;
        if (xb && xb.getAttribute("aria-label") !== xl) xb.setAttribute("aria-label", xl);
        var note = f.querySelector(".tee-upload-instruction.ezp-note-on");
        if (note && notes.indexOf(note.getAttribute("data-ezp-note")) < 0) notes.push(note.getAttribute("data-ezp-note"));
      });
      head.querySelector(".ezp-pg-req").hidden = !r.some(function (f) { return f.querySelector(".tee-asterisk"); });
      var nb = head.querySelector(".ezp-pg-note"), nt = notes.join(" ");
      if (nb.textContent !== nt) nb.textContent = nt;
      nb.hidden = !nt;
    });
    var olds = box.querySelectorAll(".ezp-pg, .ezp-pg-head");
    for (i = 0; i < olds.length; i++) {
      el = olds[i];
      if (el._ezpStamp === stamp) continue;
      if (el.classList.contains("ezp-pg-head")) { el.parentNode.removeChild(el); continue; }
      el.classList.remove("ezp-pg", "ezp-pg-opt");
      var q = el.querySelector(".tee-photo"), qi = el.querySelector("input[type=file]");
      if (q) { q.removeAttribute("tabindex"); q.removeAttribute("role"); q.removeAttribute("aria-label"); }
      if (qi && qi.multiple) qi.multiple = false;
    }
    if (box.classList.contains("ezp-pg-on") !== runs.length > 0) box.classList.toggle("ezp-pg-on", runs.length > 0);
    pgCount();
  }
  /* c) the line under each grid heading: "2 of 6 added", or after Preview with photos missing,
        "Add 4 more photos (2 of 6 added)" in red, and the empty tiles outlined in red (Teeinblue's own state) */
  /* "Photos 1–3, 5": the numbers of the tiles a note is about */
  function pgNums(list) {
    var n = list.map(function (f) { return parseInt(f._ezpNum, 10); }).filter(function (x) { return x === x; }).sort(function (a, b) { return a - b; });
    var out = [], i = 0;
    while (i < n.length) {
      var j = i;
      while (j + 1 < n.length && n[j + 1] === n[j] + 1) j++;
      out.push(j - i >= 2 ? n[i] + "–" + n[j] : j > i ? n[i] + ", " + n[j] : String(n[i]));
      i = j + 1;
    }
    return (list.length > 1 ? "Photos " : "Photo ") + out.join(", ");
  }
  function pgCount() {
    var heads = document.querySelectorAll(PG_FORM + " .ezp-pg-head");
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i], r = h._ezpRun || [], have = 0, err = false, msgs = {}, order = [], fit = [];
      var bad = 0;                                   // empty tiles Teeinblue marks as missing (an optional photo is never counted)
      r.forEach(function (f) {
        var on = !!f.querySelector(".tee-photo-uploaded img, .tee-photo-uploading");
        if (on) have++;
        else if (f.classList.contains("tee-field--invalid")) { err = true; bad++; }
        /* Teeinblue's own note in the photo card: a tile has no room for it, so it goes under the heading.
           The "aspect ratio" note (switching 9 ⇄ 6 photos moves every photo to a frame of another shape) is a hint,
           not an error (§30): one grey line for all of them. A real error ("image is too small…") stays red, and
           the same sentence for several photos is written once: "Photos 2, 5: …" (anh 19/10 13:31: 5 × the same
           red paragraph after 9 → 6). */
        var m = f.querySelector(".tee-photo-message"), mt = m ? m.textContent.replace(/\s+/g, " ").trim() : "";
        var isFit = !!mt && RATIO_NOTE.test(mt);
        if (isFit) fit.push(f);
        else if (mt) { if (!msgs[mt]) { msgs[mt] = []; order.push(mt); } msgs[mt].push(f); }
        var red = !!mt && !isFit;
        if (f.classList.contains("ezp-pg-msg-on") !== red) f.classList.toggle("ezp-pg-msg-on", red);
      });
      var mb = h.querySelector(".ezp-pg-msg"), mtx = order.map(function (t) { return pgNums(msgs[t]) + ": " + t; }).join("\n");
      if (mb && mb.textContent !== mtx) mb.textContent = mtx;
      if (mb) mb.hidden = !mtx;
      var fb = h.querySelector(".ezp-pg-fit"), ftx = fit.length ? pgNums(fit) + ": the photo shape differs from the frame. Tap " + (fit.length > 1 ? "a photo" : "it") + " to check the fit." : "";
      if (fb && fb.textContent !== ftx) fb.textContent = ftx;
      if (fb) fb.hidden = !ftx;
      var miss = bad;
      var t = err && miss > 0 ? "Add " + miss + " more photo" + (miss > 1 ? "s" : "") + " (" + have + " of " + r.length + " added)" : have + " of " + r.length + " added";
      var line = h.querySelector(".ezp-pg-n");
      if (line.textContent !== t) line.textContent = t;
      if (h.classList.contains("ezp-pg-err") !== (err && miss > 0)) h.classList.toggle("ezp-pg-err", err && miss > 0);
      if (line.classList.contains("is-some") !== have > 0) line.classList.toggle("is-some", have > 0);
      var done = r.length > 0 && have === r.length;
      if (line.classList.contains("is-done") !== done) line.classList.toggle("is-done", done);
    }
  }
  function pgOpen(f) {
    var s = pgS();
    if (!window.ezSheet) { var b0 = f.querySelector(".tee-btn--recustomize"); if (b0) b0.click(); return; }
    var ico = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + "</svg>"; };
    var sh = window.ezSheet({
      title: f._ezpCap || "Photo",
      cls: "ezp-pg-sheet",
      fill: function (body) {
        body.innerHTML = '<div class="ezp-pg-acts">' +
          '<span class="ezp-pg-act" role="button" tabindex="0" data-ezp-act="adjust">' + ico('<path d="M5 9 2 12l3 3M9 5l3-3 3 3M15 19l-3 3-3-3M19 9l3 3-3 3M2 12h20M12 2v20"/>') + "Adjust position &amp; zoom</span>" +
          '<span class="ezp-pg-act" role="button" tabindex="0" data-ezp-act="change">' + ico('<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-5-5L5 21"/>') + "Change photo</span>" +
          '<span class="ezp-pg-act ezp-pg-act--rm" role="button" tabindex="0" data-ezp-act="remove">' + ico('<path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/>') + "Remove photo</span>" +
          "</div>";
      },
      onClose: function () { s.sheet = null; s.field = null; }
    });
    if (!sh) return;
    s.sheet = sh;
    s.field = f;
  }
  function pgAct(kind) {
    var s = pgS(), f = s.field, sh = s.sheet;
    if (f && f.isConnected) {
      /* the photo picker has to be asked for inside the tap itself (iPhone), so before the sheet goes */
      if (kind === "change") { var inp = f.querySelector("input[type=file]"); if (inp && !inp.disabled) inp.click(); }
      if (sh) sh.close();
      if (kind === "adjust") { var b = f.querySelector(".tee-btn--recustomize"); if (b) b.click(); }
      if (kind === "remove") { var x = f.querySelector(".tee-photo-clear"); if (x) x.click(); }
    } else if (sh) sh.close();
  }
  /* × on a tile (review 19/10): the first tap only turns it into a red "Remove" (4 s), the second removes. A slip on a
     74 px tile then costs nothing, while removing still needs no sheet (anh 19/10). The sheet's Remove presses × itself
     (not a trusted click) and goes straight through. */
  function pgArm(f) {
    var s = pgS(), old = s.armed;
    clearTimeout(s.armT);
    s.armed = f || null;
    [old, f].forEach(function (g) {
      if (!g) return;
      var on = g === s.armed;
      if (g.classList.contains("ezp-rm-armed") !== on) g.classList.toggle("ezp-rm-armed", on);
      var xb = g.querySelector(".tee-photo-clear");
      if (xb) xb.setAttribute("aria-label", (on ? "Tap again to remove " : "Remove ") + (g._ezpCap || "photo"));
    });
    if (f) { s.armAt = Date.now(); s.armT = setTimeout(function () { pgArm(null); }, 4000); }
  }
  function pgTap(e, key) {
    var t = e.target;
    if (!t || !t.closest) return false;
    var s0 = pgS(), xb = t.closest(PG_FORM + " .tee-field.ezp-pg .tee-photo-clear"), xf = xb && xb.closest(".tee-field");
    if (s0.armed && s0.armed !== xf) pgArm(null);
    if (xb && e.isTrusted) {
      if (!xf.classList.contains("ezp-rm-armed")) { pgArm(xf); return true; }
      if (Date.now() - s0.armAt < 350) return true;   // a double tap is still one tap
      pgArm(null);
      return false;                                 // second tap: Teeinblue removes the photo
    }
    var tips = t.closest(".ezp-pg-tips");
    if (tips) { var g = document.querySelector(".upload_image_guidelines"); if (g) g.click(); return true; }
    var act = t.closest(".ezp-pg-sheet [data-ezp-act]");
    if (act) { pgAct(act.getAttribute("data-ezp-act")); return true; }
    var p = t.closest(PG_FORM + " .tee-field.ezp-pg .tee-photo");
    /* Teeinblue's own ×, its (hidden) buttons and the file input: the sheet presses those itself, never caught here */
    if (!p || t.closest(".tee-photo-clear, .tee-photo-action, input") || p.querySelector(".tee-photo-uploading")) return false;
    if (p.querySelector(".tee-photo-uploaded img")) { pgOpen(p.closest(".tee-field")); return true; }
    if (!key) return false;                         // empty tile, tap: §17b opens the picker
    var inp = p.querySelector("input[type=file]");
    if (inp && !inp.disabled) inp.click();
    return true;
  }
  /* d) Ban-166 → 168 (anh 25/10 11:15 after Macorner; 14:53) — several photos at once, then one crop window for all.
        An empty tile's picker takes several photos (iPhone: select several in Photos). Teeinblue's input reads one file,
        so the trusted "change" carrying several is stopped on the window and each file is handed to one empty tile of the
        same grid — the tapped one first, then the empty ones after it, then those before it — as its own "change"
        (Teeinblue uploads them side by side: 3 photos ~1 s on TEST 13). More photos than empty tiles: the rest are left
        out and the heading says so.
        Crop window: Teeinblue opens it after every upload (showImagePlacement → $modal.show), so with several uploads at
        once it showed one window for whichever finished last (photo 2 of 3 in the test). While a batch runs, those opening
        calls are held back (a wrapper on the app's own $modal.show; each held call marks its tile ready). Ban-166/167
        then opened the window photo by photo ("Save & next"); Ban-168 opens it once, through Teeinblue's own
        "recustomize" button of the first photo, when all are up: "Adjust your photos", every photo in its strip (§15d).
        Without the app handle (never seen) the photos are still shared out and Teeinblue opens its window as before.
        Measured / tried on TEST 13 "Mom Photo Collage" (6 tiles) in the pane. */
  var PB = null;   // the batch: { fields, open, many, t, allow, seen }
  var PB_NAME = "tee-dialog-image-placement";
  function pbModal(f) {
    /* the page's one Teeinblue app (mounted on #teeinblue-wrapper; the form itself is drawn elsewhere, so it cannot be
       found from the tile). Not when the page holds more than one app. Ban-171: the cart's Edit popup too (it was left
       out): its parts use the same $modal as the app (checked on /cart), and its crop window is found (cropParts) */
    var els = document.querySelectorAll("#teeinblue-wrapper, [data-v-app]"), found = null;
    for (var i = 0; i < els.length; i++) {
      var app = els[i].__vue_app__, gp = app && app.config && app.config.globalProperties, m = gp && gp.$modal;
      if (!m || typeof m.show !== "function" || m === found) continue;
      if (found) return null;
      found = m;
    }
    return found;
  }
  function pbHook(f) {
    var m = pbModal(f);
    if (!m) return false;
    if (m.__ezpShow) return true;
    var show = m.show;
    m.__ezpShow = show;
    m.show = function (name, params) {
      /* Ban-171: in the cart's Edit popup the window is called "tee-dialog-image-placementedit-customization" */
      if (PB && typeof name === "string" && name.indexOf(PB_NAME) === 0 && !PB.allow) {
        var fe = params && params.fieldRef && params.fieldRef.$el;
        if (fe && PB.fields.indexOf(fe) >= 0 && fe !== PB.open) {
          fe._ezpReady = true;
          PB.mute[fe.id.replace("tee-field--", "")] = Date.now();   // Ban-170/171: its "go to this photo" 200 ms later
          pbSoon();
          return;
        }
        /* setting "change photo in the window" off: no field given, hold the first opening calls only (one per photo) */
        if (!fe && !PB.open && PB.seen < PB.fields.length) { PB.seen++; pbSoon(); return; }
      }
      return show.apply(this, arguments);
    };
    return true;
  }
  function pbWin() { return cropWin(); }   // Ban-175: the last one (§15d)
  function pbReady(g) {
    if (g._ezpReady) return true;
    var img = g.querySelector(".tee-photo-uploaded img");
    /* normally the held opening call says so; without it (setting off), a photo shown for a while will do */
    return !!img && !g.querySelector(".tee-photo-uploading") && !!PB && Date.now() - PB.t > 4000;
  }
  function pbFailed(g) {
    if (g.querySelector(".tee-photo-uploaded img, .tee-photo-uploading")) return false;
    var m = g.querySelector(".tee-photo-message");
    return !!(m && m.textContent.trim()) || Date.now() - PB.t > 4000;
  }
  function pbSoon() { clearTimeout(pbSoon.t); pbSoon.t = setTimeout(pbTick, 60); }
  function pbEnd() { clearTimeout(pbSoon.t); clearTimeout(pbTick.t); PB = null; }
  /* Ban-168 (anh 14:53): ONE crop window for the whole batch instead of one per photo ("Save & next"): the window
     already holds every photo (its strip, §15d), each one can be moved / turned / changed there. It opens once every
     photo of the batch is up (or after 20 s), on the first one; closing it in any way ends the batch. */
  var PB_TITLE = "Adjust your photos", PB_HINT = "Tap a photo below to edit it";
  /* Ban-170: photos added from the "+" of an open window (§15d c). The window stays: each value of a new photo's box
     that changes in the design goes into the window's copy (tempCustomization), unless the customer has already changed
     that value in the window (moved the new photo). Closed before the photos are up: their windows stay held, none opens. */
  function pbMine(k) {
    for (var i = 0; i < PB.ids.length; i++) {
      var id = PB.ids[i];
      if (k === id || k.indexOf(id + "-") === 0 || k === "local-file-" + id) return true;
    }
    return false;
  }
  function pbSnap(real) {
    for (var k in real) if (pbMine(k) && !(k in PB.last)) PB.last[k] = JSON.stringify(real[k]);
  }
  function pbSync() {
    var ip = PB.ip, real = ip.customization, temp = ip.tempCustomization, add = null;
    if (!real || !temp) return;
    for (var k in real) {
      if (!pbMine(k)) continue;
      var s = JSON.stringify(real[k]), was = PB.last[k];
      if (s === was) continue;
      PB.last[k] = s;
      if (was !== undefined && k in temp && JSON.stringify(temp[k]) !== was) continue;   // changed in the window: theirs
      (add = add || {})[k] = s === undefined ? undefined : JSON.parse(s);
    }
    if (add) { try { ip.tempCustomization = Object.assign({}, temp, add); } catch (err) {} }
  }
  /* Teeinblue, once a photo is up, opens the window on it and 200 ms later tells the window to go to that photo
     (EventBus "photo-placement-draggable"). The opening is held; the "go to" would move the window away from the photo
     being adjusted each time one of the new photos is up (a few seconds apart on a phone): dropped for those photos.
     Instead the window goes once to the first new photo (the box tapped), unless the customer picked one meanwhile. */
  function pbMute(eb) {
    if (!eb || typeof eb.$emit !== "function" || eb.__ezpEmit) return;
    var emit = eb.$emit;
    eb.__ezpEmit = emit;
    eb.$emit = function (ev, p) {
      /* once per held opening, only from its timer (window.event empty): a tap in the strip always goes through */
      if (PB && !PB.pass && !window.event && ev === "photo-placement-draggable" && p && Date.now() - (PB.mute[p.fieldId] || 0) < 1500) {
        delete PB.mute[p.fieldId];
        return;
      }
      return emit.apply(this, arguments);
    };
  }
  function pbPick() {
    var q = cropParts(), mip = q.mip;
    if (!mip || Date.now() - PB.t > 20000) { PB.picked = true; return; }
    if (PB.from && mip.fieldId !== PB.from) { PB.picked = true; return; }   // the customer went to another photo
    var g = (mip.photoGroups || []).filter(function (x) { return x.fieldId === PB.first; })[0];
    if (!g) return;
    PB.picked = true;
    PB.pass = true;                                  // Teeinblue's selectPhoto goes through the same "go to" message
    try { mip.selectPhoto(g); } catch (err) {}
    PB.pass = false;
  }
  function pbWinTick() {
    var w = pbWin(), live = PB.fields.filter(function (g) { return g.isConnected && !pbFailed(g); });
    var going = live.some(function (g) { return !pbReady(g); }) && Date.now() - PB.t < 20000;
    if (!w || !PB.ip.isOpen) {
      if (going) pbTick.t = setTimeout(pbTick, 250); else pbEnd();
      return;
    }
    pbSync();
    if (!PB.picked) pbPick();
    var ttl = w.querySelector(".ezp-crop-head__title"), hint = w.querySelector(".ezp-crop-head__hint");
    if (ttl && ttl.textContent !== PB_TITLE) ttl.textContent = PB_TITLE;
    if (hint && hint.textContent !== PB_HINT) hint.textContent = PB_HINT;
    cropStrip();                                     // the new thumbnails: numbers, places, spinners off
    pbTick.t = setTimeout(pbTick, going ? 150 : 400);
  }
  function pbTick() {
    clearTimeout(pbTick.t);
    if (!PB) return;
    if (PB.win) { pbWinTick(); return; }
    var w = pbWin();
    if (PB.open) {
      if (!w) { pbEnd(); return; }                   // closed (Save, Cancel, X, Esc): done
      var ttl = w.querySelector(".ezp-crop-head__title"), hint = w.querySelector(".ezp-crop-head__hint");
      if (PB.many && ttl && ttl.textContent !== PB_TITLE) ttl.textContent = PB_TITLE;
      if (PB.many && hint && hint.textContent !== PB_HINT) hint.textContent = PB_HINT;
      pbTick.t = setTimeout(pbTick, 400);
      return;
    }
    if (Date.now() - PB.t > 60000) { pbEnd(); return; }
    if (w) { pbTick.t = setTimeout(pbTick, 250); return; }   // a crop window the customer opened: wait
    var live = PB.fields.filter(function (g) { return g.isConnected && !pbFailed(g); });
    if (!live.length) { pbEnd(); return; }
    var ready = live.filter(pbReady);
    if (ready.length < live.length && Date.now() - PB.t < 20000) { pbTick.t = setTimeout(pbTick, 250); return; }
    var g = ready[0] || live[0], b = g.querySelector(".tee-btn--recustomize");
    if (!b) { pbEnd(); return; }
    PB.open = g;
    PB.many = live.length > 1;
    PB.allow = true;
    try { b.click(); } finally { PB.allow = false; }
    pbTick.t = setTimeout(pbTick, 120);
  }
  function pbOver(head, msg) {
    var o = head.querySelector(".ezp-pg-over");
    if (!o) {
      o = document.createElement("p");
      o.className = "ezp-pg-over";
      o.setAttribute("role", "status");
      var n = head.querySelector(".ezp-pg-n");
      head.insertBefore(o, n ? n.nextSibling : null);
    }
    o.textContent = msg;
    o.hidden = !msg;
    clearTimeout(o._t);
    if (msg) o._t = setTimeout(function () { o.hidden = true; }, 8000);
  }
  function pbStart(f, files, win) {
    var head = f._ezpHead, run = (head._ezpRun || []).filter(function (g) { return g.isConnected; }), k = run.indexOf(f);
    var empty = function (g) {
      var i = g.querySelector("input[type=file]");
      return !!i && !i.disabled && !g.querySelector(".tee-photo-uploaded img, .tee-photo-uploading");
    };
    var order = [f].concat(run.slice(k + 1).filter(empty), run.slice(0, Math.max(k, 0)).filter(empty));
    var take = Math.min(order.length, files.length), skip = files.length - take, targets = order.slice(0, take);
    var ip = null;
    var q = null;
    if (win) {
      /* Ban-170: into the open window — needs the window's part (its copy of the design) and the app's $modal */
      q = pbWin() ? cropParts() : null;
      ip = q && q.ip && q.ip.isOpen && q.ip.tempCustomization && q.ip.customization ? q.ip : null;
      if (ip && !ip.reuploadInPopup) ip = null;      // setting off: Teeinblue's opening calls carry no box, cannot be held one by one
      if (!ip || !pbHook(f)) return false;
      pbMute(ip.EventBus);
    }
    pbOver(head, skip ? "Only " + take + " more photo" + (take > 1 ? "s" : "") + " fit here: " + skip + " not added." : "");
    targets.forEach(function (g) { g._ezpReady = false; });
    var ids = targets.map(function (g) { return g.id.replace("tee-field--", ""); });
    if (win && PB && PB.win && PB.ip === ip) {
      /* more photos into the same window while the first ones are still going up: one batch */
      PB.fields = PB.fields.concat(targets);
      PB.ids = PB.ids.concat(ids);
      PB.t = Date.now();
      PB.first = ids[0];
      PB.from = q.mip && q.mip.fieldId;
      PB.picked = false;
      pbSnap(ip.customization);
    } else {
      pbEnd();
      if (win) {
        var cur = ip.fieldRef && ip.fieldRef.$el;
        PB = { fields: targets, open: cur || true, many: true, t: Date.now(), allow: false, seen: 0, win: true, ip: ip, ids: ids,
          last: {}, mute: {}, first: ids[0], from: q.mip && q.mip.fieldId, picked: false };
        pbSnap(ip.customization);
      } else if (take > 1 && pbHook(f)) {
        PB = { fields: targets, open: null, many: false, t: Date.now(), allow: false, seen: 0, mute: {} };
        /* Ban-171: the window opened for the batch flicked to whichever photo's "go to" came last (~70 ms, measured in the
           cart's Edit popup): those of the held photos are dropped here too */
        var qf = cropParts(f).fields;
        for (var fk in qf) { pbMute(qf[fk].EventBus); break; }
      }
    }
    targets.forEach(function (g, j) {
      var inp = g.querySelector("input[type=file]"), dt = new DataTransfer();
      dt.items.add(files[j]);
      inp.files = dt.files;
      inp.dispatchEvent(new Event("change", { bubbles: true }));
    });
    if (PB) { clearTimeout(pbTick.t); pbTick.t = setTimeout(pbTick, PB.win ? 60 : 400); }
    return true;
  }
  /* Ban-169: the "+" thumbnails of the crop window's strip (§15d c) hand their photos here; Ban-170: win = keep the
     window open (false back: could not, the caller falls back to save / close / reopen) */
  window.ezpAddPhotos = function (f, files, win) {
    if (!f || !f._ezpHead) return false;
    try { new DataTransfer(); } catch (err) { return false; }
    return pbStart(f, files, !!win);
  };
  window.addEventListener("change", function (e) {
    var inp = e.target;
    if (!e.isTrusted || !inp || inp.type !== "file" || !inp.files || inp.files.length < 2 || !inp.closest) return;
    var f = inp.closest(PG_FORM + " .tee-field.ezp-pg");
    if (!f || !f._ezpHead) return;
    try { new DataTransfer(); } catch (err) { return; }   // browser without it (old Safari): Teeinblue takes the first photo as before
    e.stopImmediatePropagation();
    pbStart(f, Array.prototype.slice.call(inp.files));
  }, true);
  window.addEventListener("click", function (e) {
    if (pgTap(e, false)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  window.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var t = e.target;
    if (!t || !t.matches || !t.matches(".ezp-pg-tips, .ezp-pg-sheet [data-ezp-act], " + PG_FORM + " .tee-field.ezp-pg .tee-photo")) return;
    if (pgTap(e, true)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  /* Ban-116: ez-cart-drawer.js loads this file on pages without a product form (home, collections, /cart) when the
     customer opens "Edit design"; the popup's form may already be there, so everything is applied once on request. */
  window.ezpForms = function () {
    markImgRadios(); markStates(); decoratePhotos(); photoGrid(); decorateSelects(); refreshValidity();
    prepNameInputs(); properTitles(); decorateTitle();
  };
})();

/* 71. Ban-104 — (a) the title is cut to 2 lines by CSS (§71 in ez-personalize.css): tap it to read it all;
   (b) computer (>= 990 px): a bar fixed to the bottom with Preview + Add to Cart while the form's own Add to Cart is
   off screen. Built once; only a class changes. No layout is read on click or scroll: the cut check runs in a
   ResizeObserver, the bar follows an IntersectionObserver on the form's button. The bar's buttons press the form's own
   buttons (Teeinblue checks the fields, opens the preview, adds to the cart; §2 scrolls to a missing field). */
(function () {
  if (window.__ezpDbar) return;
  window.__ezpDbar = true;
  var D = document;
  var FORM = "#tee-artwork-form";
  var WIDE = window.matchMedia("(min-width: 990px)");
  /* Ban-105: owner 20/10 15:22 — no bar on computers for now ("I'll ask when I need it"). true = turn it back on. */
  var BAR_ON = false;

  /* (a) title */
  function titleEl() { return D.querySelector(".product__info-container .product__title > h1.ezp-title"); }
  function watchTitle() {
    var h = titleEl();
    if (!h || !window.ResizeObserver) return;
    if (!h.title) h.title = (h.textContent || "").trim();
    new ResizeObserver(function () {
      if (h.classList.contains("ezp-title--open")) return;
      h.classList.toggle("ezp-title--more", h.scrollHeight > h.clientHeight + 2);
    }).observe(h);
  }

  /* (b) bar */
  var bar = null, nameEl, priceEl, io = null, seen = null, offscreen = false;
  function money(sel) {
    var e = D.querySelector(FORM + " .tee-product-price " + sel);
    return e ? (e.textContent || "").replace(/\s+/g, " ").trim() : "";
  }
  function paintPrice() {
    if (!priceEl) return;
    var now = money(".tee-price--current"), was = money(".tee-price--compare");
    priceEl.textContent = now;
    if (was && was !== now) {
      var s = D.createElement("s");
      s.textContent = was;
      priceEl.appendChild(s);
    }
  }
  function build() {
    if (bar) return;
    var og = D.querySelector('meta[property="og:image"]');
    var src = og && og.content ? og.content.replace(/^http:/, "https:") : "";
    if (src) src += (src.indexOf("?") < 0 ? "?" : "&") + "width=120";
    bar = D.createElement("div");
    bar.className = "ezp-dbar";
    bar.setAttribute("aria-hidden", "true");
    bar.innerHTML =
      '<div class="ezp-dbar__in">' +
        (src ? '<img class="ezp-dbar__img" alt="" width="52" height="52" loading="lazy" src="' + src + '">' : "") +
        '<div class="ezp-dbar__t"><div class="ezp-dbar__n"></div><div class="ezp-dbar__p"></div></div>' +
        '<span class="ezp-dbar__b ezp-dbar__b--pv" role="button" tabindex="-1" data-ezp-dbar="pv">Preview</span>' +
        '<span class="ezp-dbar__b ezp-dbar__b--atc" role="button" tabindex="-1" data-ezp-dbar="atc">Add to Cart</span>' +
      "</div>";
    nameEl = bar.querySelector(".ezp-dbar__n");
    priceEl = bar.querySelector(".ezp-dbar__p");
    var h = titleEl();
    nameEl.textContent = h ? (h.textContent || "").trim() : "";
    D.body.appendChild(bar);
  }
  function show(on) {
    if (!bar) return;
    on = on && WIDE.matches;
    if (on) paintPrice();
    bar.classList.toggle("is-on", on);
    bar.setAttribute("aria-hidden", on ? "false" : "true");
    [].forEach.call(bar.querySelectorAll("[data-ezp-dbar]"), function (b) { b.tabIndex = on ? 0 : -1; });
    D.body.classList.toggle("ezp-dbar-on", on);
  }
  /* Teeinblue can redraw its buttons: watch whichever Add to Cart is in the form now (checked when the form changes) */
  function track() {
    var atc = D.querySelector(FORM + " .tee-btn--atc");
    if (!atc || atc === seen) return;
    if (!io) io = new IntersectionObserver(function (en) {
      offscreen = !en[en.length - 1].isIntersecting;
      show(offscreen);
    });
    if (seen) io.unobserve(seen);
    seen = atc;
    build();
    io.observe(atc);
  }
  function press(kind) {
    var b = D.querySelector(FORM + (kind === "atc" ? " .tee-btn--atc" : " .tee-btn--preview"));
    if (!b) return;
    var mine = bar && bar.querySelector('[data-ezp-dbar="' + kind + '"]');
    if (kind === "atc" && mine) {
      mine.classList.add("is-busy");
      setTimeout(function () { mine.classList.remove("is-busy"); }, 2500);
    }
    b.click();
  }
  window.addEventListener("click", function (e) {
    var t = e.target && e.target.closest && e.target.closest("[data-ezp-dbar], .product__info-container .product__title > h1.ezp-title");
    if (!t) return;
    if (t.hasAttribute("data-ezp-dbar")) {
      e.preventDefault(); e.stopImmediatePropagation();
      press(t.getAttribute("data-ezp-dbar"));
      return;
    }
    if (t.classList.contains("ezp-title--more") || t.classList.contains("ezp-title--open")) {
      var open = t.classList.toggle("ezp-title--open");
      if (open) t.classList.remove("ezp-title--more"); else t.classList.add("ezp-title--more");
    }
  }, true);
  window.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var t = e.target;
    if (!t || !t.matches || !t.matches("[data-ezp-dbar]")) return;
    e.preventDefault(); e.stopImmediatePropagation();
    press(t.getAttribute("data-ezp-dbar"));
  }, true);
  window.addEventListener("ez:variant-url", function () { setTimeout(function () { if (bar && bar.classList.contains("is-on")) paintPrice(); }, 200); });
  window.addEventListener("pageshow", function () {
    if (bar) [].forEach.call(bar.querySelectorAll(".is-busy"), function (b) { b.classList.remove("is-busy"); });
  });
  if (WIDE.addEventListener) WIDE.addEventListener("change", function () { show(offscreen); });

  /* Ban-105: Teeinblue builds #tee-artwork-form with JS after this runs (it is not in the page HTML),
     so watch the product info column (in the HTML), not the form. Ban-104 returned early and never built the bar. */
  function start() {
    watchTitle();
    if (!BAR_ON || !window.IntersectionObserver) return;
    var root = D.querySelector(".product__info-container") || D.querySelector(".product__info-wrapper") || D.body;
    track();
    var timer = 0;
    new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () { timer = 0; track(); }, 300);
    }).observe(root, { childList: true, subtree: true });
  }
  if (D.readyState === "loading") D.addEventListener("DOMContentLoaded", start); else start();
})();
